/*
 * Custom Side Cart (Phase 2 – Cart-Klon mit Feature-Paritaet)
 * Namespace: csc
 *
 * Runde 34 (Cutover, 2026-09-17): Preview-Gate entfernt - laeuft jetzt fuer ALLE Besucher aktiv
 * und ersetzt den bisherigen AMP-Cart-Drawer als sichtbaren Cart (siehe pre-cart-upsell.js
 * proceedToRealCart() fuer die Oeffnen-Weiche). AMP-App bleibt vorerst installiert, liefert aber
 * keinen sichtbaren Cart mehr (siehe custom-side-cart-projekt-scope.md).
 *
 * Portiert aus assets/custom-cart-logic.js + layout/theme.liquid (<!-- SLIDECART -->) fuer
 * Feature-Paritaet, jetzt aber nativ in der Render-Funktion statt als nachtraeglicher DOM-Patch:
 *   - properties.bundle_root + properties.bundle_attached_to (StarterSet-Sets, z.B. "Gesundes
 *     Altern Set") -> werden als EINE kombinierte Bundle-Karte gerendert (Bild/Titel vom
 *     Root-Item, Gratis-Beigaben als Unterliste, EIN Preis, nur "Loeschen" (ganze Gruppe) +
 *     "Bearbeiten" (zurueck zur PDP) - keine Mengen-Stepper. Grund (2026-09-15 von Christian
 *     gemeldet, per Live-Test bestaetigt): das alte Verhalten (Gratis-Beigaben mit eigenem
 *     Mengen-Stepper, "StarterSet" explizit von der Sperr-Logik ausgenommen) erlaubte, sich
 *     durch Hochklicken der Gratis-Beigaben-Menge beliebig viele kostenlose Nachfuellpackungen
 *     zu sichern. assets/product-form-starter-kit.js (PDP-Add-to-Cart) verwendet fuer ALLE
 *     Starter-Kits denselben hartcodierten String "StarterSet" ohne jede Instanz-Kennung -
 *     zwei separate Klicks auf "In den Warenkorb" fuer dasselbe Set fuehren serverseitig zu
 *     EINER zusammengefuehrten Cart-Zeile (Shopify-Standardverhalten bei identischen
 *     Properties), nicht zu zwei sichtbar getrennten Bundle-Karten. Um das zu aendern, braeuchte
 *     es eine eindeutige Instanz-ID pro Add-to-Cart-Klick in product-form-starter-kit.js - das
 *     wuerde aber sitewide auch den LIVE-AMP-Cart betreffen (custom-cart-logic.js hat dafuer
 *     aktuell einen expliziten Sonderfall nur fuer den exakten String "StarterSet") und ist
 *     bewusst NICHT Teil dieser Aenderung; siehe Ruecksprache mit Christian.
 *     window.bundleItems/window.bundleItemsAdditional (main-product-starter-kit.liquid) sind
 *     laut Code-Recherche unbenutzter Legacy-Code, nicht die tatsaechliche Datenquelle.
 *   - properties._bundle (Kennenlern-Set/Duo Gratis-Beigabe) -> Anzeige als "GRATIS", Menge/
 *     Entfernen bleiben bewusst normal bedienbar (entspricht 1:1 der bisherigen Logik und ist
 *     hier unproblematisch: ein echter Shopify-Auto-Discount begrenzt die Gratis-Menge auf die
 *     entitled quantity, zusaetzliche Menge wird automatisch uebrpreist statt gratis, siehe
 *     computeFlags weiter unten).
 *   - properties.*free-gift-sale* (Free-Gift-Sale-Feature) -> Anzeige als "GRATIS".
 *   - legacyLockProductIds (aus layout/theme.liquid "plansIdsOffers") -> sperrt alle ANDEREN
 *     Items, wenn eines dieser 3 (vermutlich veralteten, UNLISTED) Produkte im Cart liegt.
 */
(function () {
  'use strict';

  // 2026-10-23 Multi-Currency (SE/DK): Shopify rechnet EUR-Schwellen (Versand-Rate-Bedingungen,
  // Rabattcode-Mindestwerte) mit dem Markt-Kurs (Shopify.currency.rate) in Landeswaehrung um.
  // Cart-Summen kommen in Landeswaehrung (Minor Units) -> Schwellen hier ebenso umrechnen.
  // DE/NL (EUR, Rate 1) unveraendert.
  var IG_CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var IG_RATE = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var IG_IS_EUR = IG_CUR === 'EUR';
  // 2026-10-27 Versand je Lieferland (Theme-Einstellung "Versand pro Land", ausgegeben von
  // snippets/ig-market-config als window.igMarketShip): z. B. CH gratis ab CHF 80 (fester Betrag in CHF,
  // nicht 49 EUR x Kurs), Lieferzeit CH 2-6 / AT 1-4 Werktage. Ohne Eintrag: bisherige Logik (49 EUR x Kurs, 1-3 Tage).
  var IG_SHIP = (window.igMarketShip && window.igMarketShip.free > 0) ? window.igMarketShip : null;
  function igFreeShipCents() { return IG_SHIP ? IG_SHIP.free : igEur(4900); }
  var IG_SHIP_CUSTOM = !!(IG_SHIP && !(IG_IS_EUR && IG_SHIP.free === 4900));
  function igEur(c) { return IG_IS_EUR ? c : Math.ceil(c * IG_RATE - 1e-6); }

  var LEGACY_LOCK_PRODUCT_IDS = [7258548797613, 7189735833773, 7258549452973];

  // Refill-Bundle-Builder (5er/7er/14er Set, /products/refill-bundle-builder, assets/bundle-
  // builder.js): jedes ausgewaehlte Produkt traegt properties.bundle = "5SET"/"7SET"/"14SET" plus
  // (seit 2026-09-16, Christian-Wunsch) properties._bundle_instance = eine pro Add-to-Cart-Klick
  // eindeutige ID, damit zwei separat gebaute Sets gleicher Groesse nicht zu einer Karte
  // verschmelzen (siehe buildRefillSetGroups() weiter unten). Aeltere/bereits im Cart liegende
  // Zeilen ohne _bundle_instance gruppieren weiterhin nur ueber den Code (Fallback, siehe dort).
  // 2026-10-24 (Christian): neue Prozent-Set-Codes 5ER-SET/7ER-SET/14ER-SET (10/20/25 %, Produktrabatt auf
  // Bio-Microgreens, Abo + Einzelkauf). Alte Festbetrags-Codes bleiben fuer bestehende Carts erkannt.
  // Reihenfolge = Rang (hoeherer Index gewinnt in refillSetCodeForCart).
  var REFILL_SET_CODES = ['5SET', '7SET', '14SET', '5ER-SET', '7ER-SET', '14ER-SET'];
  var REFILL_SET_SIZE = { '5SET': 5, '7SET': 7, '14SET': 14, '5ER-SET': 5, '7ER-SET': 7, '14ER-SET': 14 };

  // Cache fuer /products/{handle}.js Aufrufe (Compare-at-Preis-Lookup), damit derselbe
  // Produkt-Handle nicht bei jedem Render erneut angefragt wird.
  var productCache = {};

  // Cache fuer die volle PDP-HTML (nur bei StarterSet-Bundles gebraucht, siehe
  // getStarterSetSubscriptionData weiter unten).
  var subscriptionDataCache = {};

  // Bekannte Farboptionen der Starter-Kit-Geraete (option1/variant_title, z.B. "WEISS OZEANPLASTIK")
  // -> kurzer Anzeigename fuer die Bundle-Karten-Unterliste (z.B. "ingarden Weiß"). Manuelle
  // Zuordnung statt automatischer Gross-/Kleinschreibung, weil "WEISS" -> "Weiß" (ß) sich nicht
  // durch simples .toLowerCase() herleiten laesst.
  var DEVICE_COLOR_NAMES = {
    WEISS: 'Weiß',
    BLAU: 'Blau',
    VULKANSCHWARZ: 'Vulkanschwarz',
    SANDSTEIN: 'Sandstein',
    SALBEIGRÜN: 'Salbeigrün',
  };

  function deviceColorLabel(variantTitle) {
    if (!variantTitle) return '';
    var firstWord = variantTitle.split(' ')[0];
    if (DEVICE_COLOR_NAMES[firstWord]) return DEVICE_COLOR_NAMES[firstWord];
    // Fallback fuer unbekannte/neue Farboptionen: einfache Gross-/Kleinschreibung.
    return firstWord.charAt(0) + firstWord.slice(1).toLowerCase();
  }

  // 2026-09-24 (Christian-Feedback: "Sets sollen den Namen des SETS zeigen, nicht des
  // Pad-Refill-Bundles"): wandelt den Pad-Bundle-Rohtitel ("<Linie> Pads – <N>-Tage-Vorrat[ Duo]",
  // z.B. "Gesundes Altern Pads – 90-Tage-Vorrat" bzw. "Bestseller Mix Pads – 30-Tage-Vorrat Duo")
  // in den Namen des GESAMTEN Sets um ("<Linie> [Duo] Starter-Set <N>-Tage", z.B. "Gesundes Altern
  // Starter-Set 90-Tage" / "Bestseller Mix Duo Starter-Set 30-Tage"). Ersetzt die fruehere
  // padBundleLabel()-Funktion (2026-09-21), die auf ein AELTERES Rohtitel-Schema
  // ("<Linie> <N>-Tage-Vorrat ingarden") zielte - die Pad-Bundle-Produkte wurden seither auf das
  // aktuelle "<Linie> Pads – <N>-Tage-Vorrat[ Duo]"-Schema umbenannt, wodurch die alte Regex nicht
  // mehr griff und den (fuer Kunden verwirrenden) Pad-Rohtitel unveraendert durchreichte - genau
  // das sah Christian sowohl als Kartentitel als auch in Zeile 2 der Unterliste. Faellt weiterhin
  // auf den unveraenderten Rohtitel zurueck, wenn das Muster nicht passt (rueckwaerts-kompatibel
  // fuer andere/zukuenftige Bundle-Produkttitel, die diesem Schema nicht folgen).
  // 2026-10-20 (Christian: Wording in Monaten): erkennt "<Linie> Pads – <N>-Tage-Vorrat[ Duo]" (alt) UND
  // "<Linie> Pads – <N>-Monats-Vorrat[ Duo]" (neu) und gibt den Set-Namen in Monaten aus, z. B.
  // "Gesundes Altern Starter-Set · 3 Monate". 30/90/365 Tage -> 1/3/12 Monate.
  function bundleSetLabel(productTitle) {
    if (!productTitle) return productTitle;
    var m = productTitle.match(/^(.*?)\s+Pads\s*[–-]\s*(\d+)-(Tage|Monats)-Vorrat(\s+Duo)?$/i);
    if (!m) return productTitle;
    var line = m[1];
    var n = parseInt(m[2], 10);
    var months = null;
    if (/^monats$/i.test(m[3])) {
      months = n;
    } else if (n === 365) {
      months = 12;
    } else if (n % 30 === 0) {
      months = n / 30;
    }
    var duoSuffix = m[4] ? ' Duo' : '';
    var dur = months !== null ? (months + (months === 1 ? ' Monat' : ' Monate')) : (n + ' Tage');
    return line + duoSuffix + ' Starter-Set \u00b7 ' + dur;
  }

  function init() {
    var root = document.getElementById('csc-drawer-v2');
    if (!root) return;

    var itemsEl = root.querySelector('#csc-cart-items');
    var itemsCountEl = root.querySelector('#csc-items-count');
    var checkoutLinkEl = root.querySelector('#csc-checkout-link');
    var countEl = root.querySelector('.csc-cart-count');
    var discountsEl = root.querySelector('#csc-discounts');
    var savingsBannerEl = root.querySelector('#csc-savings-banner');
    var savingsAmountEl = root.querySelector('#csc-savings-amount');
    var summaryBreakdownEl = root.querySelector('#csc-summary-breakdown');
    var summarySubtotalEl = root.querySelector('#csc-summary-subtotal');
    var summarySavingsRowEl = root.querySelector('#csc-summary-savings-row');
    var summarySavingsEl = root.querySelector('#csc-summary-savings');
    var summaryTotalEl = root.querySelector('#csc-summary-total');
    var discountToggle = root.querySelector('#csc-discount-toggle');
    var discountToggleLabelEl = root.querySelector('#csc-discount-toggle-label');
    var discountForm = root.querySelector('#csc-discount-form');
    var discountInput = root.querySelector('#csc-discount-input');
    var discountApplyBtn = root.querySelector('#csc-discount-apply');
    var shippingLineEl = root.querySelector('#csc-shipping-line');
    // Runde 42: erstes <span> der Trust-Zeile ("45 Tage Rueckgaberecht") - kein Liquid-Change noetig.
    var trustReturnsEl = root.querySelector('#csc-trust-returns') || root.querySelector('.csc-trust-line span');
    var progressEl = root.querySelector('#csc-progress');
    // 2026-10-23 R6 (Christian): Upsells (grown, Bestseller, Minis, Zubehoer) UNTER den Artikeln -
    // nach dem ATC soll zuerst das eigene Produkt sichtbar sein. Bar + Geschenk-Karte bleiben oben.
    var upsellEl = root.querySelector('#csc-upsell-below');
    if (!upsellEl) {
      upsellEl = document.createElement('div');
      upsellEl.id = 'csc-upsell-below';
      upsellEl.hidden = true;
      var itemsHost = root.querySelector('#csc-cart-items');
      if (itemsHost && itemsHost.parentNode) itemsHost.parentNode.insertBefore(upsellEl, itemsHost.nextSibling);
    }
    (function () {
      if (document.getElementById('csc-r6-style')) return;
      var st = document.createElement('style');
      st.id = 'csc-r6-style';
      st.textContent =
        '#csc-drawer-v2 #csc-upsell-below{margin:4px 0 14px}' +
        '#csc-drawer-v2 #csc-upsell-below .csc-minis:first-child{margin-top:4px}' +
        '#csc-drawer-v2 #csc-upsell-below .csc-gwn{margin:8px 0 4px}' +
        '@media (max-width: 749px){' +
          '#csc-drawer-v2.csc-drawer .csc-drawer__footer{padding:12px 16px calc(12px + env(safe-area-inset-bottom))}' +
          '#csc-drawer-v2.csc-drawer .csc-savings-banner{padding-top:6px;padding-bottom:6px;margin-bottom:6px}' +
          '#csc-drawer-v2.csc-drawer .csc-shipping-line{margin-bottom:6px}' +
          '#csc-drawer-v2.csc-drawer .csc-discounts{margin-bottom:4px}' +
          '#csc-drawer-v2.csc-drawer .csc-discount-toggle{padding-top:4px;padding-bottom:8px;font-size:12px}' +
          '#csc-drawer-v2.csc-drawer .csc-discount-form{margin-bottom:8px}' +
          '#csc-drawer-v2.csc-drawer .csc-trust-line{margin-top:6px}' +
        '}' +
        '@media all{' +
          '#csc-drawer-v2.csc-drawer .csc-discount-toggle{justify-content:flex-start;gap:4px;width:auto;padding-top:2px;padding-bottom:8px;font-size:12px;font-weight:500;color:#595959;text-decoration:underline;text-underline-offset:2px}' +
          '#csc-drawer-v2.csc-drawer .csc-discount-toggle__chev{display:none}' +
        '}';
      document.head.appendChild(st);
    })();

    // ---- R7 (23.10., "letztes 1 %"): Feedback, Tippflaechen, Leer-Zustand ----------------------
    (function () {
      if (document.getElementById('csc-r7-style')) return;
      var st = document.createElement('style');
      st.id = 'csc-r7-style';
      st.textContent =
        // Tippflaechen >= 44 px ohne Layout-Aenderung (unsichtbar vergroesserte Klickflaeche)
        '#csc-drawer-v2 .csc-mini-card__add::after{content:"";position:absolute;inset:-12px}' +
        '#csc-drawer-v2 .csc-qty-btn,#csc-drawer-v2 .csc-bundle-icon-btn,#csc-drawer-v2 .csc-gwn__chip,#csc-drawer-v2 .csc-gwn__add,#csc-drawer-v2 .csc-drawer__close{position:relative}' +
        '#csc-drawer-v2 .csc-qty-btn::after{content:"";position:absolute;inset:-9px}' +
        '#csc-drawer-v2 .csc-bundle-icon-btn::after{content:"";position:absolute;inset:-7px}' +
        '#csc-drawer-v2 .csc-gwn__chip::after{content:"";position:absolute;inset:-11px -3px}' +
        '#csc-drawer-v2 .csc-gwn__add::after{content:"";position:absolute;inset:-6px}' +
        '#csc-drawer-v2 .csc-drawer__close::after{content:"";position:absolute;inset:-8px -11px}' +
        '#csc-drawer-v2 .csc-mini-card{cursor:pointer}' +
        '#csc-drawer-v2 .csc-trust-line--3{font-size:11px;justify-content:center;gap:0;white-space:nowrap;letter-spacing:-0.1px}' +
        '#csc-drawer-v2 .csc-trust-line--3 .csc-trust-line__sep{padding:0 5px}' +
        '@media (max-width: 370px){#csc-drawer-v2 .csc-trust-line--3{white-space:normal;flex-wrap:wrap;row-gap:2px}}' +
        '#csc-drawer-v2 .csc-bundle-actions .csc-item__qty{margin-left:8px}' +
        '#csc-drawer-v2 .csc-bundle-actions{align-items:center}' +
        // R9: Sortenzeile der Upsell-Karten darf 2-zeilig umbrechen (mobil wurde die 3. Sorte abgeschnitten)
        '#csc-drawer-v2 .csc-mini-card__variety{white-space:normal !important;text-overflow:clip !important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.3}' +
        // Sofort-Feedback
        '#csc-drawer-v2 .csc-mini-card__add.is-added,#csc-drawer-v2 .csc-gwn__add.is-added{background:#1B9500 !important;color:#fff !important}' +
        '#csc-drawer-v2 .csc-progress__line-fill{transition:width .6s ease}' +
        '#csc-drawer-v2 .csc-progress__marker{transition:left .6s ease}' +
        '@keyframes csc-flash{0%{box-shadow:0 0 0 2px #8048ED;background:#F3EEFF}100%{box-shadow:0 0 0 0 rgba(128,72,237,0)}}' +
        '#csc-drawer-v2 .csc-flash{animation:csc-flash 1.8s ease-out}' +
        '#csc-drawer-v2 .csc-toast{position:absolute;left:16px;right:16px;top:80px;z-index:15;padding:10px 14px;border-radius:12px;background:#2F2E2C;color:#fff;font-size:13px;font-weight:600;line-height:1.35;box-shadow:0 8px 24px rgba(0,0,0,.18);white-space:pre-line;opacity:0;transform:translateY(-8px);transition:opacity .25s,transform .25s;pointer-events:none}' +
        '#csc-drawer-v2 .csc-toast.is-shown{opacity:1;transform:none}' +
        // Skeleton beim Oeffnen
        '@keyframes csc-shimmer{0%{opacity:.55}50%{opacity:1}100%{opacity:.55}}' +
        '#csc-drawer-v2 .csc-skel{height:96px;border-radius:12px;background:#fff;margin:0 0 10px;animation:csc-shimmer 1.2s infinite}' +
        '#csc-drawer-v2 .csc-skel--short{height:64px}' +
        // Leerer Warenkorb
        '#csc-drawer-v2 .csc-empty-state{padding:8px 0 16px;text-align:center;color:#2F2E2C}' +
        '#csc-drawer-v2 .csc-empty-state__title{font-size:16px;font-weight:700;margin:4px 0 2px}' +
        '#csc-drawer-v2 .csc-empty-state__sub{font-size:13px;color:#595959;margin:0 0 14px}' +
        '#csc-drawer-v2 .csc-empty-state__grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;text-align:left}' +
        '#csc-drawer-v2 .csc-empty-card{display:block;background:#fff;border-radius:12px;overflow:hidden;color:#2F2E2C;text-decoration:none;border:1px solid #F2F2F2}' +
        '#csc-drawer-v2 .csc-empty-card img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;background:#FAF8F4}' +
        '#csc-drawer-v2 .csc-empty-card__body{padding:8px 10px 10px}' +
        '#csc-drawer-v2 .csc-empty-card__title{font-size:12.5px;font-weight:700;line-height:1.3;margin-bottom:4px}' +
        '#csc-drawer-v2 .csc-empty-card__cta{font-size:12px;font-weight:700;color:#8048ED}';
      document.head.appendChild(st);
    })();
    // R8: Funnel-Events (dataLayer fuer GTM + Shopify Customer Events). Fehler werden ignoriert.
    function cscTrack(name, data) {
      var payload = Object.assign({ event: name }, data || {});
      try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) {}
    }
    var lastCartCtx = { segment: 'unknown', subtotal: 0, items: 0 };
    var pendingToast = null;
    var pendingFlashVariants = [];
    var prevProgressGeom = null;
    function queueFeedback(text, variantIds) {
      if (text) pendingToast = pendingToast ? pendingToast + '\n' + text : text;
      (variantIds || []).forEach(function (v) { if (v) pendingFlashVariants.push(Number(v)); });
    }
    function showCartToast(text) {
      var panel = root.querySelector('.csc-drawer__panel');
      if (!panel || !text) return;
      if (window.getComputedStyle(panel).position === 'static') panel.style.position = 'relative';
      var t = panel.querySelector('.csc-toast');
      if (!t) { t = document.createElement('div'); t.className = 'csc-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); panel.appendChild(t); }
      t.textContent = text;
      void t.offsetHeight;
      t.classList.add('is-shown');
      clearTimeout(t._h);
      t._h = setTimeout(function () { t.classList.remove('is-shown'); }, 2800);
    }
    function markAdded(btn, label) {
      if (!btn) return;
      btn.classList.add('is-added');
      btn.textContent = label || '✓';
    }
    function applyPendingFeedback(cart) {
      if (pendingFlashVariants.length) {
        cart.items.forEach(function (it) {
          if (pendingFlashVariants.indexOf(it.variant_id) === -1) return;
          var el = itemsEl.querySelector('.csc-item[data-key="' + it.key + '"]');
          if (el) { el.classList.remove('csc-flash'); void el.offsetWidth; el.classList.add('csc-flash'); }
        });
        pendingFlashVariants = [];
      }
      if (pendingToast) { showCartToast(pendingToast); pendingToast = null; }
    }
    // Balken animiert vom alten auf den neuen Stand (statt zu springen)
    function animateProgress() {
      var fill = progressEl.querySelector('.csc-progress__line-fill');
      var marker = progressEl.querySelector('.csc-progress__marker');
      var next = { w: fill ? fill.style.width : null, l: marker ? marker.style.left : null };
      if (prevProgressGeom && fill && prevProgressGeom.w && prevProgressGeom.w !== next.w) {
        fill.style.transition = 'none'; fill.style.width = prevProgressGeom.w;
        if (marker && prevProgressGeom.l) { marker.style.transition = 'none'; marker.style.left = prevProgressGeom.l; }
        void fill.offsetWidth;
        fill.style.transition = ''; fill.style.width = next.w;
        if (marker && next.l) { marker.style.transition = ''; marker.style.left = next.l; }
      }
      prevProgressGeom = next;
    }
    var EMPTY_STATE_HANDLES = ['ingarden-alle-bestseller-sorten', 'bestseller-mix-set-duo'];
    async function emptyStateMarkup() {
      var en = igIsEn();
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var prods = await Promise.all(EMPTY_STATE_HANDLES.map(getProductByHandle));
      var cards = prods.map(function (pr, i) {
        if (!pr) return '';
        var img = pr.featured_image || '';
        return '<a class="csc-empty-card" href="' + base + 'products/' + EMPTY_STATE_HANDLES[i] + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '<div class="csc-empty-card__body"><div class="csc-empty-card__title">' + pr.title + '</div>' +
          '<div class="csc-empty-card__cta">' + (en ? 'Discover →' : 'Ansehen →') + '</div></div></a>';
      }).join('');
      return '<div class="csc-empty-state">' +
        '<div class="csc-empty-state__title">' + (en ? 'Your cart is empty' : 'Dein Warenkorb ist leer') + '</div>' +
        '<div class="csc-empty-state__sub">' + (en ? 'Start with our bestseller:' : 'Starte mit unserem Bestseller:') + '</div>' +
        (cards ? '<div class="csc-empty-state__grid">' + cards + '</div>' : '') +
        '</div>';
    }

    // Gratis-Versand-Schwelle (Cent) - unter dieser Summe wird die Lieferzeilen-Info bewusst
    // ausgeblendet statt z.B. Versandkosten anzuzeigen (Christian-Wunsch 2026-09-16: unter der
    // Schwelle soll das perspektivisch in eine Progress-Bar wandern, Phase 3, noch offen).
    var FREE_SHIPPING_THRESHOLD = igFreeShipCents();

    // ---- Lieferzeit-Berechnung (2026-09-16, snocks-Referenz) -------------------------------
    // Christian-Vorgabe: konkretes Datum statt "heute + 1-3 Tage", wie bei snocks ("Do 17.9. -
    // Sa 19.9."). Sonntags wird nicht zugestellt, deshalb zaehlt Sonntag nicht als Liefertag und
    // wird beim Hochzaehlen uebersprungen (addDeliveryDays). Ausnahme: Duo ist erst ab Ende
    // September verfuegbar - dafuer kein Datumsbereich, sondern ein fixer Hinweistext.
    var GERMAN_WEEKDAYS_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

    function addDeliveryDays(date, days) {
      var d = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) added++; // Sonntag (0) zaehlt nicht mit, wird uebersprungen
      }
      return d;
    }

    function formatDeliveryDate(d) {
      return GERMAN_WEEKDAYS_SHORT[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
    }

    function isDuoCart(cart) {
      return cart.items.some(function (item) {
        var handle = (item.handle || '').toLowerCase();
        var title = (item.product_title || '').toLowerCase();
        return handle.indexOf('duo') !== -1 || title.indexOf('duo') !== -1;
      });
    }

    // Runde 42 (2026-10-05, Christian): Duo ist jetzt auf Lager -> der fruehere Fixtext
    // "Lieferung ca. Ende September" fuer Duo-Carts entfaellt, Duo nutzt dieselbe Datumslogik wie
    // Single (heute +1 bis +3 Liefertage, Sonntag uebersprungen).
    // Runde 42 (2026-10-05, Christian): Duo-Carts zeigen 100 Tage Rueckgaberecht, alle anderen 45.
    // 2026-10-16 (Christian-Klarstellung): 100 Tage gelten NUR fuer Abos ab 90 Tagen (Flexplan
    // 90-Tage- und 12-Monats-Abo), unabhaengig von Single/Duo. Alles andere (inkl. Zweitgeraet-Aktion,
    // Einzelkauf, 30-Tage-Abo, Refills) = 45 Tage.
    function returnPeriodText(cart) {
      var longPlan = cart.items.some(function (item) {
        var spa = item.selling_plan_allocation;
        var name = spa && spa.selling_plan && spa.selling_plan.name || '';
        // 2026-10-20: auch neue Plan-Namen in Monaten ("3-Monats-Abo", "12-Monats-Abo").
        // 2026-10-22: EN-Shop (NL/SE/DK) liefert uebersetzte Plan-Namen ("Flexible 90-Day Subscription ...").
        return /(90-Tage|3-Monats|12-Monats|90-Day|3-Month|12-Month)/i.test(name);
      });
      return (longPlan ? '100' : '45') + ' Tage R\u00fcckgaberecht';
    }

    function deliveryEstimateText(cart) {
      var today = new Date();
      var start = addDeliveryDays(today, (IG_SHIP && IG_SHIP.dmin) || 1);
      var end = addDeliveryDays(today, (IG_SHIP && IG_SHIP.dmax) || 3);
      return 'Lieferung ca. ' + formatDeliveryDate(start) + ' - ' + formatDeliveryDate(end);
    }

    // ---- Progress-Bar (Phase 3, 2026-09-16) ------------------------------------------------
    // Segmentierung rein ueber Warenkorb-Inhalt (von Christian entschieden, kein Customer-/
    // Login-Check): liegt ein StarterSet (bundle_root) im Cart -> Neukunden-Bar (150€/200€
    // Gratis-Beigaben, siehe custom-side-cart-projekt-scope.md, bereits vor dieser Session
    // bestaetigt). Sonst -> Returning-Bar (49€ Gratis-Versand / 70€ 10% / 100€ 15%, Betraege +
    // Rabatt-% von Christian am 2026-09-16 bestaetigt, auf Basis einer Returning-AOV-Analyse).
    //
    // Runde 12 (2026-09-16, Christian-Go "ja bitte"): die zwei Neukunden-Geschenke haengen an
    // echten Shopify-Automatic-BXGY-Discounts (100% auf das jeweilige Produkt, analog zum
    // bestehenden Kennenlern-Set-Mechanismus - Details siehe custom-side-cart-phase2-cart-klon.md,
    // Runde 12), die machen ein bereits im Cart liegendes Geschenkprodukt gratis, legen es aber
    // NICHT von selbst hinein. Tier 1 war urspruenglich Beauty-Mix Probierpackung, aber die war
    // oversold (available: -5 bei Hive Fulfillment Center) - auf Christian-Wunsch (2026-09-16)
    // durch Energiegruen-Mix Probierpackung ersetzt (gesunder Bestand: available 1236). Wichtig:
    // zwei automatische BXGY-Discounts stapeln sich bei Shopify NICHT gegenseitig, selbst mit
    // combinesWith=true auf allen Klassen (empirisch verifiziert, Runde 12) - deshalb bewusst nur
    // EIN Geschenk gleichzeitig im Cart fuehren: bei >=200€ gilt nur noch die Ernteschere, nicht
    // zusaetzlich Energiegruen-Mix (Christian-Entscheidung).
    //
    // Runde 13 (2026-09-16, Christian-Referenz: waterdrop-Cart-Screenshot): erster Ansatz war ein
    // vollautomatisches Hinzufuegen ohne jeden Klick - Christian fand das zu unauffaellig ("man
    // merkt gar nicht, dass man was geschenkt bekommt"). Stattdessen jetzt eine eigene "🎁 Gratis
    // Goodies"-Karte (progressGiftsMarkup weiter unten) im ingarden-Look (Design-System-Farben,
    // kein 1:1-Copy des waterdrop-Designs): verriegelt (🔒) bis die Stufe erreicht ist, danach ein
    // Lila-"+"-Button zum bewussten Beanspruchen. Da unsere zwei Geschenke (anders als bei
    // waterdrop) je nur EINE Variante haben, gibt es keinen Auswahl-Screen - der Klick fuegt direkt
    // hinzu. syncProgressGifts() unten uebernimmt nur noch zwei Automatismen, NICHT das Erstclaimen:
    // (1) entfernt ein bereits beanspruchtes Geschenk wieder, wenn die Stufe durch Entfernen anderer
    // Artikel unterschritten wird (sonst wuerde der Kunde ploetzlich den vollen Preis dafuer
    // zahlen), (2) tauscht ein bereits beanspruchtes Geschenk automatisch gegen die naechsthoehere
    // Stufe, sobald die erreicht ist (fuehlt sich wie ein Bonus-Upgrade an, kein erneuter Klick
    // noetig - verhindert auch, dass beide Geschenke gleichzeitig im Cart landen wuerden, siehe
    // BXGY-Stapel-Limitierung oben).
    // Die Returning-Bar-Rabatte sind bereits laenger scharf geschaltet: STAMMKUNDE15 (15%, ab 100€)
    // und STAMMKUNDE10 (10%, ab 70€) existieren beide als echte Shopify-Rabattcodes (beide gelten
    // inkl. Abo-Positionen).
    //
    // 2026-09-16 (Runde 14): Die Neukunden-Geschenke (Energiegruen-Mix/Ernteschere) liefen zunaechst
    // ueber automatische Buy-X-Get-Y-Rabatte. Live-Test durch Christian zeigte: sobald ein
    // Kennenlern-Set (das selbst einen automatischen BXGY-Rabatt "Bio-Antioxidant Mix gratis"
    // traegt) im selben Cart liegt, wird das Geschenk NICHT gratis (bleibt bei vollem Preis),
    // obwohl der Subtotal-Schwellenwert erreicht ist. Ursache: Shopify erlaubt strukturell nur
    // EINEN automatischen BXGY-Rabatt pro Bestellung - unabhaengig von combinesWith. Das
    // Kennenlern-Set-Geschenk (selbst BXGY) blockiert dadurch jedes weitere BXGY im selben Cart.
    // Fix: Die Progress-Bar-Geschenk-Rabatte wurden von BXGY auf echte Rabattcodes ("Betrag-Rabatt
    // auf bestimmtes Produkt", 100% auf die jeweilige Geschenk-Variante, combinesWith ueberall true)
    // umgestellt und werden - wie STAMMKUNDE10/15 - programmatisch per /cart/update.js discount-Feld
    // angewendet (siehe syncProgressDiscount unten). Als Rabattcode statt BXGY zaehlen sie nicht mehr
    // in die "nur ein BXGY pro Order"-Beschraenkung hinein und kombinieren sich sauber mit dem
    // Kennenlern-Set-BXGY (dessen combinesWith.productDiscounts bereits true ist). Die alten
    // BXGY-Automatics (Energiegruen-Mix ab 150€ / Ernteschere ab 200€) wurden in Shopify Admin
    // deaktiviert (nicht geloescht), nicht ersetzt.
    // Runde 28 (Christian-Wunsch): dritte Zwischenstufe bei 170€ (Bio-Mystery Superfood Pack)
    // eingefuegt, Energiegruen-Mix-Schwelle von 150€ auf 130€ gesenkt - PBGIFT150 dafuer in Shopify
    // umbenannt zu PBGIFT130 (Ziel-Variante/Betrag unveraendert), PBGIFT170 ist ein neuer Code
    // (100% auf Bio-Mystery Superfood Pack "1 Packung", Produkt-Handle bio-mystery-pack).
    // PBGIFT200/Ernteschere unveraendert.
    var PROGRESS_MANAGED_CODES = ['STAMMKUNDE10', 'STAMMKUNDE15', 'PBGIFT130', 'PBGIFT170', 'PBGIFT200'];

    // 2026-10-16 Zweitgeraet-Aktion (Bestandskunden-Secret-Page /pages/zweitgeraet-bestandskunden,
    // sections/zweitgeraet-offer.liquid): Die Seite legt das Geraet mit properties._Zweitgeraet-Aktion
    // = Rabatt in Cent (z.B. "5100") in den Cart und setzt den Code ZWEITGERAET bzw. ZWEITGERAET-DUO.
    // Die Codes gelten nur fuer das Kundensegment "mind. 1 Bestellung" - im Cart kennt Shopify die
    // Kundin meist noch nicht, deshalb steht der Code dort als "nicht anwendbar" und wird erst im
    // Checkout (E-Mail) gueltig. Im Cart deshalb: (1) Rabattzeile als "Treuepreis ... im Checkout"
    // statt "(nicht anwendbar)", (2) keine STAMMKUNDE10/15-Codes setzen (nicht kombinierbar - sonst
    // koennte im Checkout der kleinere Rabatt gewinnen), (3) Returning-Progress-Bar durch einen
    // Treuepreis-Hinweis ersetzen. Minis/Zubehoer-Upsells bleiben sichtbar.
    var ZGO_PROPERTY = '_Zweitgeraet-Aktion';
    // 2026-10-16 v2: statt Segment-Codes persoenliche Einmal-Codes aus Klaviyo (Praefix ZG-), die schon
    // im Cart gelten. Erkennung der Rabattzeile per Regex /^(ZG-|ZWEITGERAET)/i (siehe discountsMarkup).
    function isZgoCart(cart) {
      return cart.items.some(function (item) { return !!(item.properties || {})[ZGO_PROPERTY]; });
    }
    function zgoDiscountCents(cart) {
      var max = 0;
      cart.items.forEach(function (item) {
        var v = parseInt((item.properties || {})[ZGO_PROPERTY], 10) || 0;
        if (v > max) max = v;
      });
      return max;
    }

    // Property, mit der eine vom Kunden bewusst beanspruchte (Klick auf "+" in der Goodie-Karte)
    // ODER vom System hochgestufte Neukunden-Geschenk-Zeile markiert wird - so kann
    // syncProgressGifts()/progressGiftsMarkup() sie gezielt wiederfinden/entfernen, ohne eine
    // eventuell zusaetzlich vom Kunden selbst gekaufte Menge desselben Produkts anzutasten
    // (Energiegruen-Mix/Ernteschere sind auch ganz normal einzeln kaeuflich).
    var PROGRESS_GIFT_PROPERTY = '_progress_gift';

    // Runde 24 (Christian-Wunsch, "Bestseller Sorten" als zweiter Neukunden-Cart-Upsell neben den
    // Minis): analog zu PROGRESS_MANAGED_CODES, aber unabhaengig davon - zwei einfache Cart-Rabatt-
    // codes (kein Schwellenwert, kein Geschenk), die aktiv sind, sobald die jeweilige Sorten-Gruppe
    // im (Neukunden-)Cart liegt, siehe syncBestsellerDiscount() unten.
    var BESTSELLER_MANAGED_CODES = ['BESTSELLER_PURE', 'BESTSELLER_MIX'];
    var BESTSELLER_PURE_VARIANT_IDS = [50388664451413, 50388219658581]; // Brokkoli, Rucola ("1 Packung")
    var BESTSELLER_MIX_VARIANT_IDS = [50388291748181, 50388269039957]; // Superfood-Mix, Radieschen Mix ("1 Packung")

    // Markiert eine ueber die Bestseller-Sorten-Karte hinzugefuegte Zeile (analog zu
    // PROGRESS_GIFT_PROPERTY) - dient hier NICHT der Wiederauffindbarkeit fuer Entfernen/Sync
    // (der Cart-Rabatt greift variantenbasiert, unabhaengig von der Property), sondern ausschliesslich
    // dazu, den bestehenden Abo-Upsell-Hinweis (getRefillUpsellInfo/csc-bundle-upsell) fuer diese
    // Zeile zu unterdruecken (Christian: "Abo eher nicht, zu komplizierte Kaufentscheidung - nur
    // Einzelkauf mit Discount"), siehe itemUpsellInfo-Aufbau in render() weiter unten.
    var BESTSELLER_UPSELL_PROPERTY = '_bestseller_upsell';

    // 2026-10-20 (Christian): Wer den 12-Monatsplan kauft (Abo oder Einzelkauf, Single oder Duo),
    // bekommt keine Progress-Bar und kein Gratis-Mystery-Pack - der Cart liegt ohnehin ueber jeder
    // Schwelle, die Bar steuert dort nichts mehr. Erkennung ueber den Pad-Handle (bleibt bei
    // Umbenennungen stabil) bzw. den Plan-/Produktnamen. Upsell-Rail (Minis/Bestseller) bleibt.
    function isAnnualCart(cart) {
      return cart.items.some(function (item) {
        var handle = (item.handle || '').toLowerCase();
        var title = (item.product_title || '').toLowerCase();
        var plan = ((item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) || '').toLowerCase();
        return /365-tage-vorrat|12-monats-vorrat/.test(handle) || /365-tage-vorrat|12-monats-vorrat/.test(title) || /12-monats|12-month/.test(plan);
      }) || isMultiSetCart(cart);
    }

    // 2026-10-28 (Christian, BF): Starter-Set mit 2/3 ingarden - wie 12M keine Progress-Bar und kein
    // Gratis-Mystery-Pack (Cart liegt immer ueber der Schwelle). Upsell nur grown D3 + Minis.
    var MULTI_SET_HANDLES = ['ernte-duett-starter-set', 'ernte-duett-starter-set-copy', 'starter-set-mit-3-ingarden', 'starter-set-mit-3-ingarden-mit-abonnement'];
    function isMultiSetCart(cart) {
      return cart.items.some(function (item) {
        return MULTI_SET_HANDLES.indexOf((item.handle || '').toLowerCase()) !== -1;
      });
    }

    function isNeukundeCart(cart) {
      // Neukunde = irgendein Starter-Set-artiges Produkt im Cart. Zaehlt sowohl echte StarterSet-
      // Bundle-Karten (properties.bundle_root, z.B. "Gesundes Altern Set") als auch Kennenlern-Set/
      // Duo-Kaeufe (properties._bundle auf der Gratis-Beigaben-Zeile, siehe Datei-Header-Kommentar)
      // - von Christian am 2026-09-16 klargestellt: Kennenlern-Set gehoert zu den Starter-Sets.
      //
      // Ergaenzung (Runde 36, 2026-09-18, Bugfix Order DE64844): properties.baseVariant zaehlt
      // ebenfalls als Neukunden-Signal (gesetzt von assets/funnel.js auf der /pages/funnel
      // Kennenlern-Landingpage beim Plan-Wechsel - dient dort nur der Farbauswahl-Wiederherstellung,
      // hat sonst nichts mit bundle_root/_bundle zu tun, wird aber theme-weit sonst nirgends
      // gesetzt). Ohne dieses Signal wurden Neukunden ueber diesen Funnel-Weg faelschlich als
      // "Returning" eingestuft und bekamen STAMMKUNDE15 statt der Neukunden-Vorteile.
      return cart.items.some(function (item) {
        var props = item.properties || {};
        return !!props.bundle_root || !!props._bundle || !!props.baseVariant;
      });
    }

    // 2026-10-23 (Christian): Neukunden-Cart unterscheidet Abo- und Einmalkauf-Starter-Sets.
    // Abo-Carts (Flexplan 1/3/12M oder "Mit Abonnement"-Sets) haben ihre Pads schon im Abo -
    // dort keine Bestseller-Refills mehr in der Upsell-Leiste (Overstock), sondern grown + Minis.
    function isAboStarterCart(cart) {
      return cart.items.some(function (item) {
        var props = item.properties || {};
        return (!!props.bundle_root || !!props.bundle_attached_to || !!props._bundle) && !!item.selling_plan_allocation;
      });
    }

    // ---- ingarden grown als Neukunden-Cart-Upsell (2026-10-23, Christian) ----------------------
    // Einmalkauf, 1 Beutel (2-Monatsvorrat), D3 vorausgewaehlt + Umschalter B-Komplex, goldener
    // Messloeffel gratis dazu (syncGrownGift erkennt die Zeile ueber GROWN_UPSELL_PROPERTY). Kein
    // Abo-Hinweis auf der Zeile (eigener 2-Monats-Takt wuerde sich vom Pad-Abo entkoppeln).
    var GROWN_UPSELL_PROPERTY = '_grown_upsell';
    // 2026-10-23 R5: grown-Karte nur im deutschsprachigen DE/AT-Shop.
    // 2026-10-29 (Christian): grown-Upsell in allen Maerkten (CH, NL, SE, DK, ...). Preise kommen in
    // Landeswaehrung aus /products/{handle}.js, Texte DE oder EN je Shop-Sprache (GWN_T).
    function grownUpsellAllowed() { return true; }
    function igIsEn() { return /^en/i.test(document.documentElement.lang || ''); }
    var GWN_T = igIsEn() ? {
      isNew: 'New', title: 'Vitamins grown in sprouts', twoMonths: '2-month supply', add: 'Add', info: 'What is grown?',
      giftAlt: 'Golden measuring spoon', gift: '<strong>Gift: golden measuring spoon</strong> for the exact daily serving', free: 'free',
      toast: '✓ grown added · 🥄 measuring spoon free', addName: function (n) { return 'Add ' + n; }, close: 'Close',
      sheetTitle: 'What is ingarden grown?', more: 'More on the product page',
      sheetBody: '<p>Instead of making vitamins in a lab and pressing them into capsules, we let them grow: organic buckwheat sprouts in a vitamin-rich nutrient bath and stores the vitamins in its cells. It is then gently dried and finely ground.</p>' +
        '<ul>' +
        '<li>🌱 <strong>Just 1 ingredient:</strong> sprouted organic buckwheat. Vegan, gluten-free, no capsule shell, fillers or flavourings.</li>' +
        '<li>🥄 <strong>1 measuring spoon (1.5 g) a day</strong>, ideally with a meal: in muesli, yoghurt, a smoothie or water.</li>' +
        '<li>☀️ <strong>D3 version:</strong> 25 µg vitamin D3 (1,000 IU) plus all 8 B vitamins. <strong>B complex:</strong> all 8 B vitamins.</li>' +
        '<li>📦 <strong>1 pouch (90 g) lasts 60 days</strong> and ships in the same parcel as your starter set. The golden measuring spoon is included for free.</li>' +
        '</ul>' +
        '<p class="csc-gwn-sheet__fine">Vitamin D contributes to the normal function of the immune system. Vitamin B12 contributes to normal energy-yielding metabolism. Patent pending.</p>'
    } : {
      isNew: 'Neu', title: 'Vitamine aus Keimlingen', twoMonths: '2-Monatsvorrat', add: 'Hinzufügen', info: 'Was ist grown?',
      giftAlt: 'Goldener Messlöffel', gift: '<strong>Geschenk: goldener Messlöffel</strong> für die genaue Tagesportion', free: 'gratis',
      toast: '✓ grown hinzugefügt · 🥄 Messlöffel gratis dabei', addName: function (n) { return n + ' hinzufügen'; }, close: 'Schließen',
      sheetTitle: 'Was ist ingarden grown?', more: 'Mehr auf der Produktseite',
      sheetBody: '<p>Statt Vitamine im Labor herzustellen und in Kapseln zu pressen, lassen wir sie wachsen: Bio-Buchweizen keimt in einem vitaminreichen Nährstoffbad und lagert die Vitamine in seine Zellen ein. Danach wird er schonend getrocknet und fein vermahlen.</p>' +
        '<ul>' +
        '<li>🌱 <strong>Nur 1 Zutat:</strong> gekeimter Bio-Buchweizen. Vegan, glutenfrei, ohne Kapselhülle, Füllstoffe oder Aromen.</li>' +
        '<li>🥄 <strong>1 Messlöffel (1,5 g) täglich</strong>, am besten zu einer Mahlzeit: in Müsli, Joghurt, Smoothie oder Wasser.</li>' +
        '<li>☀️ <strong>D3-Variante:</strong> 25 µg Vitamin D3 (1.000 I.E.) plus alle 8 B-Vitamine. <strong>B-Komplex:</strong> alle 8 B-Vitamine.</li>' +
        '<li>📦 <strong>1 Beutel (90 g) reicht 60 Tage</strong> und kommt im selben Paket wie dein Starter-Set. Der goldene Messlöffel ist gratis dabei.</li>' +
        '</ul>' +
        '<p class="csc-gwn-sheet__fine">Vitamin D trägt zu einer normalen Funktion des Immunsystems bei. Vitamin B12 trägt zu einem normalen Energiestoffwechsel bei. Das Herstellungsverfahren ist zum Patent angemeldet.</p>'
    };
    var GROWN_UPSELL_PRODUCTS = {
      d3: {
        handle: 'ingarden-grown-vitamin-d3', variantId: 55275291705685, chip: igIsEn() ? 'D3 + B complex' : 'D3 + B-Komplex', name: 'Vitamin D3',
        image: 'https://cdn.shopify.com/s/files/1/0617/0466/7309/files/grown-d3-beutel-loeffel-freigestellt.webp?width=240',
        bullets: igIsEn() ? [
          '<strong>Vitamin D3 + all 8 B vitamins</strong>, grown in organic buckwheat sprouts',
          '1 measuring spoon a day in muesli, yoghurt or a smoothie',
        ] : [
          '<strong>Vitamin D3 + alle 8 B-Vitamine</strong>, gewachsen in Bio-Buchweizenkeimlingen',
          '1 Messlöffel täglich in Müsli, Joghurt oder Smoothie',
        ],
      },
      b: {
        handle: 'ingarden-grown-vitamin-b-komplex', variantId: 55275287478613, chip: igIsEn() ? 'B complex' : 'B-Komplex', name: igIsEn() ? 'Vitamin B complex' : 'Vitamin B-Komplex',
        image: 'https://cdn.shopify.com/s/files/1/0617/0466/7309/files/grown-b-beutel-loeffel-freigestellt.webp?width=240',
        bullets: igIsEn() ? [
          '<strong>All 8 B vitamins</strong>, grown in organic buckwheat sprouts',
          '1 measuring spoon a day in muesli, yoghurt or a smoothie',
        ] : [
          '<strong>Alle 8 B-Vitamine</strong>, gewachsen in Bio-Buchweizenkeimlingen',
          '1 Messlöffel täglich in Müsli, Joghurt oder Smoothie',
        ],
      },
    };
    var grownPick = 'd3';
    (function () {
      if (document.getElementById('csc-gwn-style')) return;
      var st = document.createElement('style');
      st.id = 'csc-gwn-style';
      st.textContent =
        '#csc-drawer-v2 .csc-gwn{margin:4px 0 14px;padding:12px;border:1.5px solid #8048ED;border-radius:12px;background:#fff;color:#2F2E2C}' +
        '#csc-drawer-v2 .csc-gwn__kicker{display:flex;align-items:center;gap:6px;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#595959;margin-bottom:8px}' +
        '#csc-drawer-v2 .csc-gwn__new{background:#8048ED;color:#fff;border-radius:4px;padding:2px 6px;font-size:10px}' +
        '#csc-drawer-v2 .csc-gwn__row{display:flex;gap:12px;align-items:flex-start}' +
        '#csc-drawer-v2 .csc-gwn__img{position:relative;flex:0 0 84px;height:108px;border-radius:10px;overflow:hidden;background:#FAF8F4;padding:6px 4px 4px;box-sizing:border-box}' +
        '#csc-drawer-v2 .csc-gwn__img .csc-gwn__pane.is-active{height:100%}' +
        '#csc-drawer-v2 .csc-gwn__img img{width:100%;height:100%;object-fit:contain;object-position:center bottom;display:block}' +
        '#csc-drawer-v2 .csc-gwn__img-badge{position:absolute;left:4px;right:4px;bottom:4px;padding:2px 0;border-radius:6px;background:#E4FFC2;color:#2F2E2C;font-size:9.5px;font-weight:700;text-align:center;line-height:1.2}' +
        '#csc-drawer-v2 .csc-gwn__gift{display:flex;align-items:center;gap:10px;margin-top:10px;padding:8px 10px;border-radius:10px;background:#E4FFC2;font-size:12px;line-height:1.35;color:#2F2E2C}' +
        '#csc-drawer-v2 .csc-gwn__gift img{flex:0 0 34px;width:34px;height:34px;object-fit:contain;border-radius:6px;background:#fff}' +
        '#csc-drawer-v2 .csc-gwn__gift strong{font-weight:700}' +
        '#csc-drawer-v2 .csc-gwn__gift s{color:#595959;margin-left:2px}' +
        '#csc-drawer-v2 .csc-gwn__body{flex:1;min-width:0}' +
        '#csc-drawer-v2 .csc-gwn__title{font-size:15px;font-weight:700;line-height:1.25;margin-bottom:6px}' +
        '#csc-drawer-v2 .csc-gwn__chips{display:flex;gap:5px;margin-bottom:8px;flex-wrap:wrap}' +
        '#csc-drawer-v2 .csc-gwn__chip{font:inherit;font-size:10.5px;font-weight:600;padding:4px 8px;white-space:nowrap;border-radius:999px;border:1px solid #D9D6D1;background:#fff;color:#2F2E2C;cursor:pointer}' +
        '#csc-drawer-v2 .csc-gwn__chip.is-active{border-color:#8048ED;background:#F3EEFF;color:#8048ED}' +
        '#csc-drawer-v2 .csc-gwn__bullets{list-style:none;margin:0;padding:0;font-size:12px;line-height:1.4}' +
        '#csc-drawer-v2 .csc-gwn__bullets li{position:relative;padding-left:16px;margin-bottom:3px}' +
        '#csc-drawer-v2 .csc-gwn__bullets li:before{content:"✓";position:absolute;left:0;color:#8048ED;font-weight:700}' +
        '#csc-drawer-v2 .csc-gwn__pane{display:none}#csc-drawer-v2 .csc-gwn__pane.is-active{display:block}' +
        '#csc-drawer-v2 .csc-gwn__foot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px;padding-top:10px;border-top:1px solid #F2F2F2}' +
        '#csc-drawer-v2 .csc-gwn__price{font-size:15px;font-weight:700;line-height:1.2}' +
        '#csc-drawer-v2 .csc-gwn__price small{display:block;font-size:11px;font-weight:500;color:#595959}' +
        '#csc-drawer-v2 .csc-gwn__price .csc-gwn__worth{margin-right:4px;font-size:12px;font-weight:500;color:#595959}' +
        '#csc-drawer-v2 .csc-gwn__price .csc-gwn__save{color:#1B9500;font-weight:700}' +
        '#csc-drawer-v2 .csc-gwn__price small s{color:#595959}' +
        '#csc-drawer-v2 .csc-gwn__add{font:inherit;font-size:13px;font-weight:700;padding:9px 14px;border:0;border-radius:999px;background:#8048ED;color:#fff;cursor:pointer;white-space:nowrap}' +
        '#csc-drawer-v2 .csc-gwn__add:disabled{opacity:.6;cursor:default}' +
        '#csc-drawer-v2 .csc-gwn__info{display:inline-block;margin-top:8px;padding:0;border:0;background:none;font:inherit;font-size:12px;font-weight:600;color:#8048ED;text-decoration:underline;cursor:pointer}' +
        '#csc-drawer-v2 .csc-gwn-sheet{position:absolute;inset:0;z-index:20;display:flex;flex-direction:column;justify-content:flex-end;visibility:hidden}' +
        '#csc-drawer-v2 .csc-gwn-sheet.is-open{visibility:visible}' +
        '#csc-drawer-v2 .csc-gwn-sheet__overlay{display:block !important;position:absolute;inset:0;background:rgba(47,46,44,.45);opacity:0;transition:opacity .25s}' +
        '#csc-drawer-v2 .csc-gwn-sheet.is-open .csc-gwn-sheet__overlay{opacity:1}' +
        '#csc-drawer-v2 .csc-gwn-sheet__box{position:relative;max-height:85%;overflow:auto;background:#fff;border-radius:16px 16px 0 0;padding:20px 18px 18px;color:#2F2E2C;transform:translateY(100%);transition:transform .3s ease}' +
        '#csc-drawer-v2 .csc-gwn-sheet.is-open .csc-gwn-sheet__box{transform:none}' +
        '#csc-drawer-v2 .csc-gwn-sheet__close{position:absolute;top:10px;right:12px;border:0;background:none;font-size:24px;line-height:1;cursor:pointer;color:#2F2E2C}' +
        '#csc-drawer-v2 .csc-gwn-sheet h3{font-size:18px;margin:0 28px 8px 0;line-height:1.25}' +
        '#csc-drawer-v2 .csc-gwn-sheet p{font-size:13px;line-height:1.5;margin:0 0 12px}' +
        '#csc-drawer-v2 .csc-gwn-sheet ul{list-style:none;margin:0 0 12px;padding:0;font-size:13px;line-height:1.45}' +
        '#csc-drawer-v2 .csc-gwn-sheet li{margin-bottom:6px;padding:8px 10px;background:#FAF8F4;border-radius:8px}' +
        '#csc-drawer-v2 .csc-gwn-sheet__fine{font-size:11px !important;color:#595959}' +
        '#csc-drawer-v2 .csc-gwn-sheet__cta{display:block;width:100%;font:inherit;font-size:14px;font-weight:700;padding:12px;border:0;border-radius:999px;background:#8048ED;color:#fff;cursor:pointer}' +
        '#csc-drawer-v2 .csc-gwn-sheet__link{display:block;text-align:center;margin-top:10px;font-size:12px;color:#595959;text-decoration:underline}';
      document.head.appendChild(st);
    })();
    function grownUpsellMarkup(products, spoonValueCents, spoonProduct) {
      var panes = '';
      var chips = '';
      var imgs = '';
      var anyAvailable = false;
      ['d3', 'b'].forEach(function (key) {
        var cfg = GROWN_UPSELL_PRODUCTS[key];
        var product = products[key];
        var variant = product && (product.variants || []).find(function (v) { return v.id === cfg.variantId; });
        if (!variant || variant.available === false) return;
        anyAvailable = true;
        var active = key === grownPick ? ' is-active' : '';
        chips += '<button type="button" class="csc-gwn__chip' + active + '" data-action="grown-pick" data-pick="' + key + '">' + cfg.chip + '</button>';
        imgs += '<div class="csc-gwn__pane' + active + '" data-pane="' + key + '">' + ((cfg.image || product.featured_image) ? '<img src="' + (cfg.image || product.featured_image) + '" alt="ingarden grown ' + cfg.name + '" loading="lazy">' : '') + '</div>';
        panes += '<div class="csc-gwn__pane' + active + '" data-pane="' + key + '" data-variant-id="' + variant.id + '" data-price="' + variant.price + '">' +
          '<ul class="csc-gwn__bullets">' + cfg.bullets.map(function (b) { return '<li>' + b + '</li>'; }).join('') + '</ul></div>';
      });
      if (!anyAvailable) return '';
      if (!products[grownPick]) grownPick = products.d3 ? 'd3' : 'b';
      var priceCents = parseInt(((products[grownPick] || products.d3 || products.b).variants || [])[0].price, 10);
      return (
        '<div class="csc-gwn" data-gwn>' +
        '<div class="csc-gwn__kicker"><span class="csc-gwn__new">' + GWN_T.isNew + '</span>ingarden grown</div>' +
        '<div class="csc-gwn__row">' +
        '<div class="csc-gwn__img">' + imgs + '</div>' +
        '<div class="csc-gwn__body">' +
        '<div class="csc-gwn__title">' + GWN_T.title + '</div>' +
        '<div class="csc-gwn__chips">' + chips + '</div>' +
        panes +
        '</div></div>' +
        // 2026-10-23 (Christian-Feedback): Gratis-Loeffel deutlicher hervorheben
        '<div class="csc-gwn__gift">' +
        (spoonProduct && spoonProduct.featured_image ? '<img src="' + spoonProduct.featured_image + '" alt="' + GWN_T.giftAlt + '" loading="lazy">' : '<span>🎁</span>') +
        '<span>' + GWN_T.gift + (spoonValueCents ? ' <s>' + money(spoonValueCents) + '</s> <strong>' + GWN_T.free + '</strong>' : ' – ' + GWN_T.free) + '</span>' +
        '</div>' +
        '<div class="csc-gwn__foot">' +
        // 2026-10-23 (Christian): Ersparnis durch Gratis-Loeffel zeigen - bewusst KEIN Streichpreis (wuerde
        // als fruehere Preissenkung gelesen), sondern "Gesamtwert" + "Du sparst".
        // 2026-10-23 R4 (Christian, Platz im Cart): doch Streichpreis = Beutel + Loeffelwert, eine Zeile.
        '<div class="csc-gwn__price">' +
        (spoonValueCents ? '<s class="csc-gwn__worth">' + money(priceCents + spoonValueCents) + '</s> ' : '') + money(priceCents) +
        '<small>' + GWN_T.twoMonths + '</small></div>' +
        '<button type="button" class="csc-gwn__add" data-action="add-grown">' + GWN_T.add + '</button>' +
        '</div>' +
        '<button type="button" class="csc-gwn__info" data-action="grown-info">' + GWN_T.info + '</button>' +
        '</div>'
      );
    }
    function grownSheetEl() {
      var panel = root.querySelector('.csc-drawer__panel');
      if (!panel) return null;
      var el = panel.querySelector('.csc-gwn-sheet');
      if (el) return el;
      if (window.getComputedStyle(panel).position === 'static') panel.style.position = 'relative';
      el = document.createElement('div');
      el.className = 'csc-gwn-sheet';
      el.innerHTML =
        '<div class="csc-gwn-sheet__overlay" data-gwn-close></div>' +
        '<div class="csc-gwn-sheet__box" role="dialog" aria-label="' + GWN_T.sheetTitle + '">' +
        '<button type="button" class="csc-gwn-sheet__close" data-gwn-close aria-label="' + GWN_T.close + '">&times;</button>' +
        '<h3>' + GWN_T.sheetTitle + '</h3>' +
        GWN_T.sheetBody +
        '<button type="button" class="csc-gwn-sheet__cta" data-gwn-add>' + GWN_T.add + '</button>' +
        '<a class="csc-gwn-sheet__link" data-gwn-link href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/ingarden-grown-vitamin-d3">' + GWN_T.more + '</a>' +
        '</div>';
      panel.appendChild(el);
      el.addEventListener('click', async function (e) {
        if (e.target.closest('[data-gwn-close]')) { el.classList.remove('is-open'); return; }
        var addBtn = e.target.closest('[data-gwn-add]');
        if (addBtn) {
          addBtn.disabled = true;
          await addGrownUpsell(GROWN_UPSELL_PRODUCTS[grownPick].variantId, 'sheet');
          addBtn.disabled = false;
          el.classList.remove('is-open');
        }
      });
      return el;
    }
    function openGrownSheet() {
      var el = grownSheetEl();
      if (!el) return;
      var cfg = GROWN_UPSELL_PRODUCTS[grownPick];
      var cta = el.querySelector('[data-gwn-add]');
      var pane = root.querySelector('.csc-gwn__body .csc-gwn__pane.is-active');
      var price = pane ? parseInt(pane.getAttribute('data-price'), 10) : 0;
      if (cta) cta.textContent = GWN_T.addName(cfg.name) + (price ? ' · ' + moneyPlain(price) : '');
      var link = el.querySelector('[data-gwn-link]');
      if (link) link.setAttribute('href', ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + cfg.handle);
      void el.offsetHeight;
      el.classList.add('is-open');
    }
    async function addGrownUpsell(variantId, source) {
      cscTrack('csc_upsell_add', Object.assign({ upsell_type: 'grown', variant_id: variantId, source: source || 'cart' }, lastCartCtx));
      queueFeedback(GWN_T.toast, [variantId, GROWN_GIFT_VARIANT_ID]);
      var gp = {};
      gp[GROWN_UPSELL_PROPERTY] = source || 'cart';
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: gp }] }),
      });
      await render();
    }

    // ---- Upgrade 1-Monats- -> 3-Monats-Vorrat im Cart (2026-10-23, Christian) ------------------
    // Nur Flexplan-Abo 30 Tage (kein 12M). Daten (90T-Pad-Produkt + Selling Plan + 90T-Hardware)
    // stammen aus dem starter-set-subscription-data-Blob der Verkaufsseite (_pdp_url) - dieselbe
    // Quelle, aus der die PDP selbst in den Cart legt. Die passende Instanz wird ueber das 30T-Pad-
    // Produkt (duplicate_product.product_id) gewaehlt (Homepage hat 2 Instanzen Single+Duo).
    var flexDataCache = {};
    var flexUpgradeByKey = {};
    function isFlex30Root(root) {
      var spa = root.selling_plan_allocation;
      var name = (spa && spa.selling_plan && spa.selling_plan.name) || '';
      return /(30-Tage|1-Monats|30-Day|1-Month)/i.test(name) || (/30-tage-vorrat/.test(root.handle || '') && !!spa);
    }
    async function getFlexplanDataFor(root) {
      var url = ((root.properties || {})._pdp_url) || '';
      if (!url || url.charAt(0) !== '/') return null;
      if (!(url in flexDataCache)) {
        flexDataCache[url] = (async function () {
          try {
            var res = await fetch(url);
            if (!res.ok) return [];
            var html = await res.text();
            var out = [];
            var re = /<script[^>]*id=["']starter-set-subscription-data[^"']*["'][^>]*>([\s\S]*?)<\/script>/g;
            var m;
            while ((m = re.exec(html))) { try { out.push(JSON.parse(m[1])); } catch (e) {} }
            return out;
          } catch (e) { return []; }
        })();
      }
      var list = await flexDataCache[url];
      return (list || []).find(function (d) {
        return d && d.duplicate_product && d.duplicate_product.product_id === root.product_id;
      }) || null;
    }
    // R5: Ergebnis pro 30T-Pad-Produkt in sessionStorage merken -> ab dem 2. Cart-Oeffnen kein
    // PDP-HTML-Fetch (100-150 KB) mehr. Fehler beim Storage-Zugriff werden ignoriert.
    async function getFlexplanDataCached(root) {
      var key = 'csc_flex_' + root.product_id;
      try {
        var raw = sessionStorage.getItem(key);
        if (raw) return JSON.parse(raw);
      } catch (e) {}
      var d = await getFlexplanDataFor(root);
      if (!d || !d.additional_variant || !d.additional_bundle_hardware) return null;
      var slim = {
        additional_variant: {
          selling_plan_id: d.additional_variant.selling_plan_id,
          selling_plan_price: d.additional_variant.selling_plan_price,
          duration_days: d.additional_variant.duration_days,
          variants: (d.additional_variant.variants || []).map(function (v) { return { id: v.id, available: v.available }; }),
        },
        additional_bundle_hardware: {
          variants: (d.additional_bundle_hardware.variants || []).map(function (v) { return { id: v.id, option1: v.option1, title: v.title, price: v.price, available: v.available }; }),
        },
      };
      try { sessionStorage.setItem(key, JSON.stringify(slim)); } catch (e) {}
      return slim;
    }
    async function getFlexUpgradeInfo(group, priceSums) {
      var root = group.root;
      var hw = group.attached[0];
      if (!root || !hw || !isFlex30Root(root)) return null;
      var data = await getFlexplanDataCached(root);
      if (!data || !data.additional_variant || !data.additional_variant.selling_plan_id || !data.additional_bundle_hardware) return null;
      var add = data.additional_variant;
      var padVariant = (add.variants || []).find(function (v) { return v.available !== false; }) || null;
      if (!padVariant) return null;
      var color = ((hw.variant_options && hw.variant_options[0]) || hw.variant_title || '').toUpperCase();
      var hwVariant = (data.additional_bundle_hardware.variants || []).find(function (v) {
        return (v.option1 || v.title || '').toUpperCase() === color;
      });
      if (!hwVariant || hwVariant.available === false) return null;
      var padNew = parseInt(add.selling_plan_price, 10) || 0;
      var newTotal = padNew * root.quantity + parseInt(hwVariant.price, 10) * hw.quantity;
      var delta = newTotal - priceSums.totalNow;
      if (!padNew || delta <= 0) return null;
      var spa = root.selling_plan_allocation;
      var monthNow = spa ? spa.price : 0;
      var monthNew = Math.round(padNew * 30 / (add.duration_days || 90));
      return {
        keys: [root.key].concat(group.attached.map(function (a) { return a.key; })),
        padVariantId: padVariant.id,
        sellingPlanId: add.selling_plan_id,
        hwVariantId: hwVariant.id,
        rootQty: root.quantity,
        hwQty: hw.quantity,
        rootProps: root.properties || {},
        hwProps: hw.properties || {},
        delta: delta,
        monthlySaving: monthNow > monthNew ? monthNow - monthNew : 0,
      };
    }
    async function applyFlexUpgrade(info) {
      // R5 (Risiko-Minimierung): zuerst die 90T-Zeilen hinzufuegen, erst bei Erfolg die 30T-Zeilen
      // entfernen - schlaegt der Add fehl (z.B. Farbe ausverkauft), bleibt das Set unveraendert.
      // Neue _bundle_instance, damit die neuen Zeilen nie mit den alten zusammenfallen (Zeilen-Keys).
      var newInst = (info.rootProps._bundle_instance || 'up') + 'u3';
      var rootProps = Object.assign({}, info.rootProps, { _bundle_additional_option: 'true', _plan_upgrade: '1to3', _bundle_instance: newInst });
      var hwProps = Object.assign({}, info.hwProps, { _bundle_instance: newInst });
      var res;
      try {
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: info.padVariantId, quantity: info.rootQty, selling_plan: info.sellingPlanId, properties: rootProps },
            { id: info.hwVariantId, quantity: info.hwQty, properties: hwProps },
          ] }),
        });
      } catch (e) { return false; }
      if (!res || !res.ok) return false;
      var rm = {};
      info.keys.forEach(function (k) { rm[k] = 0; });
      await updateCart(JSON.stringify({ updates: rm }));
      return true;
    }
    function flexUpgradeButtonHtml(rootKey, flexUpgrade) {
      var en = igIsEn();
      var flexPerks = [];
      if (flexUpgrade.monthlySaving >= 50) flexPerks.push(moneyPlain(flexUpgrade.monthlySaving) + (en ? ' cheaper per month' : ' pro Monat günstiger'));
      flexPerks.push(en ? '100 instead of 45 days returns' : '100 statt 45 Tage Rückgaberecht');
      return '<button type="button" class="csc-grown-upgrade" data-action="flex-upgrade" data-key="' + rootKey + '">' +
        '<span class="csc-grown-upgrade__main">' + (en ? '⬆ Upgrade to 3-month supply' : '⬆ Upgrade auf 3-Monats-Vorrat') + '</span>' +
        '<span class="csc-grown-upgrade__meta">+' + money(flexUpgrade.delta) + ' · <strong>' + flexPerks.join(' · ') + '</strong></span>' +
        '</button>';
    }

    // 2026-10-21 ingarden grown (Vitaminpulver, Beutel): kein Refill-/Pad-Kontext. Reiner Grown-Cart
    // (nur Grown + Gratis-Loeffel) -> keine Progress-Bar, keine STAMMKUNDE-Codes, keine Minis/Zubehoer.
    // Gratis-Messloeffel = eigenes 0-EUR-Produkt "Goldener Messloeffel (Geschenk)", wird von
    // syncGrownGift() automatisch genau 1x dazugelegt, solange Grown im Cart ist, sonst entfernt.
    var GROWN_GIFT_VARIANT_ID = 55461921620309;
    var GROWN_GIFT_PROPERTY = '_grown_gift';
    var GROWN_GIFT_VALUE_CENTS = IG_IS_EUR ? 999 : 0; // Wert des regulaeren Dosierloeffels (Streichpreis im Cart); Nicht-EUR: echter Preis wird in render() aus dosierloeffel-ingarden.js gesetzt
    // Christian 21.10.: Gratis-Loeffel NUR mit Grown-Abo (Erstbestellung, Folgelieferungen ohne).
    // Einmalkauf: kein Gratis-Loeffel (Wiederkaeufer haben schon einen, Gaeste sind vor dem Checkout
    // nicht erkennbar) - stattdessen optionaler Upsell des regulaeren Dosierloeffels im Cart.
    var GROWN_SPOON_HANDLE = 'dosierloeffel-ingarden';
    var GROWN_SPOON_VARIANT_ID = 55134944035157;
    function isGrownItem(item) {
      return /^ingarden-grown-/.test((item.handle || '').toLowerCase());
    }
    function isGrownGiftItem(item) {
      return item.variant_id === GROWN_GIFT_VARIANT_ID;
    }
    function isGrownOnlyCart(cart) {
      return cart.items.some(isGrownItem) && cart.items.every(function (item) {
        return isGrownItem(item) || isGrownGiftItem(item) || item.variant_id === GROWN_SPOON_VARIANT_ID;
      });
    }
    function isGrownSubItem(item) {
      return isGrownItem(item) && !!item.selling_plan_allocation;
    }
    // Upsell-Karte "Messloeffel" fuer reine Grown-Einmalkauf-Carts ohne Loeffel (Optik = Minis-Rail)
    function grownSpoonUpsellMarkup(product) {
      if (!product) return '';
      var variant = (product.variants || []).find(function (v) { return v.id === GROWN_SPOON_VARIANT_ID; }) || (product.variants || [])[0];
      if (!variant || variant.available === false) return '';
      var imgSrc = product.featured_image || '';
      return (
        '<div class="csc-minis">' +
        '<div class="csc-minis-heading">🥄 Noch keinen Messlöffel?</div>' +
        '<div class="csc-minis-sub">Für die genaue Tagesportion von 1,5 g. Im Abo ist er gratis dabei.</div>' +
        '<div class="csc-minis-grid-wrap"><div class="csc-minis-grid">' +
        '<div class="csc-mini-card">' +
        '<div class="csc-mini-card__image">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="Goldener Messlöffel" loading="lazy">' : '') +
        '<button type="button" class="csc-mini-card__add" data-action="add-accessory" data-variant-id="' + variant.id + '" aria-label="Messlöffel hinzufuegen">+</button>' +
        '</div>' +
        '<div class="csc-mini-card__body">' +
        '<div class="csc-mini-card__title">Goldener Messlöffel</div>' +
        '<div class="csc-mini-card__variety">genau 1,5 g</div>' +
        '<div class="csc-mini-card__price-row"><span class="csc-mini-card__price">' + money(variant.price) + '</span></div>' +
        '</div></div>' +
        '</div></div>' +
        '</div>'
      );
    }
    async function syncGrownGift(cart) {
      // 2026-10-23: Gratis-Loeffel auch beim grown-Upsell im Neukunden-Cart (Einmalkauf, Christian).
      var hasGrown = cart.items.some(function (item) {
        return isGrownSubItem(item) || (isGrownItem(item) && !!(item.properties || {})[GROWN_UPSELL_PROPERTY]);
      });
      var giftLines = cart.items.filter(isGrownGiftItem);
      if (hasGrown && giftLines.length === 1 && giftLines[0].quantity === 1) return false;
      if (!hasGrown && !giftLines.length) return false;
      if (giftLines.length) {
        var toRemove = {};
        giftLines.forEach(function (item) { toRemove[item.key] = 0; });
        await updateCart(JSON.stringify({ updates: toRemove }));
      }
      if (hasGrown) {
        var gp = {};
        gp[GROWN_GIFT_PROPERTY] = '1';
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: GROWN_GIFT_VARIANT_ID, quantity: 1, properties: gp }] }),
        });
      }
      return true;
    }

    // Meilenstein-Definitionen je Segment. "label"/"sub" sind die kurzen Zwei-Zeiler unter jedem
    // Punkt im Stepper (z.B. "10% Rabatt" / "Ab 70€"), "headlineLabel" ist der laengere Text fuer
    // die dynamische CTA-Zeile oben ("Noch X€ bis <headlineLabel>") - wie bei der wearewild-
    // Referenz (2026-09-16, Christian-Wunsch): immer alle Meilensteine sichtbar + klare CTA darueber.
    //
    // Runde 38 (2026-09-23, Christian-Wunsch, Starter-Sets ueberarbeitet): Neukunden-Leiter von 3
    // Stufen (130€/170€/200€, Energiegruen-Mix/Bio-Mystery-Pack/Ernteschere) auf EINE Stufe
    // vereinfacht - "Mystery Pack" (= das bisherige Bio-Mystery Superfood Pack, Handle
    // bio-mystery-pack, unveraendert per PBGIFT170-Code gratis geschaltet, siehe syncProgressDiscount
    // unten). Schwelle haengt jetzt vom Geraetetyp im Cart ab (isDuoCart(), bereits bestehende
    // Funktion, siehe deliveryEstimateText oben): Single-Sets 160€, Duo-Sets 210€ (Christian-Vorgabe).
    // PBGIFT130 (Energiegruen-Mix)/PBGIFT200 (Ernteschere) werden dadurch nicht mehr automatisch
    // vergeben - Codes bleiben in Shopify bestehen (nicht geloescht), bleiben aber ab jetzt ungenutzt.
    // Nicht-EUR: Label aus umgerechneter Schwelle, auf ganze Landeswaehrung aufgerundet
    // (z.B. 548,80 kr -> "From 549 kr"); EN-Shop direkt englisch (ig-en-client kennt nur "Ab 49€").
    function igFromLabel(eurCents, deLabel) {
      if (IG_IS_EUR) return deLabel;
      var whole = Math.ceil(igEur(eurCents) / 100) * 100;
      var txt = moneyPlain(whole).replace(/[.,]00(?!\d)/, '');
      return (/^en/i.test(document.documentElement.lang || '') ? 'From ' : 'Ab ') + txt;
    }
    // 2026-10-23 (Christian, Analyse Neukunden-Cart): Schwelle von 160/210 auf 185/225 angehoben -
    // 3M-Single (159,99) lag nur 1 Cent unter 160 und bekam das Geschenk quasi gratis. Neu: 3M-Abo +
    // 1 Beutel grown (29,90) knackt die Schwelle knapp (189,89 / 229,89).
    function progressTiers(isNeukunde, isDuo) {
      return isNeukunde
        ? [
            isDuo
              ? { amount: igEur(22500), label: 'Mystery Pack', sub: igFromLabel(22500, 'Ab 225€'), headlineLabel: 'Mystery Pack gratis', giftVariantId: 50388695220565, giftHandle: 'bio-mystery-pack', giftCode: 'PBGIFT170' }
              : { amount: igEur(18500), label: 'Mystery Pack', sub: igFromLabel(18500, 'Ab 185€'), headlineLabel: 'Mystery Pack gratis', giftVariantId: 50388695220565, giftHandle: 'bio-mystery-pack', giftCode: 'PBGIFT170' },
          ]
        : [
            { amount: FREE_SHIPPING_THRESHOLD, label: 'Gratis Versand', sub: IG_SHIP_CUSTOM ? ((/^en/i.test(document.documentElement.lang || '') ? 'From ' : 'Ab ') + IG_SHIP.freeLabel) : igFromLabel(4900, 'Ab 49€'), headlineLabel: 'gratis Versand' },
            { amount: igEur(7000), label: '10% Rabatt', sub: igFromLabel(7000, 'Ab 70€'), headlineLabel: '10% Rabatt' },
            { amount: igEur(10000), label: '15% Rabatt', sub: igFromLabel(10000, 'Ab 100€'), headlineLabel: '15% Rabatt' },
          ].sort(function (a, b) { return a.amount - b.amount; }); // 2026-10-27: CH-Versand ab CHF 80 liegt ueber der 10%-Stufe -> aufsteigend sortieren
    }

    function progressState(isNeukunde, subtotalCents, isDuo, tiersOverride, shipCents) {
      var tiers = tiersOverride || progressTiers(isNeukunde, isDuo);
      // 2026-10-27: Gratis-Versand zaehlt wie bei Shopify nach Rabatt (shipCents = cart.total_price). Relevant v. a.
      // fuer CH (CHF 80 liegt ueber der 10%-Stufe: 88 CHF Ware - 10 % = 79,20 -> Versand faellig).
      function tierAmountBase(t) { return (shipCents != null && t.label === 'Gratis Versand') ? shipCents : subtotalCents; }

      var next = null;
      var prevAmount = 0;
      var doneCount = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (tierAmountBase(tiers[i]) >= tiers[i].amount) {
          doneCount++;
        } else if (next === null) {
          next = tiers[i];
          prevAmount = i > 0 ? tiers[i - 1].amount : 0;
        }
      }

      var headline = next
        ? 'Noch ' + money(next.amount - tierAmountBase(next)) + ' bis <strong>' + next.headlineLabel + '</strong>'
        : '🎉 Du hast alle Vorteile freigeschaltet!';

      var fillPct;
      if (!next) {
        fillPct = 100;
      } else {
        var span = next.amount - prevAmount;
        var segFrac = span > 0 ? Math.max(0, Math.min(1, (tierAmountBase(next) - prevAmount) / span)) : 0;
        fillPct = ((doneCount + segFrac) / tiers.length) * 100;
      }

      var points = [{ label: 'START', sub: '', done: true }];
      tiers.forEach(function (t) {
        points.push({ label: t.label, sub: t.sub, done: tierAmountBase(t) >= t.amount });
      });

      return { headline: headline, fillPct: fillPct, points: points };
    }

    // Baut den Stepper (Meilenstein-Punkte + Linie) analog zur wearewild-Referenz, aber in
    // unserer eigenen Optik (Lila #8048ED fuer erreichte Punkte/Fuellstand, Neutral-Grau fuer den
    // Rest - siehe ingarden-homepage-design-system.md).
    function progressMarkup(state) {
      var lastIdx = state.points.length - 1;
      var pointsHtml = state.points.map(function (p, idx) {
        var cls = 'csc-progress__point' + (p.done ? ' is-done' : '');
        if (idx === 0) cls += ' csc-progress__point--start';
        if (idx === lastIdx) cls += ' csc-progress__point--end';
        var labelHtml = p.sub
          ? '<strong>' + p.label + '</strong><span>' + p.sub + '</span>'
          : p.label;
        return (
          '<div class="' + cls + '">' +
          '<span class="csc-progress__dot">' + (p.done ? '✓' : '') + '</span>' +
          '<span class="csc-progress__point-label">' + labelHtml + '</span>' +
          '</div>'
        );
      }).join('');

      // Runde 41 (2026-09-23, Christian-Feedback: "sieht so aus als ob wir schon da sind", Holy-
      // Referenz-Screenshot): bei hohem Fuellstand (z.B. 93%, nur noch 10€ fehlen) macht die duenne,
      // fast durchgehend lila Linie die winzige Restdistanz fast unsichtbar. Zwei Massnahmen dagegen,
      // beide rein visuell, KEINE Aenderung an fillPct-Berechnung selbst (die war immer schon korrekt):
      // (1) ein eigener runder "Du bist hier"-Marker GENAU am aktuellen Fuellstand (getrennt von den
      // statischen Start-/Ziel-Punkten, die nur 0%/100% markieren) - zieht den Blick explizit auf die
      // aktuelle Position statt nur auf einen fast vollen Balken. Ausgeblendet bei fillPct>=100 (dann
      // ist der Ziel-Punkt selbst schon der Blickfang, siehe is-done-Checkmark).
      // (2) staerkerer Track-Kontrast (csc-progress__line: #F2F2F2 -> #595959, siehe CSS) - die NICHT
      // gefuellte Reststrecke bleibt dadurch klar sichtbar statt nahezu unsichtbar auf Weiss/Beige.
      var markerHtml = state.fillPct < 100
        // Runde 47: Position relativ zur echten Track-Laenge (Stepper-Breite minus 2x9px Rand), damit
        // Fill und Marker bei z.B. 90% auch optisch bei 90% des Tracks stehen.
        ? '<div class="csc-progress__marker" style="left: calc(9px + (100% - 18px) * ' + (state.fillPct / 100) + ')"></div>'
        : '';
      return (
        '<div class="csc-progress__headline">' + state.headline + '</div>' +
        '<div class="csc-progress__stepper">' +
        '<div class="csc-progress__line"></div>' +
        '<div class="csc-progress__line-fill" style="width: calc((100% - 18px) * ' + (Math.min(state.fillPct, 100) / 100) + ')"></div>' +
        markerHtml +
        pointsHtml +
        '</div>'
      );
    }

    // Haelt die Returning-Bar-Rabattcodes UND (seit Runde 14) die Neukunden-Geschenk-Rabattcodes
    // automatisch synchron zur Warenkorb-Summe. Returning-Segment: STAMMKUNDE10/15 rein nach
    // Subtotal. Neukunden-Segment: PBGIFT150/PBGIFT200 nur, wenn die zugehoerige Geschenk-Zeile
    // bereits per syncProgressGifts() im Cart liegt (findClaimedGiftTier) - der Rabattcode macht
    // NUR diese bereits vorhandene Zeile gratis, fuegt selbst kein Produkt hinzu. syncProgressGifts()
    // laeuft in render() vor dieser Funktion, d.h. die Geschenk-Zeile ist zu diesem Zeitpunkt bereits
    // auf dem aktuellen Stand. Gibt true zurueck, wenn eine Aenderung noetig war (applyDiscountCodes
    // ruft danach selbst erneut render() auf).
    // Refill-Bundle-Builder: hoechster Set-Code im Cart (14SET > 7SET > 5SET) oder null.
    var refillSetAttempts = {};
    function refillSetCodeForCart(cart) {
      var best = null, bestRank = -1;
      (cart.items || []).forEach(function (item) {
        var code = (item.properties || {}).bundle;
        var rank = REFILL_SET_CODES.indexOf(code);
        if (rank > bestRank) { bestRank = rank; best = code; }
      });
      return best;
    }

    async function syncProgressDiscount(cart, isNeukunde) {
      var currentCodes = (cart.discount_codes || []).map(function (dc) { return dc.code; });
      var subtotal = cart.items_subtotal_price;
      var targetCode = null;
      // 2026-10-24 (Christian, Option A "Set-Rabatt hat Vorrang"): Liegt ein Refill-Bundle-Builder-Set
      // (properties.bundle = 5SET/7SET/14SET) in einem Returning-Cart, gilt KEINE Stammkunden-Staffel.
      // 7SET/14SET sind nicht kombinierbar; vorher hat STAMMKUNDE10/15 den Set-Code je nach Timing
      // verdraengt (z.B. 14er-Abo: 125,39 statt angezeigter 77,51). Der Set-Code wird hier aktiv
      // sichergestellt (hoechster Code bei mehreren Sets, Shopify rechnet ohnehin nur einen an).
      // Wird der Code von Shopify abgelehnt, nur EIN Versuch pro Cart-Zustand (keine Render-Schleife).
      if (!isNeukunde && !isZgoCart(cart) && !isGrownOnlyCart(cart)) {
        var setCode = refillSetCodeForCart(cart);
        if (setCode) {
          var hasManaged = currentCodes.some(function (c) { return PROGRESS_MANAGED_CODES.indexOf(c) !== -1; });
          var hasSet = currentCodes.indexOf(setCode) !== -1;
          var otherSetCodes = currentCodes.filter(function (c) { return c !== setCode && REFILL_SET_CODES.indexOf(c) !== -1; });
          if (!hasManaged && hasSet && !otherSetCodes.length) return false;
          var attemptKey = setCode + '|' + cart.item_count + '|' + cart.items_subtotal_price;
          if (!hasSet && refillSetAttempts[attemptKey]) {
            if (!hasManaged) return false;
          }
          refillSetAttempts[attemptKey] = true;
          var keepCodes = currentCodes.filter(function (c) {
            return PROGRESS_MANAGED_CODES.indexOf(c) === -1 && REFILL_SET_CODES.indexOf(c) === -1;
          });
          await applyDiscountCodes(keepCodes.concat([setCode]));
          return true;
        }
        if (subtotal >= igEur(10000)) targetCode = 'STAMMKUNDE15';
        else if (subtotal >= igEur(7000)) targetCode = 'STAMMKUNDE10';
      } else if (!isAnnualCart(cart)) {
        var claimedTier = findClaimedGiftTier(cart, progressTiers(true, isDuoCart(cart)));
        if (claimedTier && claimedTier.giftCode) targetCode = claimedTier.giftCode;
      }
      var currentManaged = currentCodes.filter(function (c) { return PROGRESS_MANAGED_CODES.indexOf(c) !== -1; });
      var isInSync = targetCode ? (currentManaged.length === 1 && currentManaged[0] === targetCode) : currentManaged.length === 0;
      if (isInSync) return false;
      var otherCodes = currentCodes.filter(function (c) { return PROGRESS_MANAGED_CODES.indexOf(c) === -1; });
      var newCodes = targetCode ? otherCodes.concat([targetCode]) : otherCodes;
      await applyDiscountCodes(newCodes);
      return true;
    }

    // Runde 24 (Christian-Wunsch): synchronisiert BESTSELLER_PURE/BESTSELLER_MIX analog zu
    // syncProgressDiscount() oben, aber ohne Schwellenwert und ohne Geschenk-Zeilen-Abhaengigkeit -
    // einfach "ist mindestens eine Variante der jeweiligen Sortengruppe im Cart, UND ist es ein
    // Neukunden-Cart" (Christian-Entscheidung: Scope nur Neukunden-Cart, Returning bleibt
    // unveraendert). Beide Codes koennen gleichzeitig aktiv sein (reiner Sorten- + Mix-Kauf
    // gemischt), deshalb hier eine Liste statt eines einzelnen targetCode wie oben.
    async function syncBestsellerDiscount(cart, isNeukunde) {
      var currentCodes = (cart.discount_codes || []).map(function (dc) { return dc.code; });
      var targetCodes = [];
      if (isNeukunde) {
        // Runde 33 (Bugfix): Brokkoli/Rucola/Superfood-Mix/Radieschen-Mix sind auch als
        // bundle_attached_to-Zeilen im "Bestseller Mix Set"-Starter-Kit-Bundle enthalten (Runde 5/6,
        // dort mit "Lieferung alle 2 Monate (Erste frei)"-Selling-Plan, erste Lieferung ohnehin
        // final_price 0) - dieselben Varianten-IDs wie BESTSELLER_PURE_VARIANT_IDS/
        // BESTSELLER_MIX_VARIANT_IDS. Vorher zaehlte jede Zeile mit passender Varianten-ID, auch
        // diese Bundle-Zeilen - Shopify lehnt den Code fuer sie dann korrekt als "nicht anwendbar" ab
        // (BESTSELLER_PURE/BESTSELLER_MIX haben appliesOnSubscription:false, s.u.), aber der Code
        // blieb trotzdem sichtbar/angehaengt im Cart. BESTSELLER_PURE/BESTSELLER_MIX sind laut Runde
        // 24 ausschliesslich fuer die eigene "Bestseller Sorten"-Upsell-Karte gedacht (Einzelkauf,
        // kein Selling Plan) - deshalb hier nur Zeilen OHNE aktive Selling-Plan-Zuordnung zaehlen.
        var eligibleVariantIds = cart.items
          .filter(function (item) { return !item.selling_plan_allocation; })
          .map(function (item) { return item.variant_id; });
        var hasPure = BESTSELLER_PURE_VARIANT_IDS.some(function (id) { return eligibleVariantIds.indexOf(id) !== -1; });
        var hasMix = BESTSELLER_MIX_VARIANT_IDS.some(function (id) { return eligibleVariantIds.indexOf(id) !== -1; });
        if (hasPure) targetCodes.push('BESTSELLER_PURE');
        if (hasMix) targetCodes.push('BESTSELLER_MIX');
      }
      var currentManaged = currentCodes.filter(function (c) { return BESTSELLER_MANAGED_CODES.indexOf(c) !== -1; });
      var isInSync = currentManaged.length === targetCodes.length &&
        targetCodes.every(function (c) { return currentManaged.indexOf(c) !== -1; });
      if (isInSync) return false;
      var otherCodes2 = currentCodes.filter(function (c) { return BESTSELLER_MANAGED_CODES.indexOf(c) === -1; });
      await applyDiscountCodes(otherCodes2.concat(targetCodes));
      return true;
    }

    // Findet die Stufe, deren Geschenk der Kunde aktuell beansprucht hat (per PROGRESS_GIFT_PROPERTY
    // markierte Zeile) - liefert null, wenn noch nichts beansprucht wurde. Es sollte durch
    // syncProgressGifts() immer hoechstens eine solche Zeile geben.
    function findClaimedGiftTier(cart, tiers) {
      var claimedLine = cart.items.find(function (item) {
        return !!(item.properties || {})[PROGRESS_GIFT_PROPERTY];
      });
      if (!claimedLine) return null;
      var amount = (claimedLine.properties || {})[PROGRESS_GIFT_PROPERTY];
      return tiers.find(function (t) { return String(t.amount) === amount; }) ||
        // 2026-10-23: Marker-Betrag stammt aus anderer Waehrung (Markt-/Waehrungswechsel mit vollem
        // Cart) -> ueber Geschenk-Variante + erreichte Schwelle zuordnen, damit der Code aktiv bleibt.
        tiers.find(function (t) { return t.giftVariantId === claimedLine.variant_id && cart.items_subtotal_price >= t.amount; }) || null;
    }

    // Automatik-Anteil der Neukunden-Bar-Geschenke (Runde 13 - siehe Kommentar bei
    // PROGRESS_GIFT_PROPERTY oben fuer den Gesamtzusammenhang). Das ERSTE Beanspruchen eines
    // Geschenks passiert bewusst NICHT hier, sondern nur ueber den manuellen "+"-Klick in der
    // Goodie-Karte (progressGiftsMarkup/claim-gift-Click-Handler) - diese Funktion kuemmert sich nur
    // um zwei Faelle, NACHDEM bereits etwas beansprucht wurde:
    //  1) Entfernen: die Stufe, die das beanspruchte Geschenk ausgeloest hat, ist nicht mehr
    //     erreicht (Kunde hat andere Artikel entfernt) - Geschenk wird ersatzlos entfernt, damit der
    //     Kunde nicht ploetzlich den vollen Preis dafuer zahlt.
    //  2) Upgrade: eine hoehere Stufe ist inzwischen zusaetzlich erreicht - das bestehende Geschenk
    //     wird automatisch gegen das der hoeheren Stufe getauscht (fuehlt sich wie ein Bonus an,
    //     kein erneuter Klick noetig). Verhindert auch, dass beide Geschenke gleichzeitig im Cart
    //     landen (Shopifys BXGY-Discounts wuerden das ohnehin nicht beide gratis machen, siehe
    //     Kommentar bei PROGRESS_MANAGED_CODES).
    // Gibt true zurueck, wenn eine Aenderung noetig war (render() soll dann den Cart neu laden,
    // bevor es weiterrendert).
    // 2026-10-23 R6 (Christian): Geschenk wird bei erreichter Schwelle AUTOMATISCH beigelegt (vorher
    // nur per "+"-Klick, nur 30 % haben es beansprucht). Entfernt die Kundin es selbst, merken wir das
    // fuer die Session (kein erneutes Auto-Add); ein spaeterer Klick auf "+" hebt das wieder auf.
    var GIFT_DECLINED_KEY = 'csc_gift_declined';
    var giftAutoAddFailed = false;
    var lastGiftKeys = {};
    function giftDeclined() { try { return sessionStorage.getItem(GIFT_DECLINED_KEY) === '1'; } catch (e) { return false; } }
    function setGiftDeclined(v) { try { if (v) sessionStorage.setItem(GIFT_DECLINED_KEY, '1'); else sessionStorage.removeItem(GIFT_DECLINED_KEY); } catch (e) {} }
    async function syncProgressGifts(cart, isNeukunde) {
      var giftLines = cart.items.filter(function (item) {
        return !!(item.properties || {})[PROGRESS_GIFT_PROPERTY];
      });

      var target = null;
      if (isNeukunde && !isAnnualCart(cart)) {
        // Hoechste erreichte Stufe gewinnt - progressTiers() ist bereits aufsteigend sortiert.
        progressTiers(true, isDuoCart(cart)).forEach(function (t) {
          if (t.giftVariantId && cart.items_subtotal_price >= t.amount) target = t;
        });
      }

      if (!giftLines.length) {
        if (!target || giftDeclined() || giftAutoAddFailed) return false;
        var autoProps = {};
        autoProps[PROGRESS_GIFT_PROPERTY] = String(target.amount);
        autoProps._gift_auto = '1';
        try {
          var autoRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: target.giftVariantId, quantity: 1, properties: autoProps }] }),
          });
          if (!autoRes.ok) { giftAutoAddFailed = true; return false; }
        } catch (e) { giftAutoAddFailed = true; return false; }
        queueFeedback(igIsEn() ? '🎉 Free Mystery Pack added to your cart' : '🎉 Mystery Pack gratis dazugelegt', [target.giftVariantId]);
        return true;
      }

      // Runde 15: quantity === 1 gehoert bewusst mit zur "korrekt"-Pruefung dazu - PBGIFT150/
      // PBGIFT200 haben KEINE native Shopify-Mengenbegrenzung (nur der Gesamtrabattbetrag ist
      // gedeckelt, siehe computeFlags/isProgressGift), d.h. eine Zeile mit Menge > 1 (z.B. durch
      // einen direkten API-Call am UI vorbei) wuerde hier NICHT als "bereits korrekt" gelten und
      // stattdessen unten entfernt + mit Menge 1 neu hinzugefuegt (Selbstheilung).
      var alreadyCorrect = target && giftLines.length === 1 && giftLines[0].variant_id === target.giftVariantId && giftLines[0].quantity === 1;
      if (alreadyCorrect) return false;

      var toRemove = {};
      giftLines.forEach(function (item) { toRemove[item.key] = 0; });
      await updateCart(JSON.stringify({ updates: toRemove }));

      if (target) {
        var giftProps = {};
        giftProps[PROGRESS_GIFT_PROPERTY] = String(target.amount);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: target.giftVariantId, quantity: 1, properties: giftProps }] }),
        });
      }

      return true;
    }

    // "🎁 Gratis Goodies"-Karte (Runde 13, waterdrop-Referenz, ingarden-Design-System-Look statt
    // 1:1-Kopie): zeigt IMMER nur die naechste relevante Stufe - entweder die erste noch nicht
    // beanspruchte (verriegelt, solange die Schwelle nicht erreicht ist) oder, nach einem Claim,
    // direkt die naechsthoehere (falls vorhanden). Frueher erreichte/bereits ueberholte Stufen
    // werden nie erneut angeboten (verhindert, dass der Kunde nach einem Upgrade versehentlich das
    // niedrigere Geschenk zusaetzlich beansprucht - siehe syncProgressGifts). Ist die hoechste Stufe
    // bereits beansprucht, gibt es nichts mehr zu zeigen -> leerer String (die Erfolgs-Headline in
    // progressState() deckt diesen Zustand bereits ab: "🎉 Du hast alle Vorteile freigeschaltet!").
    // giftProductsByAmount: { amount: /products/{handle}.js-Objekt }, in render() vorab geladen
    // (Bild + Preis fuer die Karte, ueber die bereits vorhandene getProductByHandle()-Cache-Funktion).
    function progressGiftsMarkup(cart, subtotal, giftProductsByAmount) {
      var tiers = progressTiers(true, isDuoCart(cart)).filter(function (t) { return t.giftVariantId; });
      if (!tiers.length) return '';

      var claimedTier = findClaimedGiftTier(cart, tiers);
      var claimedAmount = claimedTier ? claimedTier.amount : -1;
      // Runde 33 (Bugfix): vorher wurde per tiers.find() immer die ERSTE noch nicht beanspruchte
      // Stufe genommen (Array-Reihenfolge), unabhaengig davon, wie hoch der Subtotal tatsaechlich
      // schon war - ein Cart, der direkt (ohne je eine niedrigere Stufe zu beanspruchen) ueber 200€
      // liegt, zeigte faelschlich weiterhin die 130€-Stufe (Energiegrün-Mix) als naechstes Geschenk
      // an, statt Ernteschere. Fix: unter allen noch nicht beanspruchten Stufen, deren Schwelle der
      // aktuelle Subtotal WIRKLICH erreicht, die HOECHSTE waehlen - konsistent mit der "hoechste
      // Stufe gewinnt"-Logik, die syncProgressGifts() beim Auto-Upgrade nach dem ersten Claim schon
      // immer verwendet hat (siehe dort). Keine Stufe erreicht -> gar keine Karte (wie seit Runde 18).
      var reachedTiers = tiers.filter(function (t) {
        return t.amount > claimedAmount && subtotal >= t.amount;
      });
      var nextTier = reachedTiers.length ? reachedTiers[reachedTiers.length - 1] : null;
      if (!nextTier) return '';

      var product = giftProductsByAmount[nextTier.amount];
      var variant = product && product.variants && product.variants[0];
      var imgSrc = (product && product.featured_image) || (variant && variant.featured_image && variant.featured_image.src) || '';
      var priceWas = variant ? '<span class="csc-price csc-price--was">' + money(variant.price) + '</span>' : '';
      var priceNow = '<span class="csc-price csc-price--free">GRATIS</span>';

      var actionHtml = '<button type="button" class="csc-gift-card__action csc-gift-card__action--claim" data-action="claim-gift" ' +
        'data-variant-id="' + nextTier.giftVariantId + '" data-tier-amount="' + nextTier.amount + '" aria-label="Geschenk hinzufuegen">+</button>';

      return (
        '<div class="csc-gifts-heading">🎁 Gratis Goodies</div>' +
        '<div class="csc-gifts">' +
        '<div class="csc-gift-card">' +
        '<div class="csc-gift-card__image">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + nextTier.label + '" loading="lazy">' : '') + '</div>' +
        '<div class="csc-gift-card__body">' +
        '<div class="csc-gift-card__title">' + nextTier.label + '</div>' +
        '<div class="csc-gift-card__price-row">' + priceWas + priceNow + '</div>' +
        '</div>' +
        actionHtml +
        '</div>' +
        '</div>'
      );
    }

    // "🌱 Probiere unsere Minis"-Upsell-Sektion (Runde 17, waterdrop/Wild-Referenzen, Christian-
    // Wunsch): kompakte, guenstige Probierpackungen (alle ~6-7€) direkt unter der Progress-Bar/
    // Gratis-Goodies-Karte, damit der naechste Meilenstein (Versand/Rabatt-Stufe ODER Neukunden-
    // Geschenk) leicht per kleinem Add-on erreichbar wird - gilt bewusst fuer BEIDE Bars (Christian-
    // Entscheidung), nicht nur die Neukunden-Bar. Produktauswahl bewusst statisch/immer alle 5
    // (Christian: "kosten eh alle gleich" - eine preisbasierte Sortierung/Filterung bringt hier
    // keinen Mehrwert). Titel/Sorten-Liste sind kurze, hartkodierte Klartexte (die Shop-Produkttitel
    // tragen redundant "Probierpackung - 3 Pads", das hier bewusst weggelassen wird, siehe Christian-
    // Wunsch) - Bild/Preis/Streichpreis kommen weiterhin LIVE aus getProductByHandle() (gecacht),
    // damit kuenftige Preisaenderungen sich automatisch spiegeln, ohne Code-Anpassung.
    // Runde 18 (Christian-Wunsch: Karten kompakter, Sorten-Zeile einzeilig statt 2-zeiliger Clamp):
    // "1x " vor jeder Zutat weggelassen (redundant, spart Zeichen), Mengen >1 (2x/3x) bleiben stehen,
    // da sie hier tatsaechlich unterscheidungsrelevant sind.
    // Runde 25 (Christian-Wunsch): Reihenfolge so gewaehlt, dass combinedUpsellMarkup() unten
    // (Neukunden-Cart) Bestseller- und Mini-Karten im Wechsel zeigt (nicht mehr Bestseller-Block
    // dann Minis-Block wie in Runde 24). miniUpsellMarkup() fuer den Returning-Cart nutzt dieselbe
    // Liste unveraendert als reine Rail, die Reihenfolge hier wirkt sich dort nur kosmetisch aus.
    // R9: Sorten je Probierpackung fuer die Cart-Zeile (3 Pads je Packung, aus der Produktbeschreibung)
    var MINI_CART_VARIETY = {
      'beauty-booster-3-pads': '1× Senf · 1× Rotkohl · 1× Rucola',
      'cardio-health-booster-3-pads': '1× Radieschen · 1× Senf · 1× Rucola',
      'rucola-probierpackung': '3× Rucola',
      'radieschen-mix-probierpackung': '3× Radieschen Mix',
      'balance-probierpackung-3-pads': '2× Senf · 1× Rotkohl',
    };
    var MINI_PRODUCTS = [
      { handle: 'beauty-booster-3-pads', title: 'Beauty-Mix', variety: 'Senf · Rotkohl · Rucola' },
      { handle: 'cardio-health-booster-3-pads', title: 'Energiegrün-Mix', variety: 'Radieschen · Senf · Rucola' },
      { handle: 'rucola-probierpackung', title: 'Rucola', variety: '3x Rucola' },
      { handle: 'radieschen-mix-probierpackung', title: 'Radieschen-Mix', variety: '3x Radieschen Mix' },
      { handle: 'balance-probierpackung-3-pads', title: 'Balance-Mix', variety: '2x Senf · Rotkohl' },
    ];

    // Runde 24 (Christian-Wunsch): "Bestseller Sorten" - die 4 meistverkauften Vollpackungen
    // (jeweils "1 Packung"-Variante, 6 Pads), im Neukunden-Cart zusaetzlich zu den Minis oben in
    // derselben Rail angeboten (siehe combinedUpsellMarkup unten), um die 99€ -> 150€-Luecke mit
    // weniger Add-ons zu schliessen als mit den 7,99€-Minis allein moeglich waere. Preis lauft
    // reduziert (17,90/20,88 -> 15,90€) ueber die Cart-Rabattcodes BESTSELLER_PURE/BESTSELLER_MIX
    // (siehe syncBestsellerDiscount) - targetPriceCents hier ist NUR fuer die Karten-Vorschau vor
    // dem Hinzufuegen (der tatsaechliche Cart-Preis kommt danach ganz normal aus /cart.js).
    var BESTSELLER_PRODUCTS = [
      { handle: 'brokkoli-superfood', variantId: 50388664451413, title: 'Brokkoli', variety: 'Bestseller · Einzelsorte', targetPriceCents: 1590 },
      { handle: 'rucola-superfood', variantId: 50388219658581, title: 'Rucola', variety: 'Bestseller · Einzelsorte', targetPriceCents: 1590 },
      { handle: 'superfood-mix', variantId: 50388291748181, title: 'Superfood-Mix', variety: 'Bestseller · Mix', targetPriceCents: 1590 },
      { handle: 'radieschen-mix-superfood', variantId: 50388269039957, title: 'Radieschen Mix', variety: 'Bestseller · Mix', targetPriceCents: 1590 },
    ];

    // 2026-10-15 (Christian-Wunsch): Dochte (+ Ernteschere) als Zubehoer-Upsell NUR im Returning-Cart (Neukunden
    // haben Dochte bereits im Starter-Set), zwei Varianten (1x = 6 Stueck, 2x = 12 Stueck), hinten an
    // die Minis-Rail angehaengt. Preis/Streichpreis/Bild/Verfuegbarkeit kommen LIVE aus
    // getProductByHandle() - die Variante wird per variantId aus dem Produkt-JSON gesucht.
    var ACCESSORY_PRODUCTS = [
      { handle: 'dochte', variantId: 41619743604909, title: 'Dochte', variety: '6 Stück · Tausch alle 1–2 Mon.' },
      { handle: 'dochte', variantId: 54160346939733, title: 'Dochte 2er-Pack', variety: '12 Stück' },
      // 2026-10-15 (Christian-Wunsch): Ernteschere als letzte Zubehoer-Karte (hilft v.a. ueber die
      // 49€-Gratisversand- bzw. 70€-Schwelle des Returning-Carts).
      { handle: 'ingarden-design-schere', variantId: 47717801427285, title: 'Ernteschere', variety: 'Für die einfache Ernte' },
    ];

    // Kombinierte Rail fuer den Neukunden-Cart. Runde 25 (Christian-Wunsch, Korrektur zu Runde 24):
    // Bestseller- und Mini-Karten im WECHSEL statt Bestseller-Block dann Minis-Block - konkret
    // Brokkoli/Beauty-Mix/Rucola/Energiegruen-Mix/Superfood-Mix/Rucola-Mini/Radieschen-Mix/
    // Radieschen-Mix-Mini/Balance-Mix-Mini (Balance-Mix-Mini haengt als 9. Karte hinten dran, da nur
    // 4 Bestseller-Sorten aber 5 Minis existieren - siehe MINI_PRODUCTS-Reihenfolge oben).
    // Anders als miniUpsellMarkup() oben: KEINE gemeinsame Sorten-Unterzeile mehr (Christian-Wunsch:
    // "3 Pads"/"6 Pads" statt Subtitle, da Minis und Bestseller-Sorten unterschiedliche Pad-Zahlen
    // haben) - stattdessen ein Pad-Badge pro Karte. Der Returning-Cart bleibt unveraendert bei
    // miniUpsellMarkup() (Christian-Entscheidung: Scope nur Neukunden-Cart).
    function combinedUpsellMarkup(bestsellerData, miniData) {
      function card(entry, action, pads) {
        var product = entry.data;
        var variant = entry.variant || (product && product.variants && product.variants[0]);
        if (!variant) return '';
        // Runde 40 (2026-09-23, Christian-Wunsch): oversold/ausverkaufte Varianten (variant.available
        // kommt frisch von /products/{handle}.js bei jedem render()-Aufruf, siehe getProductByHandle
        // oben) werden nicht mehr als Karte angezeigt - kein Sonderfall noetig, verschwinden/erscheinen
        // automatisch mit dem Lagerbestand, da bei jedem Cart-Render neu abgefragt wird. Auslöser:
        // Beauty-Mix Probierpackung war oversold (inventoryQuantity -11, inventoryPolicy DENY), liess
        // sich also nicht mehr hinzufuegen, wurde aber trotzdem weiter als klickbare Karte angezeigt.
        if (variant.available === false) return '';
        var imgSrc = (product && product.featured_image) || (variant.featured_image && variant.featured_image.src) || '';
        // Nicht-EUR: 15,90€-Zielpreis gilt nicht (Preisliste/Kurs) - Vorschau = echter Variantenpreis
        // minus umgerechneter Fix-Rabatt der Codes BESTSELLER_PURE (2,00€) / BESTSELLER_MIX (4,98€).
        var targetCents = entry.targetPriceCents;
        if (targetCents && !IG_IS_EUR) {
          var bsOff = BESTSELLER_MIX_VARIANT_IDS.indexOf(variant.id) !== -1 ? 498 : 200;
          targetCents = parseInt(variant.price, 10) - Math.round(bsOff * IG_RATE);
        }
        var compareAt = targetCents
          ? parseInt(variant.price, 10)
          : (variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0);
        var nowPriceCents = targetCents || variant.price;
        var priceWas = compareAt > nowPriceCents
          ? '<span class="csc-mini-card__price csc-mini-card__price--was">' + money(compareAt) + '</span>'
          : '';
        // Runde 26 (Christian-Wunsch): Bestseller-Sorten-Produktfotos zeigen den Karton relativ klein
        // mit viel Rand/Gruenzeug drumherum - eigener Modifier zoomt nur diese Karten-Bilder per CSS
        // rein (siehe .csc-mini-card--bestseller in cart-drawer-v2.css). Mini-Fotos bleiben unveraendert.
        var cardModifier = action === 'add-bestseller' ? ' csc-mini-card--bestseller' : '';
        return (
          '<div class="csc-mini-card' + cardModifier + '">' +
          '<div class="csc-mini-card__image">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + entry.title + '" loading="lazy">' : '') +
          '<span class="csc-mini-card__pads">' + pads + '</span>' +
          '<button type="button" class="csc-mini-card__add" data-action="' + action + '" data-variant-id="' + variant.id + '" aria-label="' + entry.title + ' hinzufuegen">+</button>' +
          '</div>' +
          '<div class="csc-mini-card__body">' +
          '<div class="csc-mini-card__title">' + entry.title + '</div>' +
          '<div class="csc-mini-card__variety">' + entry.variety + '</div>' +
          '<div class="csc-mini-card__price-row">' + priceWas + '<span class="csc-mini-card__price">' + money(nowPriceCents) + '</span></div>' +
          '</div>' +
          '</div>'
        );
      }
      // Wechselweise interleaven statt zwei Bloecke aneinanderzuhaengen (Runde 25): ueberzaehlige
      // Eintraege (hier: die 5. Mini, Balance-Mix) fallen einfach am Ende an.
      var cards = '';
      var maxLen = Math.max(bestsellerData.length, miniData.length);
      for (var ci = 0; ci < maxLen; ci++) {
        if (bestsellerData[ci] && bestsellerData[ci].variant) {
          cards += card(bestsellerData[ci], 'add-bestseller', '6 Pads');
        }
        if (miniData[ci] && miniData[ci].data) {
          cards += card({ title: miniData[ci].title, variety: miniData[ci].variety, data: miniData[ci].data }, 'add-mini', '3 Pads');
        }
      }
      if (!cards) return '';
      return (
        '<div class="csc-minis">' +
        '<div class="csc-minis-heading">🌱 Bestseller Sorten &amp; Minis</div>' +
        '<div class="csc-minis-grid-wrap">' +
        '<div class="csc-minis-grid">' + cards + '</div>' +
        '</div>' +
        '</div>'
      );
    }

    // Haelt die Sektion horizontal scrollbar mit ~2 sichtbar gleichzeitigen Karten statt eines
    // wachsenden mehrzeiligen Grids (Christian-Entscheidung per Auswahlfrage) - Hoehe bleibt damit
    // FLACH, unabhaengig davon, wie viele der 5 Minis geladen werden konnten.
    function miniUpsellMarkup(miniProductsData, accessoryData) {
      // 2026-10-15: Zubehoer-Karten (Dochte) laufen durch denselben Kartenaufbau, nur mit fester
      // Variante (entry.variant) und eigener Klick-Action (add-accessory, eigene Mess-Property).
      var allEntries = miniProductsData.concat(accessoryData || []);
      var cards = allEntries.map(function (entry) {
        var product = entry.data;
        if (!product) return '';
        var variant = entry.variant || (product.variants && product.variants[0]);
        if (!variant) return '';
        // Runde 40: siehe Kommentar bei card() oben (combinedUpsellMarkup) - dieselbe Logik hier
        // nochmal, da miniUpsellMarkup() ein eigener, unabhaengiger Kartenaufbau ist.
        if (variant.available === false) return '';
        var imgSrc = product.featured_image || (variant.featured_image && variant.featured_image.src) || '';
        var compareAt = variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
        var priceWas = compareAt > variant.price
          ? '<span class="csc-mini-card__price csc-mini-card__price--was">' + money(compareAt) + '</span>'
          : '';
        return (
          '<div class="csc-mini-card">' +
          '<div class="csc-mini-card__image">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + entry.title + '" loading="lazy">' : '') +
          '<button type="button" class="csc-mini-card__add" data-action="' + (entry.action || 'add-mini') + '" data-variant-id="' + variant.id + '" aria-label="' + entry.title + ' hinzufuegen">+</button>' +
          '</div>' +
          '<div class="csc-mini-card__body">' +
          '<div class="csc-mini-card__title">' + entry.title + '</div>' +
          '<div class="csc-mini-card__variety">' + entry.variety + '</div>' +
          '<div class="csc-mini-card__price-row">' + priceWas + '<span class="csc-mini-card__price">' + money(variant.price) + '</span></div>' +
          '</div>' +
          '</div>'
        );
      }).join('');
      if (!cards) return '';
      // Runde 19 (Christian-Wunsch: "sollte noch klar gemacht werden, dass man nach rechts browsen
      // kann"): .csc-minis-grid-wrap traegt den rechten Fade-Out (siehe CSS), die Karten selbst sind
      // jetzt schmaler als 50% (siehe .csc-mini-card), sodass am rechten Rand immer ein Stueck der
      // naechsten Karte sichtbar anschneidet - beides zusammen signalisiert Scrollbarkeit.
      return (
        '<div class="csc-minis">' +
        '<div class="csc-minis-heading">' + (accessoryData && accessoryData.length ? '🌱 Minis &amp; Zubehör' : '🌱 Probiere unsere Minis') + '</div>' +
        '<div class="csc-minis-sub">' + (accessoryData && accessoryData.length ? 'Probierpackungen, Dochte &amp; Schere' : 'Probierpackung mit 3 Bio-Saatpads') + '</div>' +
        '<div class="csc-minis-grid-wrap">' +
        '<div class="csc-minis-grid">' + cards + '</div>' +
        '</div>' +
        '</div>'
      );
    }

    function money(cents) {
      try {
        return formatMoney(cents);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + IG_CUR;
      }
    }

    // money() liefert HTML (formatMoney rendert die Cent-Stellen als <sup>, z.B. "€200,<sup
    // class=\"cents\">00</sup>") - das ist fuer innerHTML gedacht, zerstoert aber ein HTML-Attribut
    // wie title="...". Fuer solche Stellen (z.B. das Schloss-Tooltip in progressGiftsMarkup) diese
    // reine Text-Variante nutzen.
    function moneyPlain(cents) {
      return money(cents).replace(/<[^>]*>/g, '');
    }

    function open() {
      if (itemsEl && (itemsEl.querySelector('.csc-empty, .csc-empty-state') || !itemsEl.innerHTML.trim())) {
        itemsEl.innerHTML = '<div class="csc-skel"></div><div class="csc-skel csc-skel--short"></div>';
      }
      var wasOpen = root.classList.contains('is-visible');
      root.classList.add('is-active');
      window.requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
      if (!wasOpen) {
        cscTrack('csc_cart_open', lastCartCtx);
        // R8: Zurueck-Geste/Taste schliesst den Warenkorb statt die Seite zu verlassen
        try {
          if (!(history.state && history.state.cscCart)) { history.pushState({ cscCart: 1 }, ''); cscHistoryPushed = true; }
        } catch (e) {}
      }
      document.documentElement.style.overflow = 'hidden';
    }

    var cscHistoryPushed = false;
    // Nach Reload/Zurueck mit offenem Cart bleibt der State erhalten -> beim Start bereinigen,
    // sonst wuerde beim naechsten Oeffnen kein neuer Eintrag gesetzt und "Zurueck" verliesse die Seite.
    try { if (history.state && history.state.cscCart) history.replaceState(null, ''); } catch (e) {}
    window.addEventListener('popstate', function () {
      if (root.classList.contains('is-visible')) { cscHistoryPushed = false; close(true); }
    });
    function close(fromPopstate) {
      if (fromPopstate !== true && cscHistoryPushed) {
        cscHistoryPushed = false;
        try { if (history.state && history.state.cscCart) history.back(); } catch (e) {}
      }
      var gwnSheet = root.querySelector('.csc-gwn-sheet.is-open');
      if (gwnSheet) gwnSheet.classList.remove('is-open');
      root.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        root.classList.remove('is-active');
      }, 350);
    }

    function findLegacyLockItem(cart) {
      return cart.items.find(function (i) {
        return LEGACY_LOCK_PRODUCT_IDS.indexOf(i.product_id) !== -1;
      });
    }

    function computeFlags(item, legacyLockItem) {
      // WICHTIG (gefunden beim Live-Test auf dem Draft-Theme, 2026-09-15): Die _bundle-Property
      // bleibt auf ALLEN Zeilen mit derselben Variante+Properties stehen, auch wenn Shopifys
      // Auto-Discount (z.B. "Kennenlern-Set: Bio-Antioxidant Mix gratis") nur eine begrenzte Menge
      // entitled (z.B. 1 Gratis-Pack pro Kennenlern-Set im Warenkorb). Erhoeht man die Menge ueber
      // das Kontingent hinaus, spaltet Shopify serverseitig automatisch eine ZWEITE Zeile ab - mit
      // identischer _bundle-Property, aber final_price > 0 (regulaer bezahlt). Ein reiner
      // Property-Check wuerde diese zweite, bezahlte Zeile faelschlich als GRATIS anzeigen.
      // Deshalb ist final_price === 0 (Shopifys eigene, bereits nach Rabatt berechnete Zeilen-
      // Wahrheit) die einzige verlaessliche Quelle fuer "ist diese Zeile gratis" - Properties dienen
      // nur noch der Lock-Logik (bundle_attached_to), nicht mehr der Gratis-Anzeige.
      // Sicherheitsnetz: dieser Zweig greift nur noch fuer Attached-Items, die (aus welchem
      // Grund auch immer) NICHT ueber eine Bundle-Karte gerendert werden (siehe buildBundleGroups/
      // render weiter unten) - der Normalfall ist, dass sie dort als Unterliste erscheinen und
      // hier gar nicht erst einzeln durchlaufen. Keine Ausnahme mehr fuer die Gruppe "StarterSet".
      var props = item.properties || {};
      var isBundleAttached = !!props.bundle_attached_to;
      var isLegacyLocked = !!legacyLockItem && item.product_id !== legacyLockItem.product_id;
      return {
        locked: isBundleAttached || isLegacyLocked,
        free: item.final_price === 0,
        // Runde 15 (2026-09-16, Christian-Fund: Mengen-Stepper auf einer per Klaim-Karte
        // beanspruchten Geschenk-Zeile liess sich beliebig hochklicken - da PBGIFT150/PBGIFT200
        // (anders als ein BXGY-Discount) KEINE native Shopify-Mengenbegrenzung kennen (Versuch mit
        // customerGets.value.discountOnQuantity schlug fehl: "only permitted with bxgy discounts"),
        // wurde stattdessen ein fixer discountAmount (statt percentage) mit
        // appliesOnEachItem:false verwendet - das deckelt den GESAMTEN Rabattbetrag der Zeile auf
        // den Einzelpreis (6,99€/19,99€), unabhaengig von der Menge (Shopify-seitiger Cap). Diese
        // isProgressGift-Flag sperrt zusaetzlich den Mengen-Stepper in der UI (siehe itemMarkup),
        // damit gar nicht erst der Eindruck entsteht, man koenne mehr als 1 Einheit beanspruchen.
        isProgressGift: !!props[PROGRESS_GIFT_PROPERTY],
        // 2026-10-21 ingarden grown: Gratis-Loeffel (kein Stepper, kein Entfernen - kommt automatisch)
        // und Grown-Zeilen (kein Abo-Toggle; im Abo keine Mengenaenderung, Menge haengt am Plan)
        grownGift: item.variant_id === GROWN_GIFT_VARIANT_ID,
        grown: isGrownItem(item),
        grownSub: isGrownItem(item) && !!item.selling_plan_allocation,
      };
    }

    // Compare-at-Preis (Streichpreis) pro Zeile: /cart.js liefert keinen compare_at_price je
    // Zeile, deshalb wird das zugehoerige Produkt einmalig ueber /products/{handle}.js
    // nachgeladen (gecacht) und der passende Varianten-Preis herausgesucht.
    // 29.10.2026: Produkt-JSON ueber den Markt-Pfad (Shopify.routes.root, z. B. /de-ch/, /en-se/) liefert die echten
    // Preise der Markt-Preisliste (CHF/SEK/DKK). /products/x.js ohne Praefix liefert EUR. Nur fuer grown-Upsell + Loeffel.
    var productCacheLocal = {};
    async function getProductByHandleLocal(handle) {
      if (!handle) return null;
      if (productCacheLocal[handle]) return productCacheLocal[handle];
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        var res = await fetch(base + 'products/' + handle + '.js');
        if (!res.ok) return getProductByHandle(handle);
        var data = await res.json();
        productCacheLocal[handle] = data;
        return data;
      } catch (e) {
        return getProductByHandle(handle);
      }
    }
    async function getProductByHandle(handle) {
      if (!handle) return null;
      if (productCache[handle]) return productCache[handle];
      try {
        var res = await fetch('/products/' + handle + '.js');
        if (!res.ok) return null;
        var data = await res.json();
        productCache[handle] = data;
        return data;
      } catch (e) {
        return null;
      }
    }

    // Runde 42 (2026-10-05, Christian: Cart-Ersparnis soll exakt der PDP-Ersparnis entsprechen):
    // Die PDP rechnet die "Zwischensumme" der Starter-Sets mit dem ECHTEN Einzelkauf-Geraetepreis
    // (subscription_hardware_product_onetime), nicht mit dem Marketing-compare_at_price der
    // Abo-Hardware (150€ Duo / 140€ Single). Damit Streichpreis + "Du sparst" im Cart dieselbe Zahl
    // zeigen wie die PDP (z.B. Duo 90T: Rabatt 100€), nutzt der Cart fuer diese Abo-Hardware-
    // Produkte als Vergleichspreis den Preis der passenden Einzelkauf-Hardware (gleiche Farbe).
    var HARDWARE_ONETIME_HANDLES = {
      'ingarden-hardware-30-tage-abo': 'ingarden-hardware-30-tage-einzelkauf',
      'ingarden-hardware-90-tage-abo': 'ingarden-hardware-90-tage-einzelkauf',
      'ingarden-gesundes-altern-duo-30-tage-vorrat-hardware': 'ingarden-gesundes-altern-duo-30-tage-vorrat-hardware-einzelkauf',
      'ingarden-gesundes-altern-duo-90-tage-vorrat-hardware': 'ingarden-gesundes-altern-duo-90-tage-vorrat-hardware-einzelkauf'
    };

    async function getHardwareOnetimeLinePrice(item) {
      var onetimeHandle = HARDWARE_ONETIME_HANDLES[item.handle];
      if (!onetimeHandle) return null;
      var onetime = await getProductByHandle(onetimeHandle);
      if (!onetime || !onetime.variants || !onetime.variants.length) return null;
      var color = ((item.variant_options && item.variant_options[0]) || item.variant_title || '').toUpperCase();
      var match = onetime.variants.find(function (v) {
        return (v.option1 || v.title || '').toUpperCase() === color;
      }) || onetime.variants[0];
      var unit = parseInt(match.price, 10);
      if (!unit) return null;
      var line = unit * item.quantity;
      return line > item.final_line_price ? line : null;
    }

    async function getCompareAtLinePrice(item) {
      if (HARDWARE_ONETIME_HANDLES[item.handle]) {
        var hwOnetime = await getHardwareOnetimeLinePrice(item);
        if (hwOnetime) return hwOnetime;
      }
      var product = await getProductByHandle(item.handle);
      if (!product || !product.variants) return null;
      var variant = product.variants.find(function (v) {
        return v.id === item.variant_id;
      });
      if (!variant || !variant.compare_at_price) return null;
      // WICHTIG: /products/{handle}.js liefert Preise bereits in Cent als Ganzzahl (z.B. 17500 fuer
      // 175,00 EUR), nicht als Dezimal-String - anders als man vom money-Format her vermuten koennte.
      // Erste Version hatte hier faelschlich zusaetzlich *100 gerechnet (Faktor-100-Bug, beim
      // Live-Test entdeckt: 175,00 EUR wurden als 17.500,00 EUR angezeigt).
      var compareAtCentsPerUnit = parseInt(variant.compare_at_price, 10);
      if (!compareAtCentsPerUnit) return null;
      var compareAtLineTotal = compareAtCentsPerUnit * item.quantity;
      if (compareAtLineTotal <= item.final_line_price) return null;
      return compareAtLineTotal;
    }

    // Liest das "starter-set-subscription-data"-JSON-Script von der PDP des StarterSet-Root-Items
    // (nur fuer den "Abonniere & Spare"-Hinweis bei OHNE-Abo gekauften Sets gebraucht, siehe
    // render() weiter unten). Dieses Script liegt auf der PDP-HTML (main-product-starter-kit.liquid),
    // nicht im /products/{handle}.js-JSON, deshalb hier ein Fetch der vollen Produktseite + Regex-
    // Extraktion statt eines API-Calls. Ergebnis wird pro Handle gecacht.
    async function getStarterSetSubscriptionData(handle) {
      if (!handle) return null;
      if (handle in subscriptionDataCache) return subscriptionDataCache[handle];
      try {
        var res = await fetch('/products/' + handle);
        if (!res.ok) {
          subscriptionDataCache[handle] = null;
          return null;
        }
        var html = await res.text();
        var match = html.match(/<script[^>]*id=["']starter-set-subscription-data["'][^>]*>([\s\S]*?)<\/script>/);
        var data = match ? JSON.parse(match[1]) : null;
        subscriptionDataCache[handle] = data;
        return data;
      } catch (e) {
        subscriptionDataCache[handle] = null;
        return null;
      }
    }

    // Ermittelt "Abonniere & Spare X" fuer ein einzelnes Refill-Produkt (Nicht-Bundle-Zeile), das
    // OHNE Abo gekauft wurde (2026-09-16, Christian-Wunsch: "sollte so aussehen wie bei unserem
    // Starter Set mit Abo" + One-Click-Toggle "wie beim Starter Set..., nutze dazu das selbe
    // design"). Anders als bei Starter-Kits gibt es hier KEIN separates "mit Abo"-Duplikat-Produkt -
    // dieselbe Variante traegt mehrere selling_plan_groups gleichzeitig (z.B. "Lieferung jeden
    // Monat", "alle 2 Monate", "3/6 Monats Lieferung", plus "Set-Lieferung..."/"...(Erste frei)"/
    // "Duo-Abo..."-Varianten, die nur im Starter-Set-Bundle-Kontext verwendet werden, siehe
    // switchGroupToSubscription() oben).
    //
    // WICHTIG (Erkenntnis aus einem gescheiterten ersten Versuch): die PDP zeigt den fuer
    // Einzelkauf-Abo relevanten Plan clientseitig per JS-Widget (Dawns "component-subscription-
    // widget") an - der ist NICHT im server-gerenderten HTML enthalten (ein Fetch der PDP-HTML
    // sieht diesen Radio-Input deshalb nie, anders als bei getStarterSetSubscriptionData() oben,
    // deren Script-Tag echt serverseitig vorhanden ist). Ein PDP-HTML-Scrape funktioniert hier also
    // nicht. Stattdessen: an beiden gemeldeten Produkten (Bio Mini-Radieschen Mix, Bio-Superfood-Mix)
    // per Live-DOM-Check verifiziert, dass die Einzelkauf-Abo-Option konsequent exakt die Gruppe
    // mit dem Namen "Lieferung jeden Monat" ist (33% laufender Rabatt) - alle anderen Gruppen tragen
    // bewusst andere Namen ("Set-...", "...(Erste frei)", "Duo-Abo...") fuer ihre jeweiligen
    // Sonderkontexte. Deshalb wird hier direkt danach gesucht, ohne PDP-HTML-Fetch noetig - robuster
    // als das clientseitig gerenderte Widget nachzubauen.
    // 2026-10-21 ingarden grown: Einzelkauf -> Abo mit einem Klick. Plan nach Menge:
    // 1 Beutel = alle 2 Monate, 2 = alle 4 Monate (1 Person), 3 = alle 2 Monate · 2 Personen,
    // ab 4 = alle 4 Monate · 2 Personen (entspricht den Optionen der PDP).
    function grownPlanNameForQty(q) {
      if (q <= 1) return 'Lieferung alle 2 Monate';
      if (q === 2) return 'Lieferung alle 4 Monate';
      if (q === 3) return 'Lieferung alle 2 Monate · 2 Personen';
      return 'Lieferung alle 4 Monate · 2 Personen';
    }
    // Plan-Lookup fuer Grown: liefert {plan, unit} fuer einen Plannamen (Stueckpreis nach Plan-Rabatt)
    function grownFindPlan(product, name, base) {
      var plan = null;
      (product.selling_plan_groups || []).some(function (g) {
        return (g.selling_plans || []).some(function (sp) {
          if (sp.name === name) { plan = sp; return true; }
          return false;
        });
      });
      if (!plan) return null;
      var adj = (plan.price_adjustments || []).find(function (a) { return a.order_count === null; }) || (plan.price_adjustments || [])[0];
      var unit = base;
      if (adj) {
        if (adj.value_type === 'fixed_amount') unit = base - adj.value;
        else if (adj.value_type === 'percentage') unit = Math.round(base * (100 - adj.value) / 100);
        else if (adj.value_type === 'price') unit = adj.value;
      }
      return { plan: plan, unit: unit };
    }
    // 2026-10-21: Einmalkauf -> Abo (Plan nach Menge) und Upgrade auf den naechstgroesseren Vorrat
    // (1 Beutel -> 4-Monats-Vorrat, 2 Beutel -> 6-Monats-Vorrat; nur 1-Personen-Plaene / Einmalkauf).
    var GROWN_FREE_SHIP_CENTS = igFreeShipCents();
    // Styles fuer den Upgrade-Button inline (cart-drawer-v2.css bleibt unveraendert)
    (function () {
      if (document.getElementById('csc-grown-upgrade-style')) return;
      var st = document.createElement('style');
      st.id = 'csc-grown-upgrade-style';
      st.textContent =
        '#csc-drawer-v2 .csc-grown-upgrade{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:4px 10px;width:100%;margin-top:8px;padding:10px 12px;border:1.5px dashed #8048ED;border-radius:10px;background:#F3EEFF;color:#2F2E2C;font:inherit;font-size:12px;line-height:1.35;text-align:left;cursor:pointer}' +
        '#csc-drawer-v2 .csc-grown-upgrade:hover{background:#EAE0FF}' +
        '#csc-drawer-v2 .csc-grown-upgrade:disabled{opacity:.6;cursor:default}' +
        '#csc-drawer-v2 .csc-grown-upgrade__main{font-weight:700;color:#8048ED}' +
        '#csc-drawer-v2 .csc-grown-upgrade__meta{font-weight:600}' +
        '#csc-drawer-v2 .csc-grown-upgrade__meta strong{color:#2F7D32}';
      document.head.appendChild(st);
    })();
    async function getGrownUpsellInfo(item) {
      var product = await getProductByHandle(item.handle);
      if (!product || !product.selling_plan_groups) return null;
      var sub = item.selling_plan_allocation;
      var q = item.quantity;
      var base = sub ? (sub.compare_at_price || item.original_price) : item.original_price;
      var info = { grown: true };

      if (!sub) {
        var wanted = grownPlanNameForQty(q);
        if (q === 3 && grownFindPlan(product, 'Lieferung alle 6 Monate', base)) wanted = 'Lieferung alle 6 Monate';
        if (q >= 6 && grownFindPlan(product, 'Lieferung alle 6 Monate · 2 Personen', base)) wanted = 'Lieferung alle 6 Monate · 2 Personen';
        var p = grownFindPlan(product, wanted, base);
        if (p) {
          var sv = item.final_line_price - p.unit * q;
          if (sv > 0) {
            info.planId = p.plan.id;
            info.savings = sv;
            info.interval = wanted.replace('Lieferung ', '').replace(' · 2 Personen', '');
          }
        }
      }

      // Upgrade
      var curName = sub && sub.selling_plan ? sub.selling_plan.name : '';
      var target = null;
      if (sub) {
        if (curName === 'Lieferung alle 2 Monate' && q === 1) target = { q: 2, name: 'Lieferung alle 4 Monate', label: '4-Monats-Vorrat' };
        else if (curName === 'Lieferung alle 4 Monate' && q === 2) target = { q: 3, name: 'Lieferung alle 6 Monate', label: '6-Monats-Vorrat' };
        else if (curName === 'Lieferung alle 2 Monate · 2 Personen' && q === 2) target = { q: 4, name: 'Lieferung alle 4 Monate · 2 Personen', label: '4-Monats-Vorrat' };
        else if (curName === 'Lieferung alle 4 Monate · 2 Personen' && q === 4) target = { q: 6, name: 'Lieferung alle 6 Monate · 2 Personen', label: '6-Monats-Vorrat' };
      } else {
        if (q === 1) target = { q: 2, name: null, label: '4-Monats-Vorrat' };
        else if (q === 2) target = { q: 3, name: null, label: '6-Monats-Vorrat' };
        else if (q === 4) target = { q: 6, name: null, label: '6-Monats-Vorrat (2 Personen)' };
      }
      if (target) {
        var newTotal = null;
        var planId = null;
        if (target.name) {
          var tp = grownFindPlan(product, target.name, base);
          if (tp) { newTotal = tp.unit * target.q; planId = tp.plan.id; }
        } else {
          newTotal = base * target.q - Math.floor(base * 5 / 100) * target.q; // Auto-Rabatt 5 % ab 2 Beuteln
        }
        if (newTotal !== null) {
          var delta = newTotal - item.final_line_price;
          var perBagNow = item.final_line_price / q;
          var perBagNew = newTotal / target.q;
          var perk = '';
          if (item.final_line_price < GROWN_FREE_SHIP_CENTS && newTotal >= GROWN_FREE_SHIP_CENTS) perk = 'Gratis-Versand';
          else if (perBagNow - perBagNew >= igEur(50)) perk = moneyPlain(Math.round(perBagNow - perBagNew)) + ' pro Beutel gespart';
          if (delta > 0) info.upgrade = { q: target.q, planId: planId, delta: delta, label: target.label, perk: perk };
        }
      }
      return (info.planId || info.upgrade) ? info : null;
    }

    async function getRefillUpsellInfo(item) {
      if (isGrownItem(item)) return getGrownUpsellInfo(item);
      var product = await getProductByHandle(item.handle);
      if (!product || !product.selling_plan_groups) return null;
      var plan = null;
      product.selling_plan_groups.some(function (g) {
        if (g.name === 'Lieferung jeden Monat' && g.selling_plans && g.selling_plans[0]) {
          plan = g.selling_plans[0];
          return true;
        }
        return false;
      });
      if (!plan) return null;
      var adj = (plan.price_adjustments || []).find(function (a) { return a.order_count === null; });
      if (!adj || adj.value_type !== 'percentage') return null;
      var savings = Math.round((item.final_price * adj.value) / 100) * item.quantity;
      if (savings <= 0) return null;
      return { planId: plan.id, percent: adj.value, savings: savings };
    }

    // Analog zu getRefillUpsellInfo(), aber fuer Artikel innerhalb eines Refill-Bundle-Builder-Sets
    // (properties.bundle = "5SET"/"7SET"/"14SET", siehe REFILL_SET_CODES oben). Diese Artikel
    // tragen laut Live-Cart-Check (2026-09-16) eine EIGENE Selling-Plan-Gruppe mit dem Namen
    // "Set-Lieferung jeden Monat" (nicht "Lieferung jeden Monat" wie beim Einzelkauf-Abo) - andere
    // Prozentsaetze/Konditionen sind dort bewusst nicht ausgeschlossen, deshalb ein eigener,
    // separater Lookup statt getRefillUpsellInfo() wiederzuverwenden.
    async function getBundleSetUpsellInfo(item) {
      var product = await getProductByHandle(item.handle);
      if (!product || !product.selling_plan_groups) return null;
      var plan = null;
      product.selling_plan_groups.some(function (g) {
        if (g.name === 'Set-Lieferung jeden Monat' && g.selling_plans && g.selling_plans[0]) {
          plan = g.selling_plans[0];
          return true;
        }
        return false;
      });
      if (!plan) return null;
      var adj = (plan.price_adjustments || []).find(function (a) { return a.order_count === null; });
      if (!adj || adj.value_type !== 'percentage') return null;
      // 2026-10-24: Basis ist der regulaere Preis - final_price ist bei 5SET bereits um den Set-Zeilenrabatt
      // reduziert, die Abo-Ersparnis wurde dadurch zu niedrig angezeigt (5er: 41,14 statt 45,65).
      var basePrice = item.original_price || item.price || item.final_price;
      var savings = Math.round((basePrice * adj.value) / 100) * item.quantity;
      if (savings <= 0) return null;
      return { planId: plan.id, percent: adj.value, savings: savings };
    }

    // Tauscht ein OHNE-Abo gekauftes StarterSet live gegen die "mit Abo"-Variante derselben Farbe:
    // entfernt die aktuelle Gruppe (Root + Gratis-Beigaben) und fuegt stattdessen den Abo-Root plus
    // die Abo-Gratis-Beigaben (samt Recharge-Plan) hinzu - wie wearewild's "Subscribe & Save"-
    // Checkbox, nur fuer ein ganzes Bundle statt eines einzelnen Produkts.
    async function switchGroupToSubscription(groupKeys, handle, rootVariantId, rootQuantity) {
      var data = await getStarterSetSubscriptionData(handle);
      if (!data || !data.original_product_variants || !data.duplicate_product || !data.duplicate_product.variants || !data.bundleItems) {
        return false;
      }
      var rootVariant = data.original_product_variants.find(function (v) { return v.id === rootVariantId; });
      if (!rootVariant) return false;
      var aboVariant = data.duplicate_product.variants.find(function (v) { return v.option1 === rootVariant.option1; });
      if (!aboVariant) return false;

      var removeUpdates = {};
      groupKeys.forEach(function (k) { removeUpdates[k] = 0; });
      await updateCart(JSON.stringify({ updates: removeUpdates }));

      // Neue Instanz-ID fuer die frisch hinzugefuegte Abo-Gruppe (2026-09-16, gleiches Prinzip wie
      // der Bundle-Merge-Bugfix in product-form-starter-kit.js): ohne eigene _bundle_instance
      // wuerde diese Gruppe mit dem leeren Fallback-Schluessel "StarterSet|" gruppieren und
      // faelschlich mit einem ANDEREN, ebenfalls instanzlosen Set im selben Cart verschmelzen.
      var newBundleInstanceId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

      var items = [
        {
          id: aboVariant.id,
          quantity: rootQuantity,
          properties: { bundle_root: 'StarterSet', _bundle_instance: newBundleInstanceId, _bundle_additional_option: '' },
        },
      ];
      data.bundleItems.forEach(function (bi) {
        items.push({
          id: bi.variant_id,
          quantity: bi.quantity,
          selling_plan: bi.plan_id,
          properties: { bundle_attached_to: 'StarterSet', _bundle_instance: newBundleInstanceId },
        });
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      return true;
    }

    // Findet die "laufende" (nicht die erste, oft gratis) Preisanpassung eines Recharge-
    // Subscription-Plans auf einer Cart-Zeile - z.B. "-33% ab der 2. Lieferung". order_count===null
    // markiert bei Recharge/Shopify Selling Plans die unbefristet wiederkehrende Anpassung.
    function findOngoingPlanAdjustment(item) {
      var spa = item.selling_plan_allocation;
      if (!spa || !spa.selling_plan) return null;
      var planAdj = (spa.selling_plan.price_adjustments || []).find(function (a) {
        return a.order_count === null;
      });
      if (!planAdj) return null;
      var priceAdj = (spa.price_adjustments || []).find(function (a) {
        return a.position === planAdj.position;
      });
      if (!priceAdj) return null;
      return { pricePerUnit: priceAdj.price, percent: planAdj.value, planName: spa.selling_plan.name };
    }

    function planLabel(name) {
      // "Lieferung alle 2 Monate (Erste frei)" -> "Lieferung alle 2 Monate"
      return (name || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
    }

    // Streichpreis (Cent, Zeilensumme) fuer eine Zeile MIT aktivem Subscription-Plan: was die
    // Zeile als Einzelkauf (ohne Abo) kosten wuerde. Shopify liefert das direkt und zuverlaessig
    // ueber selling_plan_allocation.compare_at_price (Pro-Stueck-Originalpreis vor der Plan-
    // Anpassung) - kein zusaetzlicher Produkt-Fetch noetig, anders als beim allgemeinen
    // getCompareAtLinePrice() weiter oben (das ist fuer NICHT-Abo-Zeilen gedacht und vergleicht
    // gegen den Varianten-Compare-at-Preis, nicht gegen den Abo-Ursprungspreis).
    function getPlanCompareAtLinePrice(item) {
      var spa = item.selling_plan_allocation;
      if (!spa || !spa.compare_at_price) return null;
      var total = spa.compare_at_price * item.quantity;
      if (total <= item.final_line_price) return null;
      return total;
    }

    function itemMarkup(item, flags, compareAtLinePrice, upsellInfo) {
      // Runde 21 (Christian-Wunsch, "sehen im Vergleich zu den Set-Karten unrund aus"): einfache
      // Zeilen jetzt im selben Karten-Look wie die Bundle-/Set-Karten (siehe bundleGroupMarkup/
      // refillSetGroupMarkup weiter unten) - .csc-item--bundle liefert weissen Card-Hintergrund +
      // Rahmen, .csc-bundle-main/.csc-bundle-footer-row dieselbe Bild-oben/Preis-unten-rechts-
      // Struktur, damit Bilder ueber alle Zeilentypen hinweg auf derselben Spalte sitzen und Preise
      // untereinander rechtsbuendig stehen. Mengen-Stepper (-1+) bleibt wie gewuenscht unveraendert
      // oben rechts neben Titel/Bild; nur der Entfernen-Button wandert von "x" oben rechts zum
      // Muelltonnen-Icon unten links (csc-bundle-actions/csc-bundle-icon-btn), analog zu den Karten.
      var controlsMarkup;
      var removeIconHtml = '';
      if (flags.locked) {
        controlsMarkup = '<div class="csc-item__locked-note">Teil deines Sets</div>';
        // Kein eigenstaendiges Entfernen - Zeile gehoert zu einem Set, wird nur ueber die Set-Karte
        // als Ganzes entfernt (unveraendertes Verhalten).
      } else if (flags.grownGift) {
        controlsMarkup = '<div class="csc-item__locked-note">Gratis-Beigabe</div>';
      } else if (flags.grownSub) {
        // Menge = Personen x Laufzeit, passend zum Abo-Plan -> nur ueber die Produktseite aenderbar
        controlsMarkup = '<div class="csc-item__locked-note">' + item.quantity + ' Beutel' + ' · Abo</div>';
        removeIconHtml = '<button type="button" class="csc-bundle-icon-btn" data-action="remove" data-key="' + item.key + '" aria-label="Entfernen" title="Entfernen">🗑</button>';
      } else if (flags.isProgressGift) {
        // Kein Mengen-Stepper (siehe Kommentar bei computeFlags/isProgressGift) - Entfernen bleibt
        // moeglich (Kunde kann das Geschenk jederzeit selbst wieder loswerden).
        controlsMarkup = '<div class="csc-item__locked-note">Geschenk · 1x</div>';
        removeIconHtml = '<button type="button" class="csc-bundle-icon-btn" data-action="remove" data-key="' + item.key + '" aria-label="Entfernen" title="Entfernen">🗑</button>';
      } else {
        controlsMarkup =
          '<div class="csc-item__qty">' +
          '<button type="button" class="csc-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Menge verringern">–</button>' +
          '<span class="csc-qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="csc-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Menge erhoehen">+</button>' +
          '</div>';
        removeIconHtml = '<button type="button" class="csc-bundle-icon-btn" data-action="remove" data-key="' + item.key + '" aria-label="Entfernen" title="Entfernen">🗑</button>';
      }

      // Refill-Abo-Zeile (2026-09-16, Christian-Feedback nach dem ersten Entwurf: NICHT wie beim
      // Starter-Set einen separaten teal-farbenen Info-Strip fuer "bereits im Abo" - stattdessen
      // exakt dieselbe hellgruene Klick-Box wie beim "ohne Abo"-Upsell, nur mit vorausgewaehlter
      // (checked) Checkbox. Die Starter-Set-Bundle-Karten (bundleGroupMarkup weiter unten) bleiben
      // davon bewusst unberuehrt - "sollen so bleiben wie sie aktuell sind" (Christian). Ausserdem
      // jetzt mit Streichpreis in der Preis-Zeile + Beitrag zur "Du sparst"-Summe (siehe render()).
      var ongoingAdj = (!flags.locked && !flags.free) ? findOngoingPlanAdjustment(item) : null;
      var planCompareAt = ongoingAdj ? getPlanCompareAtLinePrice(item) : null;

      // Reihenfolge "war -> jetzt", passend zum Referenz-Design (z.B. Kennenlern-Set
      // Compare-at-Preis oder Kennenlern-Set-Gratisbeigabe): erst der durchgestrichene
      // Ursprungspreis (falls vorhanden), danach der aktuelle Preis/GRATIS-Badge.
      var wasPriceHtml = '';
      if (flags.free) {
        // Nur anzeigen, wenn es tatsaechlich einen Ursprungspreis > 0 gab (echter Rabatt) - sonst
        // wuerde ein durchgestrichenes "€0,00" neben GRATIS unnoetig verwirrend wirken.
        if (item.original_line_price > 0) {
          wasPriceHtml = '<span class="csc-price csc-price--was">' + money(item.original_line_price) + '</span>';
        } else if (flags.grownGift && GROWN_GIFT_VALUE_CENTS) {
          wasPriceHtml = '<span class="csc-price csc-price--was">' + money(GROWN_GIFT_VALUE_CENTS) + '</span>';
        }
      } else if (flags.grown && !ongoingAdj && item.original_line_price > item.final_line_price) {
        // 2026-10-21 ingarden grown Einmalkauf: Mengenrabatt (5 % ab 2 Beuteln) direkt an der Zeile
        // als Streichpreis zeigen (ist bereits in total_discount -> kein Doppelzaehlen in "Du sparst")
        wasPriceHtml = '<span class="csc-price csc-price--was">' + money(item.original_line_price) + '</span>';
      } else if (planCompareAt) {
        wasPriceHtml = '<span class="csc-price csc-price--was">' + money(planCompareAt) + '</span>';
      } else if (compareAtLinePrice) {
        wasPriceHtml = '<span class="csc-price csc-price--was">' + money(compareAtLinePrice) + '</span>';
      }
      var nowPriceHtml = flags.free
        ? '<span class="csc-price csc-price--free">GRATIS</span>'
        : '<span class="csc-price">' + money(item.final_line_price) + '</span>';

      // Refill-Abo-Toggle: EINE Box fuer beide Zustaende (Christian-Wunsch), Checkbox zeigt den
      // aktuellen Stand (checked = im Abo, unchecked = Einzelkauf) und toggelt beim Klick.
      var subscriptionStripHtml = '';
      if (flags.grownSub) {
        // Grown im Abo: Haken gesetzt, Abwaehlen = zurueck zum Einzelkauf (inkl. 5 % ab 2 Beuteln)
        var gCmp = (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) || 0;
        var gOnce = gCmp * item.quantity - (item.quantity >= 2 ? Math.floor(gCmp * 5 / 100) * item.quantity : 0);
        var gSaved = gOnce - item.final_line_price;
        if (gCmp && gSaved > 0) {
          subscriptionStripHtml =
            '<label class="csc-bundle-upsell">' +
            '<input type="checkbox" class="csc-bundle-upsell-checkbox" checked data-action="switch-item-to-onetime" ' +
            'data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-quantity="' + item.quantity + '">' +
            '<span>💡 Im Abo: Du sparst ' + money(gSaved) + ' + Messlöffel gratis</span>' +
            '</label>';
        }
      } else if (flags.grown) {
        if (upsellInfo && upsellInfo.savings > 0) {
          subscriptionStripHtml =
            '<label class="csc-bundle-upsell">' +
            '<input type="checkbox" class="csc-bundle-upsell-checkbox" data-action="switch-item-to-abo" ' +
            'data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-quantity="' + item.quantity + '" data-plan-id="' + upsellInfo.planId + '">' +
            '<span>💡 Abo (Lieferung ' + upsellInfo.interval + '): spare ' + money(upsellInfo.savings) + ' + Messlöffel gratis</span>' +
            '</label>';
        }
      } else if (!flags.locked && !flags.free) {
        if (ongoingAdj) {
          var checkedSavings = planCompareAt
            ? planCompareAt - item.final_line_price
            : Math.round(item.final_price / (1 - ongoingAdj.percent / 100)) * item.quantity - item.final_line_price;
          subscriptionStripHtml =
            '<label class="csc-bundle-upsell">' +
            '<input type="checkbox" class="csc-bundle-upsell-checkbox" checked data-action="switch-item-to-onetime" ' +
            'data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-quantity="' + item.quantity + '">' +
            '<span>💡 Abonniere & Spare ' + money(checkedSavings) + '</span>' +
            '</label>';
        } else if (upsellInfo && upsellInfo.savings > 0) {
          subscriptionStripHtml =
            '<label class="csc-bundle-upsell">' +
            '<input type="checkbox" class="csc-bundle-upsell-checkbox" data-action="switch-item-to-abo" ' +
            'data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-quantity="' + item.quantity + '" data-plan-id="' + upsellInfo.planId + '">' +
            '<span>💡 Abonniere & Spare ' + money(upsellInfo.savings) + '</span>' +
            '</label>';
        }
      }

      // 2026-10-21 ingarden grown: Upgrade auf den naechstgroesseren Vorrat (ein Klick)
      if (flags.grown && upsellInfo && upsellInfo.upgrade) {
        var up = upsellInfo.upgrade;
        subscriptionStripHtml +=
          '<button type="button" class="csc-grown-upgrade" data-action="grown-upgrade" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-quantity="' + up.q + '"' + (up.planId ? ' data-plan-id="' + up.planId + '"' : '') + '>' +
          '<span class="csc-grown-upgrade__main">⬆ Upgrade auf ' + up.label + '</span>' +
          '<span class="csc-grown-upgrade__meta">+' + money(up.delta) + (up.perk ? ' · <strong>' + up.perk + '</strong>' : '') + '</span>' +
          '</button>';
      }

      var miniShort = MINI_PRODUCTS.find(function (m) { return m.handle === item.handle; }) || null;
      var qtyInFooter = /csc-item__qty/.test(controlsMarkup || '');
      return (
        '<div class="csc-item csc-item--bundle' + (flags.locked ? ' csc-item--locked' : '') + '" data-key="' + item.key + '">' +
        '<div class="csc-bundle-main">' +
        '<div class="csc-item__image"><img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
        '<div class="csc-item__body">' +
        // R10: Minis mit kurzem Titel ("Energiegrün-Mix") + "Probierpackung · Sorten" darunter
        '<div class="csc-item__title">' + (miniShort ? miniShort.title : item.product_title) + '</div>' +
        // R9 (Christian): Minis zeigen im Cart ihre Sorten statt keinem/Default-Variantentitel
        (MINI_CART_VARIETY[item.handle]
          ? '<div class="csc-item__variant">Probierpackung · ' + MINI_CART_VARIETY[item.handle] + '</div>'
          : (item.variant_title ? '<div class="csc-item__variant">' + item.variant_title + '</div>' : '')) +
        '</div>' +
        // R10 (mobil): Mengen-Stepper unten neben den Papierkorb statt rechts oben - der Text bekommt
        // die volle Breite (vorher nur ~120 px, Titel/Sorten brachen wortweise um).
        (qtyInFooter ? '' : '<div class="csc-item__controls">' + controlsMarkup + '</div>') +
        '</div>' +
        '<div class="csc-bundle-footer-row">' +
        '<div class="csc-bundle-actions">' + removeIconHtml + (qtyInFooter ? controlsMarkup : '') + '</div>' +
        '<div class="csc-item__price-row">' + wasPriceHtml + nowPriceHtml + '</div>' +
        '</div>' +
        subscriptionStripHtml +
        '</div>'
      );
    }

    // Rabatt-Zeilen fuer den Footer: automatische Zeilen-Rabatte (z.B. Kennenlern-Set-Gratisbeigabe,
    // gruppiert nach Titel) + manuell eingegebene Rabattcodes (inkl. nicht anwendbarer Codes, damit
    // man sie auch wieder entfernen kann).
    function buildDiscountRows(cart) {
      var totals = {};
      var order = [];
      cart.items.forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (alloc) {
          var title = (alloc.discount_application && (alloc.discount_application.title || alloc.discount_application.description)) || 'Rabatt';
          if (!(title in totals)) {
            totals[title] = 0;
            order.push(title);
          }
          totals[title] += alloc.amount;
        });
      });

      // WICHTIG (seit 2026-09-16, Fix Doppel-Zeilen-Bug): fuer Rabattcodes (z.B. PBGIFT150,
      // STAMMKUNDE10/15) taucht derselbe Code sowohl hier (als line_level_discount_allocations-Titel,
      // == Code-String) als auch unten in cart.discount_codes auf. Frueher wurden das zwei separate
      // Zeilen ("PBGIFT150 -€6,99" ohne Remove-Button + "PBGIFT150" ohne Betrag mit Remove-Button).
      // Fix: ueber den Titel/Code mergen, damit jeder Code nur eine Zeile mit Betrag UND Remove-Button
      // erzeugt. Automatische Rabatte (z.B. Kennenlern-Set-Gratisbeigabe) haben keinen passenden Code
      // und bleiben unveraendert eine reine totals-Zeile ohne Remove-Button.
      var codeByTitle = {};
      (cart.discount_codes || []).forEach(function (dc) {
        codeByTitle[dc.code] = dc;
      });

      var rows = order.map(function (title) {
        var dc = codeByTitle[title];
        return {
          title: title,
          amount: totals[title],
          removable: !!dc,
          code: dc ? dc.code : undefined,
          applicable: dc ? dc.applicable : true,
        };
      });

      // Codes, die (noch) keine line_level_discount_allocation erzeugt haben (z.B. nicht anwendbar),
      // werden weiterhin als eigene Zeile angezeigt, damit man sie entfernen kann.
      (cart.discount_codes || []).forEach(function (dc) {
        if (!(dc.code in totals)) {
          rows.push({
            title: dc.code,
            amount: dc.amount,
            removable: true,
            code: dc.code,
            applicable: dc.applicable,
          });
        }
      });

      return rows;
    }

    // R6 (UX): interne, vom Cart gesteuerte Codes nicht als Roh-Code ("PBGIFT170") zeigen.
    // Geschenk-Codes ganz ausblenden (Zeile steht schon als GRATIS im Warenkorb, Ersparnis im
    // "Du sparst"-Banner), uebrige mit Klartext und ohne x (wuerde sofort neu gesetzt).
    var MANAGED_CODE_LABELS = {
      STAMMKUNDE10: 'Stammkunden-Rabatt 10 %',
      STAMMKUNDE15: 'Stammkunden-Rabatt 15 %',
      BESTSELLER_PURE: 'Bestseller-Vorteil',
      BESTSELLER_MIX: 'Bestseller-Vorteil Mix',
    };
    function discountsMarkup(rows, cart) {
      rows = rows.filter(function (row) { return !(row.code && /^PBGIFT/i.test(row.code)); });
      rows.forEach(function (row) {
        if (row.code && MANAGED_CODE_LABELS[row.code]) { row.title = MANAGED_CODE_LABELS[row.code]; row.removable = false; }
      });
      if (!rows.length) return '';
      return rows.map(function (row) {
        if (row.code && /^(ZG-|ZWEITGERAET)/i.test(row.code) && row.applicable !== false) {
          // Zweitgeraet-Aktion (persoenliche Klaviyo-Codes mit Praefix ZG-): siehe ZGO_PROPERTY oben
          var zgoAmount = row.amount || (cart ? zgoDiscountCents(cart) : 0);
          return (
            '<div class="csc-discount-row">' +
            '<span class="csc-discount-row__tag">🏷</span>' +
            '<span class="csc-discount-row__title">Dein Treuepreis</span>' +
            '<span class="csc-discount-row__amount">' + (zgoAmount ? '-' + money(zgoAmount) : '') + '</span>' +
            '</div>'
          );
        }
        return (
          '<div class="csc-discount-row' + (row.applicable === false ? ' csc-discount-row--inactive' : '') + '">' +
          '<span class="csc-discount-row__tag">🏷</span>' +
          '<span class="csc-discount-row__title">' + row.title + (row.applicable === false ? ' (nicht anwendbar)' : '') + '</span>' +
          '<span class="csc-discount-row__amount">' + (row.amount ? '-' + money(row.amount) : '') + '</span>' +
          (row.removable ? '<button type="button" class="csc-discount-row__remove" data-remove-code="' + row.code + '" aria-label="Rabattcode entfernen">&times;</button>' : '') +
          '</div>'
        );
      }).join('');
    }

    // WICHTIG (seit 2026-09-16, Fix des Bundle-Merge-Bugs): product-form-starter-kit.js vergibt
    // jetzt zusaetzlich properties._bundle_instance (eindeutig pro Add-to-Cart-Klick), damit zwei
    // separat gebaute/gekaufte Sets nicht mehr verschmelzen (siehe buildBundleGroups weiter unten).
    // Der Gruppenschluessel hier (bundle_attached_to + Instanz-ID) muss dieselbe Kombination
    // verwenden wie dort, sonst wuerden Beigaben eines Sets faelschlich als verwaist gelten, sobald
    // ein ANDERES Set (gleicher bundle_attached_to-String, andere Instanz) im Cart liegt. Aeltere
    // Zeilen ohne _bundle_instance gruppieren als Fallback weiterhin nur ueber den String.
    async function cleanupOrphanedBundles(cart) {
      var groups = {};
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        var group = props.bundle_attached_to;
        if (group) {
          var key = group + '|' + (props._bundle_instance || '');
          groups[key] = groups[key] || [];
          groups[key].push(item);
        }
      });

      var toRemove = [];
      Object.keys(groups).forEach(function (key) {
        var hasRoot = cart.items.some(function (i) {
          var p = i.properties || {};
          return p.bundle_root && (p.bundle_root + '|' + (p._bundle_instance || '')) === key;
        });
        if (!hasRoot) toRemove = toRemove.concat(groups[key]);
      });

      if (!toRemove.length) return false;

      for (var i = 0; i < toRemove.length; i++) {
        await updateCart(JSON.stringify({ updates: (function () {
          var u = {};
          u[toRemove[i].key] = 0;
          return u;
        })() }));
      }
      return true;
    }

    // StarterSet-Bundles gruppieren: Root-Item (properties.bundle_root = Gruppenname) + alle
    // Attached-Items mit passendem properties.bundle_attached_to. WICHTIG (siehe Kommentar am
    // Dateianfang): der Gruppenname ist aktuell fuer ALLE Starter-Kits derselbe hartcodierte
    // String "StarterSet" (kein Produkt- oder Instanz-Bezug) - zwei separat hinzugefuegte
    // Exemplare desselben Sets fuehren serverseitig zu EINER zusammengefuehrten Cart-Zeile
    // (Shopify fuehrt Zeilen mit identischen Properties automatisch zusammen) und erscheinen
    // deshalb hier auch nur als EINE kombinierte Karte, nicht als zwei getrennte. Das ist eine
    // bekannte Einschraenkung der aktuellen Property-Vergabe in product-form-starter-kit.js,
    // keine Einschraenkung dieser Gruppierungs-Funktion.
    // Gruppenschluessel = bundle_root/bundle_attached_to-String + Instanz-ID (properties.
    // _bundle_instance, seit 2026-09-16 von product-form-starter-kit.js vergeben - siehe Kommentar
    // bei cleanupOrphanedBundles oben). Vorher war der Schluessel nur der hartcodierte String
    // "StarterSet" fuer JEDES Starter-Kit - zwei separat hinzugefuegte Sets (gleiches ODER
    // unterschiedliches Set) verschmolzen dadurch immer zu einer Karte (Bundle-Merge-Bug, von
    // Christian am 2026-09-16 gemeldet). Aeltere Zeilen ohne _bundle_instance (vor dem Fix
    // hinzugefuegt) gruppieren als Fallback weiterhin nur ueber den String - unveraendertes altes
    // Verhalten fuer bereits laufende Carts.
    function buildBundleGroups(cart) {
      var groups = {};
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (props.bundle_root) {
          var rootKey = props.bundle_root + '|' + (props._bundle_instance || '');
          groups[rootKey] = groups[rootKey] || { root: null, attached: [] };
          groups[rootKey].root = item;
        }
      });
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (props.bundle_attached_to) {
          var attKey = props.bundle_attached_to + '|' + (props._bundle_instance || '');
          if (groups[attKey]) groups[attKey].attached.push(item);
        }
      });
      return groups;
    }

    // Refill-Bundle-Builder-Sets (5er/7er/14er, properties.bundle = "5SET"/"7SET"/"14SET") gruppieren
    // - analog zu buildBundleGroups(), aber ohne Root/Attached-Unterscheidung (alle Artikel eines
    // Sets sind gleichrangig). Gruppenschluessel = Code + Build-Instanz-ID (properties.
    // _bundle_instance, seit 2026-09-16 von assets/bundle-builder.js vergeben), damit zwei separat
    // gebaute Sets gleicher Groesse nicht verschmelzen (siehe Kommentar bei REFILL_SET_CODES oben).
    // Aeltere Zeilen ohne _bundle_instance (vor diesem Fix hinzugefuegt) gruppieren als Fallback
    // weiterhin nur ueber den Code - unveraendertes altes Verhalten fuer bereits laufende Carts.
    function buildRefillSetGroups(cart) {
      var groups = {};
      var order = [];
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        var code = props.bundle;
        if (!code || REFILL_SET_CODES.indexOf(code) === -1) return;
        var groupKey = code + '|' + (props._bundle_instance || '');
        if (!groups[groupKey]) {
          groups[groupKey] = { key: groupKey, code: code, items: [] };
          order.push(groupKey);
        }
        groups[groupKey].items.push(item);
      });
      return order.map(function (k) { return groups[k]; });
    }

    // priceSums: { totalNow, totalWas } (Cent), in render() vorberechnet - totalWas nutzt je Artikel
    // denselben Streichpreis-Vorrang wie bei einzelnen Refill-Zeilen (Plan-Compare-at > allgemeiner
    // Compare-at > kein Unterschied), damit "Abonniere & Spare X" hier exakt dieselbe Bedeutung hat
    // wie bei einer einzelnen Refill-Zeile (nur Abo-Prozentsatz, NICHT zusaetzlich der Set-Rabatt -
    // der ist bereits in final_line_price eingerechnet und taucht separat in "Du sparst" auf).
    // upsellSavings: Cent-Betrag "Abonniere & Spare X" fuer NOCH NICHT abonnierte Sets (aggregiert
    // ueber alle Artikel des Sets, siehe getBundleSetUpsellInfo).
    function refillSetGroupMarkup(group, priceSums, upsellSavings) {
      var size = REFILL_SET_SIZE[group.code] || group.items.length;
      var title = size + 'er Set';

      var linesHtml = group.items.map(function (item) {
        return '<li>' + item.quantity + '× ' + item.product_title + '</li>';
      }).join('');

      var wasPriceHtml = priceSums.totalWas > priceSums.totalNow
        ? '<span class="csc-price csc-price--was">' + money(priceSums.totalWas) + '</span>'
        : '';
      var nowPriceHtml = '<span class="csc-price">' + money(priceSums.totalNow) + '</span>';

      var allKeys = group.items.map(function (i) { return i.key; });
      var isFullyAbo = group.items.every(function (i) { return !!i.selling_plan_allocation; });

      var extraStripHtml = '';
      if (isFullyAbo) {
        // Abo-Ersparnis ohne den Set-Bestellrabatt (der gilt auch im Einzelkauf)
        var aboSavings = priceSums.totalWas - (priceSums.totalNow + (priceSums.setDisc || 0));
        if (aboSavings > 0) {
          extraStripHtml =
            '<label class="csc-bundle-upsell">' +
            '<input type="checkbox" class="csc-bundle-upsell-checkbox" checked data-action="switch-set-to-onetime" ' +
            'data-group-keys="' + allKeys.join(',') + '">' +
            // 2026-10-24: angehakt = Status, kein Angebot (vorher "Abonniere & Spare" auch im Abo -> wirkte
            // wie ein erneutes Abo-Angebot; Abwaehlen stellt auf Einzelkauf um)
            '<span>' + (igIsEn() ? '✓ Subscribed · you save ' : '✓ Im Abo · du sparst ') + money(aboSavings) + '</span>' +
            '</label>';
        }
      } else if (upsellSavings > 0) {
        extraStripHtml =
          '<label class="csc-bundle-upsell">' +
          '<input type="checkbox" class="csc-bundle-upsell-checkbox" data-action="switch-set-to-abo" ' +
          'data-group-keys="' + allKeys.join(',') + '">' +
          '<span>💡 Abonniere & Spare ' + money(upsellSavings) + '</span>' +
          '</label>';
      }

      return (
        '<div class="csc-item csc-item--bundle" data-key="' + group.items[0].key + '">' +
        '<div class="csc-bundle-main">' +
        '<div class="csc-item__image"><img src="' + group.items[0].image + '" alt="' + title + '" loading="lazy"></div>' +
        '<div class="csc-item__body">' +
        '<div class="csc-item__title">' + title + '</div>' +
        '<ul class="csc-bundle-sublist">' + linesHtml + '</ul>' +
        '</div>' +
        '</div>' +
        '<div class="csc-bundle-footer-row">' +
        '<div class="csc-bundle-actions">' +
        '<button type="button" class="csc-bundle-icon-btn" data-action="remove-group" data-group-keys="' + allKeys.join(',') + '" aria-label="Entfernen" title="Entfernen">🗑</button>' +
        '</div>' +
        '<div class="csc-item__price-row">' + wasPriceHtml + nowPriceHtml + '</div>' +
        '</div>' +
        extraStripHtml +
        '</div>'
      );
    }

    // priceSums: { totalNow, totalWas } (Cent), Summe ueber Root+Attached-Items (in render()
    // vorberechnet, analog refillSetPriceSums/refillSetGroupMarkup) - Bugfix 2026-09-20 (Christian-
    // Screenshots 30T/90T): vorher zeigte die Karte faelschlich nur den Root-Zeilenpreis (z.B.
    // 18,99€ statt 129,01€ Root+Hardware), obwohl die Unterliste bereits beide Positionen auflistete.
    // upsellSavings: Cent-Betrag "Abonniere & Spare X" fuer OHNE-Abo gekaufte Sets (2-Monats-Vorrat
    // only, per Christian-Vorgabe nicht fuer den 4-Monats-Vorrat - siehe render()), sonst null.
    // 2026-09-29 (Christian-Feedback): der "Bearbeiten"-Stift verlinkte bisher immer auf root.url -
    // root ist aber das Pad-Bundle-Produkt (duplicate_product/additional_variant), ein rein internes
    // Preis-/SKU-Vehikel OHNE eigene Verkaufsseite (kein Flexplan-Template) - Kunden landeten also auf
    // der Pad-Refill-PDP statt auf der Starter-Set-Seite, von der aus sie tatsaechlich gekauft haben.
    // product-form-starter-kit-flexplan.js schreibt seitdem beim Add-to-Cart properties._pdp_url =
    // window.location.pathname auf die Root-Zeile (die echte Starter-Set-PDP-URL). Fallback auf
    // root.url bleibt fuer bereits laufende Carts, die vor diesem Fix hinzugefuegt wurden (haben noch
    // keine _pdp_url-Property), sowie fuer jeden anderen Bundle-Typ, der dieses Property nicht setzt.
    function bundleEditUrl(root) {
      var props = root.properties || {};
      return props._pdp_url || root.url;
    }

    function bundleGroupMarkup(group, priceSums, upsellSavings, flexUpgrade) {
      var root = group.root;
      var attached = group.attached;
      // Geraet (Farbe/Menge): kommt aus dem Attached-Item (Hardware-Produkt), NICHT aus root -
      // root ist seit dem Preis-Split-Redesign das Pad-Bundle, dessen variant_title keine Farbe
      // ist (2026-09-21-Bugfix: deviceColorLabel(root.variant_title) lieferte deshalb bisher immer
      // "" -> Christian-Screenshot zeigte "1× ingarden" ganz ohne Farbe).
      var hardwareItem = attached[0];

      // 2026-09-21 (Christian-Feedback, Cart-Description-Cleanup): Unterliste jetzt 3 Zeilen statt
      // 2 - (1) Geraet mit Farbe, (2) Pad-Bundle mit freundlichem Namen statt Roh-Produkttitel
      // (der bisher 1:1 mit dem Karten-Titel dupliziert war), (3) enthaltene Sorten ("Mit ...").
      // Faellt jede Zeile einzeln auf ihre Rohdaten zurueck, falls die jeweilige Quelle fehlt.
      var deviceLine = hardwareItem
        ? '<li>' + hardwareItem.quantity + '× ingarden ' + deviceColorLabel(hardwareItem.variant_title) + '</li>'
        : '';
      var padLine = '<li>' + root.quantity + '× ' + bundleSetLabel(root.product_title) + '</li>';
      // 2026-09-22 (Christian-Feedback): Sorten-Zeile ("Mit ...") wieder entfernt - "zu viel los"
      // in der Unterliste, gilt fuer alle Plaene. properties._pad_flavors wird von
      // product-form-starter-kit-flexplan.js weiterhin beim Add-to-Cart gesetzt (harmlos, ungenutzt),
      // damit die Zeile bei Bedarf ohne JS-Aenderung wieder eingeschaltet werden kann - hier bleibt
      // sie einfach leer/ungerendert.
      var flavorsLine = '';
      // Etwaige WEITERE Attached-Items ueber das primaere Geraet hinaus (aktuell im Starter-Kit-
      // Flexplan-Flow nie der Fall - addProductsToCart() fuegt genau Pad-Bundle + 1 Hardware-Item
      // hinzu - aber defensiv, damit kuenftige Bundle-Varianten mit mehreren Attached-Items nicht
      // stillschweigend etwas aus der Unterliste verlieren).
      var extraAttachedHtml = attached.slice(1).map(function (a) {
        return '<li>' + a.quantity + '× ' + a.product_title + '</li>';
      }).join('');
      var subListHtml = deviceLine + padLine + flavorsLine + extraAttachedHtml;

      var wasPriceHtml = priceSums.totalWas > priceSums.totalNow
        ? '<span class="csc-price csc-price--was">' + money(priceSums.totalWas) + '</span>'
        : '';
      var nowPriceHtml = '<span class="csc-price">' + money(priceSums.totalNow) + '</span>';

      var allKeys = [root.key].concat(attached.map(function (a) { return a.key; }));

      // 2026-09-23 (Christian-Feedback, Screenshot-Vergleich wearewild): die Bundle-Karte zeigte
      // bisher NUR root.image (Pad-Bundle-Foto) - das Hardware-Item (attached[0]) hat aber ein
      // eigenes, unterschiedliches Produktfoto (siehe Checkout-Beleg: 2 Line-Items, 2 Bilder), das
      // in der Cart-Drawer-Karte bisher komplett unsichtbar war. Fix: 50/50-Split-Thumbnail nach
      // wearewild-Vorbild (links Geraet/Hardware, rechts Pad-Bundle) - gleiche Aussenmasse wie bisher
      // (.csc-item__image bleibt 64x64px, siehe CSS), nur der Inhalt wird bei vorhandenen Bildern
      // beider Seiten zu 2 nebeneinander liegenden object-fit:cover-Bildern (.csc-item__image--split/
      // .csc-item__image-half, siehe cart-drawer-v2.css). Faellt auf das alte Einzelbild (root.image)
      // zurueck, wenn das Hardware-Item fehlt (leeres attached-Array) oder eines der beiden Bilder
      // nicht vorhanden ist - kein kaputtes/halb-leeres Layout in diesem Fall.
      var hasSplitBundleImages = !!(hardwareItem && hardwareItem.image && root.image);
      var bundleImageHtml = hasSplitBundleImages
        ? '<div class="csc-item__image csc-item__image--split">' +
          '<img class="csc-item__image-half" src="' + hardwareItem.image + '" alt="" loading="lazy">' +
          '<img class="csc-item__image-half" src="' + root.image + '" alt="' + (root.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
          '</div>'
        : '<div class="csc-item__image"><img src="' + root.image + '" alt="' + (root.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>';

      // Subscription-Info-Strip: wenn die Gratis-Beigaben einen aktiven Recharge-Subscription-Plan
      // haben (Set "mit Abo" gekauft), zeige die kuenftige Nachfuell-Rate. Datum der ersten
      // Nachfuellung liefert weder Shopify noch Recharge vor Checkout-Abschluss, deshalb bewusst
      // ohne Datum ("ab der 2. Lieferung" statt eines konkreten Kalenderdatums wie bei wearewild).
      var subscriptionTotal = 0;
      var subscriptionPercent = null;
      var subscriptionPlanName = '';
      attached.forEach(function (a) {
        var adj = findOngoingPlanAdjustment(a);
        if (adj) {
          subscriptionTotal += adj.pricePerUnit * a.quantity;
          subscriptionPercent = adj.percent;
          subscriptionPlanName = planLabel(adj.planName);
        }
      });

      var extraStripHtml = '';
      if (subscriptionPercent !== null) {
        extraStripHtml =
          '<div class="csc-bundle-subscription">🔄 <span>' + subscriptionPlanName + ' – ab der 2. Lieferung ca. ' +
          money(subscriptionTotal) + ' (-' + subscriptionPercent + '%)</span></div>';
      } else if (upsellSavings > 0) {
        // Anklickbar (wie wearewild "Subscribe & Save"-Checkbox): tauscht die Gruppe live gegen die
        // "mit Abo"-Variante desselben Sets/derselben Farbe aus, siehe switchGroupToSubscription().
        extraStripHtml =
          '<label class="csc-bundle-upsell">' +
          '<input type="checkbox" class="csc-bundle-upsell-checkbox" data-action="switch-to-abo" ' +
          'data-group-keys="' + allKeys.join(',') + '" data-handle="' + root.handle + '" ' +
          'data-root-variant-id="' + root.variant_id + '" data-root-quantity="' + root.quantity + '">' +
          '<span>💡 Abonniere & Spare ' + money(upsellSavings) + '</span>' +
          '</label>';
      }
      // 2026-10-23: Upgrade 1-Monats- -> 3-Monats-Vorrat (Optik wie grown-Upgrade-Button).
      // R8: wiederkehrende Abbuchung schon im Cart nennen (Checkout zeigt "Wiederkehrende
      // Zwischensumme") - Flexplan-Plan haengt an der Pad-Zeile (root), Geraet ist Einmalkauf.
      if (subscriptionPercent === null && root.selling_plan_allocation) {
        var rSpa = root.selling_plan_allocation;
        var rName = (rSpa.selling_plan && rSpa.selling_plan.name) || '';
        var rAdj = findOngoingPlanAdjustment(root);
        var rUnit = rAdj ? rAdj.pricePerUnit : rSpa.price;
        var rMonths = null;
        var mDays = rName.match(/(\d+)-(Tage|Day)/i);
        var mMon = rName.match(/(\d+)-(Monat|Month)/i);
        if (mDays) rMonths = Math.round(parseInt(mDays[1], 10) / 30);
        else if (mMon) rMonths = parseInt(mMon[1], 10);
        var en = igIsEn();
        var rInterval = rMonths === 1 ? (en ? 'every month' : 'jeden Monat')
          : rMonths ? (en ? 'every ' + rMonths + ' months' : 'alle ' + rMonths + ' Monate') : planLabel(rName);
        if (rUnit) {
          // R9 (Christian): Vorteil ggue. Einzelkauf derselben Pads nennen (Anknuepfungspunkt "guter Deal").
          // Vergleich = aktueller Einzelkaufpreis der Pad-Variante (kein frueherer Preis).
          var rOne = parseInt(rSpa.compare_at_price || root.original_price || 0, 10);
          var rPct = rOne > rUnit ? Math.round((1 - rUnit / rOne) * 100) : 0;
          var rNow = money(rUnit * root.quantity);
          var rWas = rPct >= 5 ? money(rOne * root.quantity) : '';
          extraStripHtml += '<div class="csc-bundle-subscription">🔄 <span>' +
            (en ? 'Pads then ' + rInterval + ' <strong>' + rNow + '</strong>' + (rWas ? ' instead of ' + rWas + ' one-off <strong>(−' + rPct + ' %)</strong>' : '') + ' · device one-time'
                : 'Pads danach ' + rInterval + ' <strong>' + rNow + '</strong>' + (rWas ? ' statt ' + rWas + ' einzeln <strong>(−' + rPct + ' %)</strong>' : '') + ' · Gerät einmalig') +
            '</span></div>';
        }
      }
      if (flexUpgrade) extraStripHtml += flexUpgradeButtonHtml(root.key, flexUpgrade);

      return (
        '<div class="csc-item csc-item--bundle" data-key="' + root.key + '">' +
        '<div class="csc-bundle-main">' +
        bundleImageHtml +
        '<div class="csc-item__body">' +
        '<div class="csc-item__title">' + bundleSetLabel(root.product_title) + '</div>' +
        '<ul class="csc-bundle-sublist">' + subListHtml + '</ul>' +
        '</div>' +
        '</div>' +
        '<div class="csc-bundle-footer-row">' +
        '<div class="csc-bundle-actions">' +
        '<button type="button" class="csc-bundle-icon-btn" data-action="remove-group" data-group-keys="' + allKeys.join(',') + '" aria-label="Entfernen" title="Entfernen">🗑</button>' +
        '<a href="' + bundleEditUrl(root) + '" class="csc-bundle-icon-btn" aria-label="Bearbeiten" title="Bearbeiten">✎</a>' +
        '</div>' +
        '<div class="csc-item__price-row">' + wasPriceHtml + nowPriceHtml + '</div>' +
        '</div>' +
        extraStripHtml +
        '</div>'
      );
    }

    async function render() {
      var cart = await fetchCart();
      var cleaned = await cleanupOrphanedBundles(cart);
      if (cleaned) cart = await fetchCart();

      var isNeukunde = isNeukundeCart(cart);
      lastCartCtx = {
        segment: isNeukunde ? (isAboStarterCart(cart) ? 'neukunde_abo' : 'neukunde_einmal') : 'returning',
        subtotal: cart.items_subtotal_price / 100,
        items: cart.item_count,
        has_grown: cart.items.some(isGrownItem),
        has_upgrade: cart.items.some(function (it) { return !!(it.properties || {})._plan_upgrade; }),
      };

      var giftsResynced = await syncProgressGifts(cart, isNeukunde);
      if (giftsResynced) cart = await fetchCart();

      var grownGiftResynced = await syncGrownGift(cart);
      if (grownGiftResynced) cart = await fetchCart();
      var grownOnly = isGrownOnlyCart(cart);
      // Nicht-EUR: Streichpreis/"Du sparst"-Wert des Gratis-Loeffels = echter Preis des regulaeren
      // Dosierloeffels in Landeswaehrung (statt fixer 9,99 EUR). Nicht ladbar -> 0 (wird ausgeblendet).
      if (!IG_IS_EUR && !GROWN_GIFT_VALUE_CENTS && cart.items.some(isGrownGiftItem)) {
        var spoonProduct = await getProductByHandleLocal(GROWN_SPOON_HANDLE);
        var spoonVariant = spoonProduct && ((spoonProduct.variants || []).find(function (v) { return v.id === GROWN_SPOON_VARIANT_ID; }) || (spoonProduct.variants || [])[0]);
        if (spoonVariant) GROWN_GIFT_VALUE_CENTS = parseInt(spoonVariant.price, 10) || 0;
      }

      var discountResynced = await syncProgressDiscount(cart, isNeukunde);
      if (discountResynced) return; // applyDiscountCodes hat render() bereits mit dem neuen Stand erneut aufgerufen

      var bestsellerResynced = await syncBestsellerDiscount(cart, isNeukunde);
      if (bestsellerResynced) return; // dito

      var legacyLockItem = findLegacyLockItem(cart);
      var compareAtLinePrices = await Promise.all(cart.items.map(function (item) {
        return getCompareAtLinePrice(item);
      }));
      var compareAtByKey = {};
      cart.items.forEach(function (item, idx) {
        compareAtByKey[item.key] = compareAtLinePrices[idx];
      });

      // StarterSet-Bundles (bundle_root/bundle_attached_to) werden als EINE kombinierte Karte
      // gerendert; ihre Attached-Items werden dabei uebersprungen (erscheinen nur als Unterliste
      // in der Bundle-Karte). Alle anderen Zeilen (inkl. _bundle-Kennenlern-Set) laufen wie bisher
      // ueber itemMarkup. Siehe buildBundleGroups/bundleGroupMarkup weiter oben.
      var bundleGroups = buildBundleGroups(cart);
      var renderedRootGroups = {};
      var attachedKeys = {};
      Object.keys(bundleGroups).forEach(function (groupName) {
        bundleGroups[groupName].attached.forEach(function (a) {
          attachedKeys[a.key] = true;
        });
      });

      // "Abonniere & Spare X": nur relevant, wenn das Set OHNE Abo gekauft wurde (Gratis-Beigaben
      // ohne Recharge-Subscription-Plan). Ermittelt ueber die PDP der Root-Zeile, welche
      // Variante/Farbe im Vergleich zum "Mit Abonnement"-Produkt wie viel kosten wuerde. Fuer den
      // 4-Monats-Vorrat (kein Abo-Pendant vorhanden) liefert data.original_product_variants keinen
      // Treffer fuer die aktuelle variant_id, dann bleibt upsellSavings 0/nicht gesetzt.
      var bundleUpsellSavings = {};
      await Promise.all(Object.keys(bundleGroups).map(async function (groupName) {
        var g = bundleGroups[groupName];
        if (!g.root) return;
        var hasSubscriptionAttached = g.attached.some(function (a) { return !!a.selling_plan_allocation; });
        if (hasSubscriptionAttached) return;
        var data = await getStarterSetSubscriptionData(g.root.handle);
        if (!data || !data.original_product_variants || !data.duplicate_product || !data.duplicate_product.variants) return;
        // WICHTIG (von Christian am 2026-09-16 gemeldet, per Live-Test bestaetigt): das
        // "starter-set-subscription-data"-Script ist relativ zur jeweils aktuell betrachteten PDP
        // aufgebaut - original_product_variants ist deshalb einfach "die Varianten DIESES Produkts",
        // nicht zwingend das 2-Monats-ohne-Abo-Produkt. Auf der 4-Monats-Vorrat-PDP selbst matcht die
        // Root-Variante also faelschlich sich selbst in original_product_variants und wuerde einen
        // Abo-Hinweis mit dem (viel guenstigeren) 2-Monats-Abo-Preis auslösen, obwohl es gar kein
        // 4-Monats-Abo gibt. Deshalb: 4-Monats-Vorrat-Produkte (erkannt ueber additional_variant.product_id)
        // explizit ausschliessen, bevor ueberhaupt versucht wird zu matchen.
        if (data.additional_variant && data.additional_variant.product_id === g.root.product_id) return;
        var rootVariant = data.original_product_variants.find(function (v) { return v.id === g.root.variant_id; });
        if (!rootVariant) return; // z.B. 4-Monats-Vorrat: kein Abo-Pendant, kein Upsell-Hinweis
        var aboVariant = data.duplicate_product.variants.find(function (v) { return v.option1 === rootVariant.option1; });
        if (!aboVariant) return;
        var savings = rootVariant.price - aboVariant.price;
        if (savings > 0) bundleUpsellSavings[groupName] = savings;
      }));

      // Preis-Summe fuer die kombinierte Bundle-Karte (Root + alle Attached-Items, z.B. Pad-Bundle +
      // Hardware) - Bugfix 2026-09-20 (Christian-Screenshots 30T/90T-Cart-Drawer): die Karte zeigte
      // vorher nur root.final_line_price (Pad-Bundle-Preis), obwohl die Unterliste bereits Pad-
      // Bundle + Hardware auflistete; Zwischensumme/Gesamt waren stets korrekt (Anzeige-Bug, kein
      // Abrechnungs-Bug). "was" nutzt denselben Streichpreis-Vorrang wie bei einzelnen Refill-Zeilen
      // (Plan-Compare-at > allgemeiner Compare-at > kein Unterschied), analog refillSetPriceSums.
      var bundlePriceSums = {};
      Object.keys(bundleGroups).forEach(function (groupName) {
        var g = bundleGroups[groupName];
        if (!g.root) return;
        var groupItems = [g.root].concat(g.attached);
        var totalNow = 0;
        var totalWas = 0;
        groupItems.forEach(function (item) {
          totalNow += item.final_line_price;
          var planWas = getPlanCompareAtLinePrice(item);
          if (planWas) {
            totalWas += planWas;
          } else if (compareAtByKey[item.key]) {
            totalWas += compareAtByKey[item.key];
          } else {
            totalWas += item.final_line_price;
          }
        });
        bundlePriceSums[groupName] = { totalNow: totalNow, totalWas: totalWas };
      });

      // Refill-Produkte (Nicht-Bundle-Zeilen): "Abonniere & Spare X", nur wenn OHNE aktives Abo
      // gekauft (siehe getRefillUpsellInfo oben). Bundle-Root- und Attached-Zeilen werden hier
      // bewusst ausgeschlossen (haben ihre eigene Upsell-Logik/Darstellung, s.o.), ebenso gesperrte/
      // Gratis-Zeilen und Zeilen, die bereits ein laufendes Abo haben.
      // Refill-Bundle-Builder-Sets (5er/7er/14er, siehe buildRefillSetGroups oben): werden wie die
      // StarterSet-Bundles als EINE Karte pro Set gerendert statt als Einzelzeilen. Aggregierte
      // Preis-Summen + "Abonniere & Spare"-Ersparnis werden hier vorberechnet, damit
      // refillSetGroupMarkup() reine Darstellungslogik bleibt (siehe dortige Kommentare).
      var refillSetGroups = buildRefillSetGroups(cart);
      var refillSetKeys = {};
      refillSetGroups.forEach(function (g) {
        g.items.forEach(function (it) { refillSetKeys[it.key] = g; });
      });

      var refillSetPriceSums = {};
      refillSetGroups.forEach(function (g) {
        var totalNow = 0;
        var totalWas = 0;
        g.items.forEach(function (item) {
          totalNow += item.final_line_price;
          var planWas = getPlanCompareAtLinePrice(item);
          if (planWas) {
            totalWas += planWas;
          } else if (compareAtByKey[item.key]) {
            totalWas += compareAtByKey[item.key];
          } else {
            totalWas += item.final_line_price;
          }
        });
        // 5SET ist ein Zeilenrabatt (steckt in final_line_price) -> als Set-Rabatt merken, damit die
        // Abo-Ersparnis im Warenkorb ihn nicht mitzaehlt (sonst 5er-Abo "du sparst 55,65" statt 45,65)
        var lineSetDisc = 0;
        g.items.forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (a) {
            var t = a.discount_application && (a.discount_application.title || a.discount_application.code);
            if (REFILL_SET_CODES.indexOf(t) !== -1) lineSetDisc += a.amount || 0;
          });
        });
        refillSetPriceSums[g.key] = { totalNow: totalNow, totalWas: totalWas, setDisc: lineSetDisc };
      });
      // 2026-10-24: 7SET/14SET sind Bestellrabatte (cart_level), nicht in final_line_price enthalten.
      // Damit die Set-Karte denselben Preis zeigt wie Kasse/Builder, den Betrag der ersten Gruppe mit
      // diesem Code abziehen (5SET ist ein Zeilenrabatt und steckt bereits in final_line_price).
      (cart.cart_level_discount_applications || []).forEach(function (app) {
        var code = app.title || app.code;
        if (REFILL_SET_CODES.indexOf(code) === -1) return;
        var target = refillSetGroups.find(function (g) { return g.code === code; });
        if (target && refillSetPriceSums[target.key]) {
          var amt = app.total_allocated_amount || 0;
          refillSetPriceSums[target.key].totalNow = Math.max(0, refillSetPriceSums[target.key].totalNow - amt);
          refillSetPriceSums[target.key].setDisc = (refillSetPriceSums[target.key].setDisc || 0) + amt;
        }
      });

      var refillSetUpsellSavings = {};
      await Promise.all(refillSetGroups.map(async function (g) {
        var isFullyAbo = g.items.every(function (it) { return !!it.selling_plan_allocation; });
        if (isFullyAbo) return;
        var infos = await Promise.all(g.items.map(function (it) {
          return it.selling_plan_allocation ? null : getBundleSetUpsellInfo(it);
        }));
        var total = 0;
        infos.forEach(function (info) { if (info) total += info.savings; });
        if (total > 0) refillSetUpsellSavings[g.key] = total;
      }));

      var itemUpsellInfo = {};
      await Promise.all(cart.items.map(async function (item) {
        if (attachedKeys[item.key]) return;
        if (refillSetKeys[item.key]) return;
        var props = item.properties || {};
        if (props.bundle_root) return;
        if (props[BESTSELLER_UPSELL_PROPERTY]) return; // Runde 24: kein Abo-Hinweis auf Bestseller-Upsell-Zeilen
        var flags = computeFlags(item, legacyLockItem);
        if (flags.locked || flags.free) return;
        if (props[GROWN_UPSELL_PROPERTY]) return; // 2026-10-23: grown-Cart-Upsell bleibt Einmalkauf
        if (props[PROGRESS_GIFT_PROPERTY] || props[GROWN_GIFT_PROPERTY] || props._bundle) return; // R6: nie Abo-Hinweis auf Geschenken
        if (isGrownItem(item)) {
          var gInfo = await getGrownUpsellInfo(item);
          if (gInfo) itemUpsellInfo[item.key] = gInfo;
          return;
        }
        if (findOngoingPlanAdjustment(item)) return;
        var info = await getRefillUpsellInfo(item);
        if (info) itemUpsellInfo[item.key] = info;
      }));

      // R5 (Performance): Upgrade-Daten werden nicht mehr abgewartet - vorher blockierte der
      // PDP-HTML-Fetch (~0,4 s, mobil mehr) das Anzeigen der Artikel. Bekannte Infos aus dem
      // letzten Render werden sofort genutzt, neue per DOM-Patch nachgereicht.
      var flexPrev = flexUpgradeByKey;
      flexUpgradeByKey = {};
      var flexJobs = [];
      if (!isAnnualCart(cart)) {
        Object.keys(bundleGroups).forEach(function (groupName) {
          var g = bundleGroups[groupName];
          if (!g.root || !bundlePriceSums[groupName] || !isFlex30Root(g.root)) return;
          if (flexPrev[g.root.key]) flexUpgradeByKey[g.root.key] = flexPrev[g.root.key];
          flexJobs.push({ group: g, sums: bundlePriceSums[groupName] });
        });
      }

      var renderedRefillSetGroups = {};
      // R6 (UX): Starter-Set immer oben, dann bezahlte Artikel, Geschenke/Gratis-Beigaben zuletzt -
      // Shopify liefert neueste Zeilen zuerst, dadurch stand das Set nach jedem Upsell ganz unten.
      function itemRank(it) {
        var pr = it.properties || {};
        if (pr.bundle_root || pr.bundle_attached_to) return 0;
        if (pr[PROGRESS_GIFT_PROPERTY] || pr[GROWN_GIFT_PROPERTY] || it.final_line_price === 0) return 3;
        if (pr.bundle) return 1;
        return 2;
      }
      var orderedItems = cart.items.slice().sort(function (a, b) { return itemRank(a) - itemRank(b); });
      itemsEl.innerHTML = cart.items.length
        ? orderedItems.map(function (item) {
            var props = item.properties || {};
            if (attachedKeys[item.key]) return '';
            if (refillSetKeys[item.key]) {
              var rsGroup = refillSetKeys[item.key];
              if (renderedRefillSetGroups[rsGroup.key]) return '';
              renderedRefillSetGroups[rsGroup.key] = true;
              return refillSetGroupMarkup(rsGroup, refillSetPriceSums[rsGroup.key], refillSetUpsellSavings[rsGroup.key]);
            }
            var rootGroupKey = props.bundle_root ? props.bundle_root + '|' + (props._bundle_instance || '') : null;
            if (rootGroupKey && bundleGroups[rootGroupKey] && bundleGroups[rootGroupKey].root) {
              if (renderedRootGroups[rootGroupKey]) return '';
              renderedRootGroups[rootGroupKey] = true;
              return bundleGroupMarkup(bundleGroups[rootGroupKey], bundlePriceSums[rootGroupKey], bundleUpsellSavings[rootGroupKey], flexUpgradeByKey[bundleGroups[rootGroupKey].root.key]);
            }
            return itemMarkup(item, computeFlags(item, legacyLockItem), compareAtByKey[item.key], itemUpsellInfo[item.key]);
          }).join('')
        : '<div class="csc-empty">Dein Warenkorb ist leer.</div>';
      if (!cart.items.length) {
        var emptyHtml = await emptyStateMarkup();
        itemsEl.innerHTML = emptyHtml;
      }
      lastGiftKeys = {};
      cart.items.forEach(function (it) { if ((it.properties || {})[PROGRESS_GIFT_PROPERTY]) lastGiftKeys[it.key] = true; });

      flexJobs.forEach(function (job) {
        getFlexUpgradeInfo(job.group, job.sums).then(function (fu) {
          var rk = job.group.root.key;
          if (!fu) { delete flexUpgradeByKey[rk]; return; }
          flexUpgradeByKey[rk] = fu;
          var card = itemsEl.querySelector('.csc-item--bundle[data-key="' + rk + '"]');
          if (card && !card.querySelector('[data-action="flex-upgrade"]')) card.insertAdjacentHTML('beforeend', flexUpgradeButtonHtml(rk, fu));
        }).catch(function () {});
      });

      // WICHTIG (Bugfix 2026-09-16, von Christian gemeldet): cart.items_subtotal_price enthaelt
      // zwar Zeilen-Rabatte, aber KEINE Cart-Level-Rabattcodes (z.B. STAMMKUNDE15) - die Anzeige
      // "Summe" blieb dadurch trotz angewendetem 15%-Code unveraendert (119,94€ statt 101,95€),
      // obwohl "Du sparst €17,99" korrekt berechnet wurde. cart.total_price ist Shopifys Feld fuer
      // "was der Kunde tatsaechlich zahlt" (nach ALLEN Rabatten, inkl. Codes) - das gehoert in die
      // Summe-Anzeige. items_subtotal_price bleibt bewusst die Berechnungsbasis fuer Versand-
      // Schwelle/Progress-Bar (Rohwert vor Rabattcodes, unveraendert).
      // Runde 18 (Christian-Wunsch, Wild-Referenz): die Summe steht jetzt direkt im Checkout-Button
      // statt in einer eigenen "Summe"-Zeile ueber dem Footer - die separate Zeile entfaellt dadurch
      // komplett (spart eine ganze Fusszeile Platz).
      checkoutLinkEl.innerHTML = (cart.items.length ? moneyPlain(cart.total_price) + ' &middot; ' : '') + 'Jetzt sicher zur Kasse';
      if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      // "Du hast X Produkte"-Zeile (Wild-Referenz, Christian-Wunsch): sitzt oben im scrollbaren
      // Cart-Body, zusaetzlich zur Anzahl im Drawer-Header.
      if (itemsCountEl) {
        itemsCountEl.textContent = cart.items.length
          ? 'Du hast ' + cart.item_count + (cart.item_count === 1 ? ' Produkt' : ' Produkte') + ' im Warenkorb'
          : '';
      }

      // Runde 23 (Christian-Wunsch): "Empfehlung eines Freundes" darf nur Neukunden angeboten
      // werden (Referral-Programm gilt nur fuer Erstkaeufer) - im Returning-Cart deshalb nur
      // "Rabattcode" als Toggle-Label anzeigen, im Neukunden-Cart bleibt der bisherige Text.
      if (discountToggleLabelEl) {
        // R8: dezenter Textlink statt auffaelliger Frage (weniger "Code-Suche" ausserhalb des Shops)
        discountToggleLabelEl.textContent = igIsEn() ? 'Redeem code' : 'Code einlösen';
      }

      // Lieferzeilen-Info (wie snocks-Referenz): nur ab der Gratis-Versand-Schwelle anzeigen, jetzt
      // mit echtem berechnetem Lieferdatum statt statischem Text (Christian-Wunsch 2026-09-16),
      // siehe deliveryEstimateText()/addDeliveryDays() oben.
      if (trustReturnsEl) trustReturnsEl.textContent = returnPeriodText(cart);
      // 2026-10-24: Shopify prueft die Gratis-Versand-Grenze NACH Rabatten (cart.total_price) - vorher
      // zeigte z.B. ein 7er-Abo-Set (75,47 - 30 = 45,47) "Kostenlos", an der Kasse kamen 3,80 dazu.
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
        shippingLineEl.innerHTML = '<span>' + deliveryEstimateText(cart) + '</span><span class="csc-shipping-line__free">Kostenlos</span>';
        shippingLineEl.hidden = false;
      } else {
        shippingLineEl.innerHTML = '';
        shippingLineEl.hidden = true;
      }

      // Progress-Bar (Phase 3): Neukunden- oder Returning-Meilensteine, siehe progressState() oben.
      // 2026-10-24 (Option A): Returning-Cart mit Builder-Set bekommt keine Stammkunden-Staffel ->
      // Balken zeigt nur das Versandziel, gemessen am Betrag nach Rabatt (wie Shopify rechnet).
      // Fuer alle anderen Returning-Carts zaehlt der Versand-Meilenstein ebenfalls nach Rabatt.
      var progressSetCart = !isNeukunde && !isZgoCart(cart) && !isGrownOnlyCart(cart) && !!refillSetCodeForCart(cart);
      var progress = progressSetCart
        ? progressState(isNeukunde, cart.total_price, isDuoCart(cart), progressTiers(false, false).filter(function (t) { return t.label === 'Gratis Versand'; }))
        : progressState(isNeukunde, cart.items_subtotal_price, isDuoCart(cart), null, isNeukunde ? null : cart.total_price);
      var giftsHtml = '';
      var annualCart = isAnnualCart(cart);
      if (isNeukunde && !annualCart) {
        // Bild/Preis fuer die Goodie-Karte vorladen (Runde 13) - ueber dieselbe gecachte
        // getProductByHandle()-Funktion wie die Streichpreis-Lookups weiter oben.
        var giftProductsByAmount = {};
        await Promise.all(progressTiers(true, isDuoCart(cart)).filter(function (t) { return t.giftVariantId; }).map(async function (t) {
          giftProductsByAmount[t.amount] = await getProductByHandle(t.giftHandle);
        }));
        giftsHtml = progressGiftsMarkup(cart, cart.items_subtotal_price, giftProductsByAmount);
      }

      // "🌱 Probiere unsere Minis"-Upsell (Runde 17): auf BEIDEN Bars sichtbar (Christian-
      // Entscheidung). Runde 20 (Christian-Wunsch): bleibt jetzt AUCH sichtbar, wenn bereits alle
      // Meilensteine erreicht sind - anders als die Goodie-Klaim-Karte ist der Minis-Upsell kein
      // Progress-Bar-Reward, sondern ein reiner Zusatzverkauf ohne Bezug zur Schwelle, das
      // Verstecken sparte hier also keinen sinnvollen Platz, nur eine funktionierende Upsell-Flaeche.
      var minisHtml = '';
      if (grownOnly && !cart.items.some(function (it) { return isGrownGiftItem(it) || it.variant_id === GROWN_SPOON_VARIANT_ID; })) {
        minisHtml = grownSpoonUpsellMarkup(await getProductByHandleLocal(GROWN_SPOON_HANDLE));
      }
      if (cart.items.length && !grownOnly) {
        var miniProductsData = await Promise.all(MINI_PRODUCTS.map(async function (p) {
          return { title: p.title, variety: p.variety, data: await getProductByHandle(p.handle) };
        }));
        if (isNeukunde) {
          // 2026-10-23 (Christian): grown-Karte zuerst (nur solange kein grown im Cart liegt), dann
          // Abo-Carts nur Minis (keine Bestseller-Refills, Overstock), Einmalkauf-Carts wie bisher
          // Bestseller Sorten & Minis.
          var grownHtml = '';
          if (grownUpsellAllowed() && !cart.items.some(isGrownItem)) {
            var gp3 = await Promise.all([
              getProductByHandleLocal(GROWN_UPSELL_PRODUCTS.d3.handle),
              getProductByHandleLocal(GROWN_UPSELL_PRODUCTS.b.handle),
              getProductByHandleLocal(GROWN_SPOON_HANDLE),
            ]);
            // 29.10.2026: Nicht-EUR (CHF/SEK/DKK) - Loeffelwert in Landeswaehrung aus dem regulaeren Dosierloeffel
            if (!GROWN_GIFT_VALUE_CENTS && gp3[2]) {
              var gsv = (gp3[2].variants || []).find(function (v) { return v.id === GROWN_SPOON_VARIANT_ID; }) || (gp3[2].variants || [])[0];
              if (gsv) GROWN_GIFT_VALUE_CENTS = parseInt(gsv.price, 10) || 0;
            }
            grownHtml = grownUpsellMarkup({ d3: gp3[0], b: gp3[1] }, GROWN_GIFT_VALUE_CENTS, gp3[2]);
          }
          if (isAboStarterCart(cart) || isMultiSetCart(cart)) {
            minisHtml = grownHtml + miniUpsellMarkup(miniProductsData);
          } else {
            // Runde 24 (Christian-Wunsch, Scope: nur Neukunden-Cart): Bestseller-Sorten zusaetzlich
            // zu den Minis, in einer gemeinsamen Rail (siehe combinedUpsellMarkup oben).
            var bestsellerProductsData = await Promise.all(BESTSELLER_PRODUCTS.map(async function (p) {
              var product = await getProductByHandle(p.handle);
              var variant = product && (product.variants || []).find(function (v) { return v.id === p.variantId; });
              return { title: p.title, variety: p.variety, targetPriceCents: p.targetPriceCents, data: product, variant: variant };
            }));
            minisHtml = grownHtml + combinedUpsellMarkup(bestsellerProductsData, miniProductsData);
          }
        } else {
          // 2026-10-15: Dochte (Zubehoer) nur im Returning-Cart, siehe ACCESSORY_PRODUCTS.
          var accessoryData = await Promise.all(ACCESSORY_PRODUCTS.map(async function (p) {
            var product = await getProductByHandle(p.handle);
            var variant = product && (product.variants || []).find(function (v) { return v.id === p.variantId; });
            return { title: p.title, variety: p.variety, data: variant ? product : null, variant: variant, action: 'add-accessory' };
          }));
          minisHtml = miniUpsellMarkup(miniProductsData, accessoryData);
        }
      }

      // Zweitgeraet-Aktion: statt Returning-Meilensteinen (STAMMKUNDE-Codes sind hier aus, s.o.) ein
      // Treuepreis-Hinweis, Upsells bleiben.
      var progressHtml = (annualCart || grownOnly)
        ? ''
        : (!isNeukunde && isZgoCart(cart))
        ? '<div class="csc-progress__headline">💚 Dein Treuepreis für das Zweitgerät ist reserviert</div>'
        : progressMarkup(progress);
      progressEl.innerHTML = progressHtml + giftsHtml;
      progressEl.hidden = cart.items.length === 0 || !progressEl.innerHTML.trim();
      upsellEl.innerHTML = cart.items.length ? minisHtml : '';
      upsellEl.hidden = !upsellEl.innerHTML.trim();
      animateProgress();
      applyPendingFeedback(cart);

      // Trust-Zeile unter dem CTA: bei reinem Grown-Cart "Kündige jederzeit" statt Geraete-Garantie
      var trustLast = document.querySelector('#csc-drawer-v2 .csc-trust-line > span:last-child');
      if (trustLast) {
        if (!trustLast.dataset.defaultText) trustLast.dataset.defaultText = trustLast.textContent;
        trustLast.textContent = grownOnly ? 'Kündige jederzeit' : trustLast.dataset.defaultText;
      }
      // R11 (Christian): bei Flexplan-Abo 1/3 Monate "Jederzeit kündbar" direkt am Checkout-Button
      // (gleiches Versprechen wie auf der PDP). Keine neue Zeile: Trust-Zeile wird dreiteilig und kuerzer.
      var flexCancelable = !grownOnly && cart.items.some(function (it) {
        var pr = it.properties || {};
        var nm = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) || '';
        return !!pr.bundle_root && /(30-Tage|90-Tage|1-Monat|3-Monat|30-Day|90-Day|1-Month|3-Month)/i.test(nm);
      });
      var trustLine = document.querySelector('#csc-drawer-v2 .csc-trust-line');
      if (trustLine && trustLast) {
        var cancelEl = trustLine.querySelector('.csc-trust-cancel');
        if (flexCancelable && !cancelEl) {
          var sep2 = document.createElement('span'); sep2.className = 'csc-trust-line__sep csc-trust-cancel-sep'; sep2.textContent = '|';
          cancelEl = document.createElement('span'); cancelEl.className = 'csc-trust-cancel';
          trustLine.insertBefore(cancelEl, trustLast); trustLine.insertBefore(sep2, trustLast);
        }
        if (cancelEl) {
          var sepEl = trustLine.querySelector('.csc-trust-cancel-sep');
          cancelEl.hidden = !flexCancelable; if (sepEl) sepEl.hidden = !flexCancelable;
          cancelEl.textContent = igIsEn() ? 'Cancel anytime' : 'Jederzeit kündbar';
        }
        if (flexCancelable) {
          if (trustReturnsEl) trustReturnsEl.textContent = (igIsEn() ? '100-day trial' : (/^100/.test(returnPeriodText(cart)) ? '100 Tage testen' : '45 Tage Rückgabe'));
          trustLast.textContent = igIsEn() ? 'Lifetime warranty' : 'Lebenslange Garantie';
        }
        trustLine.classList.toggle('csc-trust-line--3', flexCancelable);
      }

      discountsEl.innerHTML = discountsMarkup(buildDiscountRows(cart), cart);

      // "Du sparst"-Betrag: automatische/Code-Rabatte (cart.total_discount, z.B. Gratis-Beigabe)
      // PLUS Streichpreis-Ersparnis der reg. bezahlten Zeilen (compareAtLinePrice - final_line_price).
      // Gratis-Zeilen (flags.free) werden hier bewusst ausgeschlossen, da ihre Ersparnis schon ueber
      // total_discount erfasst ist (sonst wuerde doppelt gezaehlt). Gewuenscht von Christian, damit
      // z.B. beim Kennenlern-Set (Streichpreis-Rabatt) + Gratis-Beigabe beide Anteile zusammen
      // angezeigt werden statt nur des automatischen Rabatts.
      // Refill-Abo-Streichpreis (2026-09-16, Christian-Wunsch: Savings sollen auch unten bei der
      // Summe auftauchen): fuer Zeilen mit aktivem Subscription-Plan zaehlt der Plan-Streichpreis
      // (getPlanCompareAtLinePrice), nicht der allgemeine Produkt-Compare-at - sonst wuerde je nach
      // Zufall doppelt oder gar nicht gezaehlt. Gesperrte (Bundle-)Zeilen bewusst ausgenommen -
      // Starter-Sets haben ihre eigene, unveraenderte Darstellung/Berechnung.
      var compareAtSavings = 0;
      cart.items.forEach(function (item, idx) {
        var flags = computeFlags(item, legacyLockItem);
        // Runde 42 (2026-10-05): Attached-Zeilen eines Starter-Set-Bundles (v.a. die Hardware)
        // zaehlen jetzt mit - die Bundle-Karte zeigt ihren Streichpreis ohnehin schon im
        // Karten-Streichpreis (bundlePriceSums.totalWas). Vorher fehlte dieser Anteil in
        // "Du sparst"/Zwischensumme (Duo 90T: Cart 72€ statt PDP 100€). Legacy-gesperrte Zeilen
        // bleiben weiterhin ausgenommen.
        var countAttached = flags.locked && attachedKeys[item.key] &&
          !(legacyLockItem && item.product_id !== legacyLockItem.product_id);
        // 2026-10-21 ingarden grown: Gratis-Loeffel ist ein 0-EUR-Produkt (kein Rabatt in
        // total_discount) - sein Wert (9,99) zaehlt deshalb hier explizit zur "Du sparst"-Summe.
        if (flags.grownGift) {
          compareAtSavings += GROWN_GIFT_VALUE_CENTS * item.quantity;
          return;
        }
        if (flags.free || (flags.locked && !countAttached)) return;
        var adj = findOngoingPlanAdjustment(item);
        if (adj) {
          var planCompareAt = getPlanCompareAtLinePrice(item);
          if (planCompareAt) {
            compareAtSavings += planCompareAt - item.final_line_price;
            return;
          }
          // Runde 37 (Bugfix, 2026-09-18, Christian gemeldet): frueher endete die Zeile hier per
          // return, sobald ein Abo aktiv war - auch wenn der Abo-eigene Streichpreis fehlte (z.B.
          // Selling Plan ohne eigenen compare_at_price). Dadurch fiel die Zeile komplett aus der
          // "Du sparst"-Summe/Zwischensumme heraus, obwohl auf der Zeile selbst (itemMarkup
          // wasPriceHtml) laengst korrekt der allgemeine Produkt-Streichpreis als Fallback
          // angezeigt wurde ("Herbst-Vorrat" Beispiel: 89,50€ -> 49,50€ am Artikel sichtbar, aber
          // nicht in der Summe). Fix: kein fruehes return mehr - faellt wie itemMarkup() auf den
          // allgemeinen compareAtLinePrices-Wert weiter unten zurueck, wenn kein Abo-eigener
          // Streichpreis vorhanden ist. Aendert keine Preise/Rabatte, nur die "Du sparst"-Anzeige.
        }
        var compareAt = compareAtLinePrices[idx];
        if (compareAt) {
          compareAtSavings += compareAt - item.final_line_price;
        }
      });
      var totalSavings = cart.total_discount + compareAtSavings;
      // Runde 18 (Christian-Wunsch, Wild-Referenz "Total Savings"-Banner): eigene hervorgehobene
      // Zeile im Footer statt kleinem Inline-Text neben der (jetzt entfernten) Summe-Zeile.
      if (totalSavings > 0) {
        savingsAmountEl.innerHTML = money(totalSavings);
        savingsBannerEl.hidden = false;
      } else {
        savingsBannerEl.hidden = true;
      }

      // Runde 19 (Christian-Wunsch, Wild-Referenz Screenshot 4): sichtbare Summen-Aufschluesselung
      // im Cart-Body (Zwischensumme/Ersparnis/Gesamt), zusaetzlich zur Summe im Checkout-Button -
      // "man sieht die Summe im Cart nicht". Zwischensumme = Gesamt + Ersparnis (rueckgerechnet),
      // damit die drei Zeilen immer konsistent aufgehen, unabhaengig davon, ob die Ersparnis aus
      // Rabattcodes, automatischen Rabatten oder Streichpreisen stammt.
      if (summaryBreakdownEl) {
        summaryBreakdownEl.hidden = cart.items.length === 0;
        summarySubtotalEl.innerHTML = money(cart.total_price + totalSavings);
        summaryTotalEl.innerHTML = money(cart.total_price);
        if (totalSavings > 0) {
          summarySavingsEl.innerHTML = '-' + money(totalSavings);
          summarySavingsRowEl.hidden = false;
        } else {
          summarySavingsRowEl.hidden = true;
        }
      }
    }

    itemsEl.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var key = btn.getAttribute('data-key');
      var action = btn.getAttribute('data-action');
      var qty = Number(btn.getAttribute('data-qty') || 0);
      var updates = {};
      if ((action === 'remove' || action === 'decrease') && lastGiftKeys[key]) { setGiftDeclined(true); cscTrack('csc_gift_removed', lastCartCtx); }
      if (action === 'increase') updates[key] = qty + 1;
      else if (action === 'decrease') updates[key] = Math.max(0, qty - 1);
      else if (action === 'remove') updates[key] = 0;
      else if (action === 'remove-group') {
        var groupKeys = (btn.getAttribute('data-group-keys') || '').split(',').filter(Boolean);
        groupKeys.forEach(function (k) { updates[k] = 0; });
      } else if (action === 'switch-to-abo') {
        btn.disabled = true;
        var switchGroupKeys = (btn.getAttribute('data-group-keys') || '').split(',').filter(Boolean);
        var switchHandle = btn.getAttribute('data-handle');
        var switchRootVariantId = Number(btn.getAttribute('data-root-variant-id'));
        var switchRootQuantity = Number(btn.getAttribute('data-root-quantity')) || 1;
        await switchGroupToSubscription(switchGroupKeys, switchHandle, switchRootVariantId, switchRootQuantity);
        await render();
        return;
      } else if (action === 'switch-item-to-abo') {
        // Analog zu switch-to-abo, aber fuer eine einzelne Refill-Zeile statt eine Bundle-Gruppe:
        // kein Produkt-Tausch noetig (dieselbe Variante traegt den Plan direkt), nur entfernen +
        // mit selling_plan erneut hinzufuegen (Shopify erlaubt keinen Plan-Wechsel per
        // /cart/update.js auf einer bestehenden Zeile).
        btn.disabled = true;
        var itemVariantId = Number(btn.getAttribute('data-variant-id'));
        var itemQuantity = Number(btn.getAttribute('data-quantity')) || 1;
        var itemPlanId = Number(btn.getAttribute('data-plan-id'));
        var rmUpdates = {};
        rmUpdates[key] = 0;
        await updateCart(JSON.stringify({ updates: rmUpdates }));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: itemVariantId, quantity: itemQuantity, selling_plan: itemPlanId }] }),
        });
        await render();
        return;
      } else if (action === 'flex-upgrade') {
        var fuInfo = flexUpgradeByKey[key];
        if (!fuInfo) return;
        btn.disabled = true;
        var upOk = await applyFlexUpgrade(fuInfo);
        cscTrack('csc_plan_upgrade', Object.assign({ success: !!upOk, delta: fuInfo.delta / 100 }, lastCartCtx));
        queueFeedback(upOk ? (igIsEn() ? '⬆ Switched to 3-month supply · 100-day returns' : '⬆ Auf 3-Monats-Vorrat umgestellt · 100 Tage Rückgaberecht') : (igIsEn() ? 'Upgrade not possible right now – your set is unchanged' : 'Upgrade gerade nicht möglich – dein Set bleibt unverändert'), upOk ? [fuInfo.padVariantId] : []);
        await render();
        return;
      } else if (action === 'grown-upgrade') {
        // Grown-Zeile durch groesseren Vorrat ersetzen (gleiche Variante, neue Menge, ggf. neuer Plan)
        btn.disabled = true;
        var upVariantId = Number(btn.getAttribute('data-variant-id'));
        var upQty = Number(btn.getAttribute('data-quantity')) || 1;
        var upPlan = btn.getAttribute('data-plan-id');
        var upRm = {};
        upRm[key] = 0;
        await updateCart(JSON.stringify({ updates: upRm }));
        var upItem = { id: upVariantId, quantity: upQty };
        if (upPlan) upItem.selling_plan = Number(upPlan);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [upItem] }),
        });
        await render();
        return;
      } else if (action === 'switch-item-to-onetime') {
        // Gegenstueck zu switch-item-to-abo: Box ist jetzt eine einzige Toggle-Checkbox
        // (Christian-Wunsch), Abwaehlen soll die Zeile zurueck auf Einzelkauf stellen - entfernen +
        // ohne selling_plan erneut hinzufuegen.
        btn.disabled = true;
        var onetimeVariantId = Number(btn.getAttribute('data-variant-id'));
        var onetimeQuantity = Number(btn.getAttribute('data-quantity')) || 1;
        var onetimeRmUpdates = {};
        onetimeRmUpdates[key] = 0;
        await updateCart(JSON.stringify({ updates: onetimeRmUpdates }));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: onetimeVariantId, quantity: onetimeQuantity }] }),
        });
        await render();
        return;
      } else if (action === 'switch-set-to-abo' || action === 'switch-set-to-onetime') {
        // Kombinierter Abo-Umschalter fuer ein ganzes Refill-Bundle-Builder-Set (2026-09-16,
        // Christian-Wunsch: "genauso diesen Abonnieren & Sparen Streifen mit Checkmark ... mit
        // einem Klick zum Abo wechseln"). Analog zu switch-item-to-abo/-onetime, aber fuer ALLE
        // Artikel des Sets auf einmal statt fuer eine einzelne Zeile: aktuellen Stand jeder Zeile
        // live nachladen (Menge/Variante/Properties bleiben dabei automatisch erhalten, inkl.
        // bundle-Code + _bundle_instance), entfernen, dann mit (bzw. ohne) Selling-Plan erneut
        // hinzufuegen. Plan-ID wird pro Produkt ueber getBundleSetUpsellInfo() aufgeloest (Gruppe
        // "Set-Lieferung jeden Monat" - nicht dieselbe wie beim Einzelkauf-Abo, siehe dort).
        btn.disabled = true;
        var toAbo = action === 'switch-set-to-abo';
        var setGroupKeys2 = (btn.getAttribute('data-group-keys') || '').split(',').filter(Boolean);
        var liveCart = await fetchCart();
        var setGroupItems = liveCart.items.filter(function (i) { return setGroupKeys2.indexOf(i.key) !== -1; });

        var setRemoveUpdates = {};
        setGroupItems.forEach(function (i) { setRemoveUpdates[i.key] = 0; });
        await updateCart(JSON.stringify({ updates: setRemoveUpdates }));

        var setAddItems = [];
        for (var si = 0; si < setGroupItems.length; si++) {
          var setItem = setGroupItems[si];
          var setPayload = {
            id: setItem.variant_id,
            quantity: setItem.quantity,
            properties: setItem.properties || {},
          };
          if (toAbo) {
            var setPlanInfo = await getBundleSetUpsellInfo(setItem);
            if (setPlanInfo) setPayload.selling_plan = setPlanInfo.planId;
          }
          setAddItems.push(setPayload);
        }
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: setAddItems }),
        });
        await render();
        return;
      } else return;

      btn.disabled = true;
      await updateCart(JSON.stringify({ updates: updates }));
      await render();
    });

    // "+"-Klick auf der "🎁 Gratis Goodies"-Karte (Runde 13): bewusstes Beanspruchen des
    // Geschenks der aktuell angezeigten Stufe - legt EINE Einheit mit PROGRESS_GIFT_PROPERTY-
    // Markierung in den Cart (siehe progressGiftsMarkup/syncProgressGifts oben). Eigener Listener
    // auf progressEl statt itemsEl, da die Goodie-Karte dort gerendert wird (Event-Delegation,
    // ueberlebt das innerHTML-Ersetzen bei jedem render() wie auch beim itemsEl-Handler oben).
    async function onUpsellZoneClick(e) {
      // R7: ganze Upsell-Karte antippbar (nicht nur das 20-px-"+")
      if (!e.target.closest('[data-action]')) {
        var tapCard = e.target.closest('.csc-mini-card');
        var tapBtn = tapCard && tapCard.querySelector('.csc-mini-card__add:not(:disabled)');
        if (tapBtn) { tapBtn.click(); return; }
      }
      // 2026-10-23 grown-Karte: Umschalter D3/B (nur DOM, kein Re-Render), Hinzufuegen, Info-Sheet
      var pickBtn = e.target.closest('[data-action="grown-pick"]');
      if (pickBtn) {
        grownPick = pickBtn.getAttribute('data-pick') === 'b' ? 'b' : 'd3';
        var card = pickBtn.closest('[data-gwn]');
        if (card) {
          card.querySelectorAll('.csc-gwn__chip').forEach(function (c) { c.classList.toggle('is-active', c === pickBtn); });
          card.querySelectorAll('.csc-gwn__pane').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pane') === grownPick); });
        }
        return;
      }
      var grownAddBtn = e.target.closest('[data-action="add-grown"]');
      if (grownAddBtn) {
        grownAddBtn.disabled = true;
        markAdded(grownAddBtn, 'Hinzugefügt ✓');
        await addGrownUpsell(GROWN_UPSELL_PRODUCTS[grownPick].variantId, 'cart');
        return;
      }
      if (e.target.closest('[data-action="grown-info"]')) {
        cscTrack('csc_grown_info_open', lastCartCtx);
        openGrownSheet();
        return;
      }

      var claimBtn = e.target.closest('[data-action="claim-gift"]');
      if (claimBtn) {
        setGiftDeclined(false);
        claimBtn.disabled = true;
        var giftVariantId = Number(claimBtn.getAttribute('data-variant-id'));
        var tierAmount = claimBtn.getAttribute('data-tier-amount');
        var giftProps = {};
        giftProps[PROGRESS_GIFT_PROPERTY] = tierAmount;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1, properties: giftProps }] }),
        });
        await render();
        return;
      }

      // "+"-Klick auf einer Mini-Probierpackungs-Karte (Runde 17): normaler Add-to-Cart (keine
      // Sonder-Property) - Shopify erhoeht bei bereits vorhandener identischer Variante automatisch
      // nur die Menge der bestehenden Zeile.
      var miniBtn = e.target.closest('[data-action="add-mini"]');
      if (miniBtn) {
        miniBtn.disabled = true;
        markAdded(miniBtn);
        cscTrack('csc_upsell_add', Object.assign({ upsell_type: 'mini', variant_id: Number(miniBtn.getAttribute('data-variant-id')) }, lastCartCtx));
        queueFeedback(igIsEn() ? '✓ Sampler added' : '✓ Probierpackung hinzugefügt', [Number(miniBtn.getAttribute('data-variant-id'))]);
        var miniVariantId = Number(miniBtn.getAttribute('data-variant-id'));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // Runde 43 (2026-10-05): unsichtbare Property zur Messung, wie viele Probierpackungen
          // ueber die Cart-Leiste kommen (Underscore = nicht im Checkout/in Mails sichtbar).
          body: JSON.stringify({ items: [{ id: miniVariantId, quantity: 1, properties: { _mini_upsell: 'cart' } }] }),
        });
        await render();
        return;
      }

      // "+"-Klick auf einer Zubehoer-Karte (Dochte, 2026-10-15): normaler Add-to-Cart mit eigener
      // unsichtbarer Mess-Property (analog _mini_upsell).
      var accessoryBtn = e.target.closest('[data-action="add-accessory"]');
      if (accessoryBtn) {
        accessoryBtn.disabled = true;
        markAdded(accessoryBtn);
        cscTrack('csc_upsell_add', Object.assign({ upsell_type: 'accessory', variant_id: Number(accessoryBtn.getAttribute('data-variant-id')) }, lastCartCtx));
        queueFeedback(igIsEn() ? '✓ Added' : '✓ Hinzugefügt', [Number(accessoryBtn.getAttribute('data-variant-id'))]);
        var accessoryVariantId = Number(accessoryBtn.getAttribute('data-variant-id'));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: accessoryVariantId, quantity: 1, properties: { _accessory_upsell: 'cart' } }] }),
        });
        await render();
        return;
      }

      // "+"-Klick auf einer Bestseller-Sorten-Karte (Runde 24): Property BESTSELLER_UPSELL_PROPERTY
      // markiert die Zeile nur fuer die Abo-Hinweis-Unterdrueckung (siehe itemUpsellInfo-Aufbau in
      // render()) - der Cart-Rabatt (BESTSELLER_PURE/BESTSELLER_MIX) greift unabhaengig davon
      // variantenbasiert ueber syncBestsellerDiscount().
      var bestsellerBtn = e.target.closest('[data-action="add-bestseller"]');
      if (bestsellerBtn) {
        bestsellerBtn.disabled = true;
        markAdded(bestsellerBtn);
        cscTrack('csc_upsell_add', Object.assign({ upsell_type: 'bestseller', variant_id: Number(bestsellerBtn.getAttribute('data-variant-id')) }, lastCartCtx));
        queueFeedback(igIsEn() ? '✓ Bestseller added' : '✓ Bestseller-Sorte hinzugefügt', [Number(bestsellerBtn.getAttribute('data-variant-id'))]);
        var bestsellerVariantId = Number(bestsellerBtn.getAttribute('data-variant-id'));
        var bestsellerProps = {};
        bestsellerProps[BESTSELLER_UPSELL_PROPERTY] = '1';
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: bestsellerVariantId, quantity: 1, properties: bestsellerProps }] }),
        });
        await render();
      }
    }
    progressEl.addEventListener('click', onUpsellZoneClick);
    upsellEl.addEventListener('click', onUpsellZoneClick);

    // Rabattcode-Formular: auf-/zuklappbar, aehnlich dem wearewild-Referenz-Design. Anwenden/
    // Entfernen laeuft ueber /cart/update.js mit dem "discount"-Feld (Shopifys native
    // AJAX-Rabattcode-Unterstuetzung) - keine Checkout-Weiterleitung noetig.
    discountToggle.addEventListener('click', function () {
      var expanded = discountToggle.getAttribute('aria-expanded') === 'true';
      discountToggle.setAttribute('aria-expanded', String(!expanded));
      discountForm.hidden = expanded;
      if (!expanded) discountInput.focus();
    });

    async function applyDiscountCodes(codes) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') }),
      });
      await render();
    }

    discountApplyBtn.addEventListener('click', async function () {
      var code = discountInput.value.trim();
      if (!code) return;
      var cart = await fetchCart();
      var existing = (cart.discount_codes || []).map(function (dc) { return dc.code; });
      if (existing.indexOf(code) === -1) existing.push(code);
      discountApplyBtn.disabled = true;
      await applyDiscountCodes(existing);
      discountApplyBtn.disabled = false;
      discountInput.value = '';
    });

    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        discountApplyBtn.click();
      }
    });

    discountsEl.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-remove-code]');
      if (!btn) return;
      var codeToRemove = btn.getAttribute('data-remove-code');
      var cart = await fetchCart();
      var remaining = (cart.discount_codes || [])
        .map(function (dc) { return dc.code; })
        .filter(function (c) { return c !== codeToRemove; });
      await applyDiscountCodes(remaining);
    });

    root.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') close();
    });

    // Runde 34 (Cutover): window.CSC_CART ist jetzt der einzige Cart-Oeffnen-Weg fuer echte
    // Kunden (siehe pre-cart-upsell.js proceedToRealCart()) - der bisherige Dev-Test-Button
    // ("🧪 Native Cart (Phase 2)") ist damit obsolet und wurde entfernt.
    if (checkoutLinkEl) checkoutLinkEl.addEventListener('click', function () {
      cscTrack('csc_checkout_click', lastCartCtx);
      cscHistoryPushed = false; // Seitenwechsel, kein history.back()
    });
    window.CSC_CART = { open: open, close: close, refresh: render };

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();